import _ from "lodash";

export const historicalDeviceLoading  = true;

export const getLog = {"Records":[{"feed_id":2,"devicename":"CG_IoT_Demo","asset_id":"DEMO_WELL","sub_asset_id":"DEMO_WELL","logid":"CG_Demo","feed_type":"CSV","device_id":"yellowhammer","dfbit":0,"server_address":"","source_address":"","active":"N","archive_status":"N","isSecure":false,"username":"","startTime":"1661438936930","endTime":"1696059384352","password":"","socketid":"null","created_user_profile":"SOURCE","adaptorConfig":"{\"issLiveStreaming\":false,\"tsChannelName\":\"\",\"freq\":\"1\",\"device_type\":\"TIMESERIES\",\"sourceFile\":\"/home/sigmastream/sample-data-with-torque-value.csv\",\"csvStreamDataCount\":\"\",\"startIndex\":\"2022-08-25T14:54:04.955Z\",\"endIndex\":\"\",\"streamLoopingEvents\":\"False\",\"deviceGapIntervalMinute\":\"\",\"indexMnemonic\":\"timestamp\",\"loopingEnable\":\"True\",\"deepSleepTime\":\"60000\",\"monitorDataFile\":\"False\",\"isDeviceThresholdbackfillEnable\":false,\"sparseDataStreaming\":\"True\",\"speedupFactor\":\"\",\"devicePerformReportingEnable\":false,\"skipOverlap\":\"True\",\"csvMonitorTimeInterval\":\"5000\",\"isDeviceBackfillEnable\":false,\"deviceThresholdAutoBackFIllInterval\":\"\",\"isDeviceAutoRestoreEnable\":false,\"deviceThresholdAutoRecoveryInterval\":\"\",\"devicePerformReportingInterval\":\"5\"}","data_type":"RAW","frequency":1.0,"created_on":"Aug 25, 2022 2:48:56 PM","updated_on":"Sep 30, 2023 7:36:24 AM","lazyLoading":true,"manufacturer":"","device_type":"TIMESERIES","indexMnemonic":"timestamp","model_number":"","serial_number":"","channels":[],"recordCount":"0","nullValues":[],"timezone":"Etc/UTC","dstEnable":false,"metadata":{},"nodeInfo":""},{"feed_id":7,"devicename":"DQDQ_DQ_CG_Demo","asset_id":"DQDQ","sub_asset_id":"DQ","logid":"CG_Demo","feed_type":"CSV","device_id":"yellowhammer","dfbit":0,"server_address":"null","source_address":"null","active":"N","archive_status":"Y","isSecure":false,"username":"null","startTime":"1690608406712","endTime":"1690615768371","password":"null","socketid":"null","created_user_profile":"SOURCE","adaptorConfig":"{\"issLiveStreaming\":false,\"tsChannelName\":\"\",\"freq\":\"1\",\"device_type\":\"TIMESERIES\",\"sourceFile\":\"/home/sigmastream/sample-data-with-torque-value.csv\",\"csvStreamDataCount\":\"\",\"startIndex\":\"2022-08-25T14:54:04.955Z\",\"endIndex\":\"\",\"streamLoopingEvents\":\"False\",\"deviceGapIntervalMinute\":\"\",\"indexMnemonic\":\"timestamp\",\"loopingEnable\":\"True\",\"deepSleepTime\":\"60000\",\"monitorDataFile\":\"False\",\"isDeviceThresholdbackfillEnable\":false,\"sparseDataStreaming\":\"True\",\"speedupFactor\":\"\",\"devicePerformReportingEnable\":false,\"skipOverlap\":\"True\",\"csvMonitorTimeInterval\":\"5000\",\"isDeviceBackfillEnable\":false,\"deviceThresholdAutoBackFIllInterval\":\"\",\"isDeviceAutoRestoreEnable\":false,\"deviceThresholdAutoRecoveryInterval\":\"\",\"devicePerformReportingInterval\":\"5\"}","data_type":"RAW","frequency":1.0,"created_on":"Jul 29, 2023 5:26:46 AM","updated_on":"Jul 29, 2023 7:29:28 AM","lazyLoading":true,"manufacturer":"","device_type":"TIMESERIES","indexMnemonic":"timestamp","model_number":"","serial_number":"","channels":[],"recordCount":"0","nullValues":[],"timezone":"Etc/UTC","dstEnable":false,"metadata":{}},{"feed_id":8,"devicename":"DQDQ_DQ_dsdsds","asset_id":"DQDQ","sub_asset_id":"DQ","logid":"dsdsds","feed_type":"WSocket","device_id":"yellowhammer-in","dfbit":0,"server_address":"null","source_address":"null","active":"N","archive_status":"Y","isSecure":false,"username":"null","startTime":"1690608406820","endTime":"1690615801132","password":"null","socketid":"null","created_user_profile":"SOURCE","adaptorConfig":"{\"isDeviceOffsetEnable\":false,\"issLiveStreaming\":false,\"remoteIP\":\"192.168.2.104\",\"deviceOffsetThreshold\":\"\",\"discoveryinterval\":\"60000\",\"timeout\":\"60000\",\"issResumeStreaming\":false,\"startIndex\":\"2023-07-26T11:52:00.208Z\",\"timeStampChannelMN\":\"DATETIME\",\"payloadType\":\"CSVSPARSE\",\"endIndex\":\"\",\"deviceGapIntervalMinute\":\"60\",\"deviceOffset\":\"\",\"startTime\":\"\",\"indexMnemonic\":\"timestamp\",\"deviceType\":{\"DATA-PUSH\":\"false\",\"CSV\":\"false\",\"WITS\":\"false\",\"WSOCKET\":\"false\",\"MONGODB\":\"false\",\"WITSML\":\"false\"},\"apikey\":\"eWVsbG93aGFtbWVyLnNpZ21hc3RyZWFt\",\"dataType\":{\"SIMULATED\":\"false\",\"RAW\":\"false\",\"PROCESSED\":\"false\"},\"deepSleepTime\":\"\",\"reconnectInterval\":\"60000\",\"isDeviceThresholdbackfillEnable\":false,\"sourceLogName\":\"CG_Demo\",\"backfillPollInterval\":\"1\",\"schemes\":\"wss://\",\"dataFlowMode\":\"Normal\",\"backfillingEnabled\":\"false\",\"backfillBatchSize\":\"100\",\"speedupFactor\":\"\",\"modeType\":\"Live\",\"dataQuality\":{\"Standpipe Pressure 2\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":true,\"aswiEnable\":true,\"aswiDuration\":360000.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000.0,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000.0,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}}},\"devicePerformReportingEnable\":false,\"port\":\"8443\",\"assetid\":\"DQDQ\",\"isDeviceBackfillEnable\":false,\"deviceThresholdAutoBackFIllInterval\":\"120\",\"autoConfigEnable\":\"true\",\"isDeviceAutoRestoreEnable\":false,\"deviceThresholdAutoRecoveryInterval\":\"\",\"deviceRestoreRetry\":\"\",\"endTime\":\"\",\"subassetID\":\"DQ\",\"devicePerformReportingInterval\":\"5\",\"sourceIDs\":[\"7\"],\"username\":\"yellowhammer\",\"deviceThresholdAutoBackFIllMergeInterval\":\"120\"}","data_type":"SIMULATED","frequency":1.0,"created_on":"Jul 29, 2023 5:26:46 AM","updated_on":"Jul 29, 2023 7:30:01 AM","lazyLoading":true,"manufacturer":"","device_type":"TIMESERIES","indexMnemonic":"timestamp","model_number":"","serial_number":"","channels":[],"recordCount":"0","nullValues":[],"timezone":"Etc/UTC","dstEnable":false,"metadata":{}},{"feed_id":9,"devicename":"DEMO_CSV_DEMO_CSV_CG_Demo","asset_id":"DEMO_CSV","sub_asset_id":"DEMO_CSV","logid":"CG_Demo","feed_type":"CSV","device_id":"yellowhammer","dfbit":0,"server_address":"null","source_address":"null","active":"N","archive_status":"Y","isSecure":false,"username":"null","startTime":"1690611996848","endTime":"1699451466300","password":"null","socketid":"null","created_user_profile":"SOURCE","adaptorConfig":"{\"issLiveStreaming\":false,\"tsChannelName\":\"\",\"freq\":\"1\",\"device_type\":\"TIMESERIES\",\"sourceFile\":\"/home/sigmastream/sample-data-with-torque-value.csv\",\"csvStreamDataCount\":\"\",\"startIndex\":\"2022-08-25T14:54:04.955Z\",\"endIndex\":\"\",\"streamLoopingEvents\":\"False\",\"deviceGapIntervalMinute\":\"\",\"indexMnemonic\":\"timestamp\",\"loopingEnable\":\"True\",\"deepSleepTime\":\"60000\",\"monitorDataFile\":\"False\",\"isDeviceThresholdbackfillEnable\":false,\"sparseDataStreaming\":\"True\",\"speedupFactor\":\"\",\"devicePerformReportingEnable\":false,\"skipOverlap\":\"True\",\"csvMonitorTimeInterval\":\"5000\",\"isDeviceBackfillEnable\":false,\"deviceThresholdAutoBackFIllInterval\":\"\",\"isDeviceAutoRestoreEnable\":false,\"deviceThresholdAutoRecoveryInterval\":\"\",\"devicePerformReportingInterval\":\"5\"}","data_type":"RAW","frequency":1.0,"created_on":"Jul 29, 2023 6:26:36 AM","updated_on":"Nov 8, 2023 1:51:06 PM","lazyLoading":true,"manufacturer":"","device_type":"TIMESERIES","indexMnemonic":"timestamp","model_number":"","serial_number":"","channels":[],"recordCount":"0","nullValues":[],"timezone":"Etc/UTC","dstEnable":false,"metadata":{},"nodeInfo":""},{"feed_id":10,"devicename":"DQ2_DQ2_CG_Demo","asset_id":"DQ2","sub_asset_id":"DQ2","logid":"CG_Demo","feed_type":"CSV","device_id":"yellowhammer","dfbit":0,"server_address":"null","source_address":"null","active":"N","archive_status":"Y","isSecure":false,"username":"null","startTime":"1691744016965","endTime":"1693288877998","password":"null","socketid":"null","created_user_profile":"SOURCE","adaptorConfig":"{\"issLiveStreaming\":false,\"tsChannelName\":\"\",\"freq\":\"1\",\"device_type\":\"TIMESERIES\",\"sourceFile\":\"/home/sigmastream/sample-data-with-torque-value.csv\",\"csvStreamDataCount\":\"\",\"startIndex\":\"2022-08-25T14:54:04.955Z\",\"endIndex\":\"\",\"streamLoopingEvents\":\"False\",\"deviceGapIntervalMinute\":\"\",\"indexMnemonic\":\"timestamp\",\"loopingEnable\":\"True\",\"deepSleepTime\":\"60000\",\"monitorDataFile\":\"False\",\"isDeviceThresholdbackfillEnable\":false,\"sparseDataStreaming\":\"True\",\"speedupFactor\":\"\",\"devicePerformReportingEnable\":false,\"skipOverlap\":\"True\",\"csvMonitorTimeInterval\":\"5000\",\"isDeviceBackfillEnable\":false,\"deviceThresholdAutoBackFIllInterval\":\"\",\"isDeviceAutoRestoreEnable\":false,\"deviceThresholdAutoRecoveryInterval\":\"\",\"devicePerformReportingInterval\":\"5\"}","data_type":"RAW","frequency":1.0,"created_on":"Aug 11, 2023 8:53:36 AM","updated_on":"Aug 29, 2023 6:01:17 AM","lazyLoading":true,"manufacturer":"","device_type":"TIMESERIES","indexMnemonic":"timestamp","model_number":"","serial_number":"","channels":[],"recordCount":"0","nullValues":[],"timezone":"Etc/UTC","dstEnable":false,"metadata":{},"nodeInfo":""},{"feed_id":11,"devicename":"DQ2_DQ2_dsdsds","asset_id":"DQ2","sub_asset_id":"DQ2","logid":"dsdsds","feed_type":"WSocket","device_id":"yellowhammer-in","dfbit":0,"server_address":"null","source_address":"null","active":"N","archive_status":"Y","isSecure":false,"username":"null","startTime":"1691744017152","endTime":"1693288838553","password":"null","socketid":"null","created_user_profile":"SOURCE","adaptorConfig":"{\"isDeviceOffsetEnable\":false,\"issLiveStreaming\":false,\"remoteIP\":\"192.168.2.104\",\"deviceOffsetThreshold\":\"\",\"discoveryinterval\":\"60000\",\"timeout\":\"60000\",\"issResumeStreaming\":false,\"startIndex\":\"2023-08-11T08:58:48.592Z\",\"timeStampChannelMN\":\"DATETIME\",\"payloadType\":\"CSVSPARSE\",\"endIndex\":\"\",\"deviceGapIntervalMinute\":\"60\",\"deviceOffset\":\"\",\"startTime\":\"\",\"indexMnemonic\":\"timestamp\",\"deviceType\":{\"DATA-PUSH\":\"false\",\"CSV\":\"false\",\"WITS\":\"false\",\"WSOCKET\":\"false\",\"MONGODB\":\"false\",\"WITSML\":\"false\"},\"apikey\":\"eWVsbG93aGFtbWVyLnNpZ21hc3RyZWFt\",\"dataType\":{\"SIMULATED\":\"false\",\"RAW\":\"false\",\"PROCESSED\":\"false\"},\"deepSleepTime\":\"\",\"reconnectInterval\":\"60000\",\"isDeviceThresholdbackfillEnable\":false,\"sourceLogName\":\"CG_Demo\",\"backfillPollInterval\":\"1\",\"schemes\":\"wss://\",\"dataFlowMode\":\"Normal\",\"backfillingEnabled\":\"false\",\"backfillBatchSize\":\"100\",\"speedupFactor\":\"\",\"modeType\":\"Live\",\"dataQuality\":{\"Standpipe Pressure 2\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":true,\"aswiEnable\":true,\"aswiDuration\":360000.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000.0,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000.0,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"CG_Demo_Standpipe Pressure 1\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":3600000.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000.0,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":300000.0,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.5\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"CG_Demo_Standpipe Pressure 2\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":3600000.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000.0,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":300000.0,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}}},\"devicePerformReportingEnable\":false,\"port\":\"8443\",\"assetid\":\"DQ2\",\"isDeviceBackfillEnable\":false,\"deviceThresholdAutoBackFIllInterval\":\"120\",\"autoConfigEnable\":\"true\",\"isDeviceAutoRestoreEnable\":false,\"deviceThresholdAutoRecoveryInterval\":\"\",\"deviceRestoreRetry\":\"\",\"endTime\":\"\",\"subassetID\":\"DQ2\",\"devicePerformReportingInterval\":\"5\",\"sourceIDs\":[\"10\"],\"username\":\"yellowhammer\",\"deviceThresholdAutoBackFIllMergeInterval\":\"120\"}","data_type":"SIMULATED","frequency":1.0,"created_on":"Aug 11, 2023 8:53:37 AM","updated_on":"Aug 29, 2023 6:00:38 AM","lazyLoading":true,"manufacturer":"","device_type":"TIMESERIES","indexMnemonic":"timestamp","model_number":"","serial_number":"","channels":[],"recordCount":"0","nullValues":[],"timezone":"Etc/UTC","dstEnable":false,"metadata":{},"nodeInfo":""},{"feed_id":13,"devicename":"DEPTH_DEVICE_1","asset_id":"DQAdvance","sub_asset_id":"DQAdvance","logid":"DEPTH_SURFACE","feed_type":"CSV","device_id":"yellowhammer","dfbit":0,"server_address":"","source_address":"","active":"N","archive_status":"N","isSecure":false,"username":"","startTime":"1692339879612","endTime":"1699451467407","password":"","socketid":"null","created_user_profile":"SOURCE","adaptorConfig":"{\"isDeviceOffsetEnable\":false,\"issLiveStreaming\":false,\"deviceOffsetThreshold\":\"\",\"tsChannelName\":\"\",\"freq\":\"1\",\"device_type\":\"DEPTHSERIES\",\"sourceFile\":\"/home/sigmastream/sample-data-with-torque-value.csv\",\"csvStreamDataCount\":\"\",\"issResumeStreaming\":false,\"startIndex\":\"2023-08-18T05:55:25.861Z\",\"endIndex\":\"\",\"streamLoopingEvents\":\"False\",\"deviceGapIntervalMinute\":\"60\",\"deviceOffset\":\"\",\"indexMnemonic\":\"Hole Depth\",\"loopingEnable\":\"False\",\"deepSleepTime\":\"60000\",\"monitorDataFile\":\"False\",\"isDeviceThresholdbackfillEnable\":false,\"backfillPollInterval\":\"1\",\"sparseDataStreaming\":\"True\",\"backfillBatchSize\":\"100\",\"speedupFactor\":\"\",\"devicePerformReportingEnable\":false,\"skipOverlap\":\"True\",\"csvMonitorTimeInterval\":\"5000\",\"isDeviceBackfillEnable\":false,\"deviceThresholdAutoBackFIllInterval\":\"120\",\"isDeviceAutoRestoreEnable\":false,\"deviceThresholdAutoRecoveryInterval\":\"\",\"deviceRestoreRetry\":\"\",\"devicePerformReportingInterval\":\"5\",\"deviceThresholdAutoBackFIllMergeInterval\":\"120\",\"dataQuality\":{\"hooks\":{\"name\":\"hooks\",\"status\":\"enable\",\"slideBy\":\"45\",\"windowLength\":\"546\",\"indexes\":[\"aswi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"10\",\"deltaValue\":10,\"weightage\":\"100\",\"ttThreshold\":\"200000\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"42\",\"weightage\":\"42\",\"ttThreshold\":\"01\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"23\",\"weightage\":\"32\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"23\",\"deltaValue\":60,\"ttThreshold\":\"32\",\"weightage\":\"23965\"},{\"name\":\"latency\",\"status\":\"enable\",\"expectedValue\":\"653\",\"deltaValue\":60,\"ttThreshold\":\"32\",\"weightage\":\"8000\"},{\"name\":\"minValue\",\"status\":\"enable\",\"expectedValue\":\"452\",\"deltaValue\":2,\"ttThreshold\":\"53\",\"weightage\":\"50000\"},{\"name\":\"staleValue\",\"status\":\"enable\",\"ttThreshold\":\"7525\",\"weightage\":\"323655\"},{\"name\":\"maxValue\",\"status\":\"disabled\",\"expectedValue\":\"4533\",\"weightage\":\"33\",\"ttThreshold\":\"53432\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"hook1\":{\"name\":\"hook1\",\"status\":\"enable\",\"slideBy\":\"86\",\"windowLength\":\"652\",\"indexes\":[\"aswi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"65\",\"deltaValue\":10,\"weightage\":\"456\",\"ttThreshold\":\"466\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"6\",\"weightage\":\"4\",\"ttThreshold\":\"64\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"4\",\"weightage\":\"6\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"64\",\"deltaValue\":60,\"ttThreshold\":\"6\",\"weightage\":\"46\"},{\"name\":\"latency\",\"status\":\"disabled\",\"expectedValue\":\"6\",\"deltaValue\":60,\"ttThreshold\":\"4\",\"weightage\":\"6\"},{\"name\":\"minValue\",\"status\":\"disabled\",\"expectedValue\":\"6\",\"deltaValue\":2,\"ttThreshold\":\"46\",\"weightage\":\"4\"},{\"name\":\"staleValue\",\"status\":\"enable\",\"ttThreshold\":\"46\",\"weightage\":\"46\"},{\"name\":\"maxValue\",\"status\":\"enable\",\"expectedValue\":\"646\",\"weightage\":\"464\",\"ttThreshold\":\"4646\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"depth\":{\"name\":\"depth\",\"status\":\"enable\",\"slideBy\":\"9865\",\"windowLength\":\"9654\",\"indexes\":[\"aswi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"456\",\"deltaValue\":10,\"weightage\":\"456\",\"ttThreshold\":\"45\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"6546\",\"weightage\":\"46\",\"ttThreshold\":\"46\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"6\",\"weightage\":\"46\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"46\",\"deltaValue\":60,\"ttThreshold\":\"4\",\"weightage\":\"6\"},{\"name\":\"latency\",\"status\":\"disabled\",\"expectedValue\":\"6\",\"deltaValue\":60,\"ttThreshold\":\"46\",\"weightage\":\"4\"},{\"name\":\"minValue\",\"status\":\"disabled\",\"expectedValue\":\"4\",\"deltaValue\":2,\"ttThreshold\":\"64\",\"weightage\":\"6\"},{\"name\":\"staleValue\",\"status\":\"enable\",\"ttThreshold\":\"6\",\"weightage\":\"46\"},{\"name\":\"maxValue\",\"status\":\"disabled\",\"expectedValue\":\"6\",\"weightage\":\"4\",\"ttThreshold\":\"6\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"jh\":{\"name\":\"jh\",\"status\":\"disabled\",\"slideBy\":\"896\",\"windowLength\":\"456\",\"indexes\":[\"aswi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"645\",\"deltaValue\":10,\"weightage\":\"654\",\"ttThreshold\":\"654\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"654\",\"weightage\":\"654\",\"ttThreshold\":\"654\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"654\",\"weightage\":\"654\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"65\",\"deltaValue\":60,\"ttThreshold\":\"654\",\"weightage\":\"645\"},{\"name\":\"latency\",\"status\":\"disabled\",\"expectedValue\":\"654\",\"deltaValue\":60,\"ttThreshold\":\"654\",\"weightage\":\"654\"},{\"name\":\"minValue\",\"status\":\"disabled\",\"expectedValue\":\"65\",\"deltaValue\":2,\"ttThreshold\":\"654\",\"weightage\":\"65\"},{\"name\":\"staleValue\",\"status\":\"disabled\",\"ttThreshold\":\"6546\",\"weightage\":\"5\"},{\"name\":\"maxValue\",\"status\":\"disabled\",\"expectedValue\":\"546\",\"weightage\":\"65456\",\"ttThreshold\":\"654\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"mouse\":{\"name\":\"mouse\",\"status\":\"enable\",\"slideBy\":\"64565\",\"windowLength\":\"654\",\"indexes\":[\"aswi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"enable\",\"expectedValue\":\"4564\",\"deltaValue\":10,\"weightage\":\"646\",\"ttThreshold\":\"6\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"65\",\"weightage\":\"6\",\"ttThreshold\":\"46\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"6\",\"weightage\":\"46\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"64\",\"deltaValue\":60,\"ttThreshold\":\"6\",\"weightage\":\"46\"},{\"name\":\"latency\",\"status\":\"disabled\",\"expectedValue\":\"64\",\"deltaValue\":60,\"ttThreshold\":\"6\",\"weightage\":\"4\"},{\"name\":\"minValue\",\"status\":\"disabled\",\"expectedValue\":\"46\",\"deltaValue\":2,\"ttThreshold\":\"54\",\"weightage\":\"64\"},{\"name\":\"staleValue\",\"status\":\"enable\",\"ttThreshold\":\"6\",\"weightage\":\"46\"},{\"name\":\"maxValue\",\"status\":\"disabled\",\"expectedValue\":\"6\",\"weightage\":\"446\",\"ttThreshold\":\"4646\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"mains\":{\"name\":\"mains\",\"status\":\"enable\",\"slideBy\":\"46\",\"windowLength\":\"645\",\"indexes\":[\"aswi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"46545\",\"deltaValue\":10,\"weightage\":\"45\",\"ttThreshold\":\"45\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"45\",\"weightage\":\"45\",\"ttThreshold\":\"456\"},{\"name\":\"dataGap\",\"status\":\"enable\",\"expectedValue\":\"456\",\"weightage\":\"456\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"456\",\"deltaValue\":60,\"ttThreshold\":\"546\",\"weightage\":\"645\"},{\"name\":\"latency\",\"status\":\"disabled\",\"expectedValue\":\"546\",\"deltaValue\":60,\"ttThreshold\":\"546456\",\"weightage\":\"546\"},{\"name\":\"minValue\",\"status\":\"disabled\",\"expectedValue\":\"456\",\"deltaValue\":2,\"ttThreshold\":\"456\",\"weightage\":\"456\"},{\"name\":\"staleValue\",\"status\":\"disabled\",\"ttThreshold\":\"456\",\"weightage\":\"456\"},{\"name\":\"maxValue\",\"status\":\"disabled\",\"expectedValue\":\"456\",\"weightage\":\"45\",\"ttThreshold\":\"45\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"lock\":{\"name\":\"lock\",\"status\":\"disabled\",\"slideBy\":\"6666666\",\"windowLength\":\"56\",\"indexes\":[\"aswi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"56465\",\"deltaValue\":10,\"weightage\":\"56\",\"ttThreshold\":\"6654\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"6\",\"weightage\":\"4\",\"ttThreshold\":\"65\"},{\"name\":\"dataGap\",\"status\":\"enable\",\"expectedValue\":\"56\",\"weightage\":\"4\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"6\",\"deltaValue\":60,\"ttThreshold\":\"46\",\"weightage\":\"4\"},{\"name\":\"latency\",\"status\":\"disabled\",\"expectedValue\":\"6\",\"deltaValue\":60,\"ttThreshold\":\"46\",\"weightage\":\"46\"},{\"name\":\"minValue\",\"status\":\"disabled\",\"expectedValue\":\"465\",\"deltaValue\":2,\"ttThreshold\":\"4\",\"weightage\":\"6\"},{\"name\":\"staleValue\",\"status\":\"disabled\",\"ttThreshold\":\"65\",\"weightage\":\"4\"},{\"name\":\"maxValue\",\"status\":\"disabled\",\"expectedValue\":\"64\",\"weightage\":\"6\",\"ttThreshold\":\"46\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"bit depth\":{\"name\":\"bit depth\",\"status\":\"enable\",\"slideBy\":\"45646\",\"windowLength\":\"56464\",\"indexes\":[\"dqi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"656\",\"deltaValue\":10,\"weightage\":\"56\",\"ttThreshold\":\"5\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"56\",\"weightage\":\"56\",\"ttThreshold\":\"56\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"56\",\"weightage\":\"56\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"56\",\"deltaValue\":60,\"ttThreshold\":\"56\",\"weightage\":\"56\"},{\"name\":\"latency\",\"status\":\"enable\",\"expectedValue\":\"65\",\"deltaValue\":60,\"ttThreshold\":\"6\",\"weightage\":\"56\"},{\"name\":\"minValue\",\"status\":\"enable\",\"expectedValue\":\"56\",\"deltaValue\":2,\"ttThreshold\":\"56\",\"weightage\":\"56\"},{\"name\":\"staleValue\",\"status\":\"disabled\",\"ttThreshold\":\"65\",\"weightage\":\"65\"},{\"name\":\"maxValue\",\"status\":\"disabled\",\"expectedValue\":\"56\",\"weightage\":\"56\",\"ttThreshold\":\"565\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"MOV\":{\"name\":\"MOV\",\"status\":\"enable\",\"slideBy\":\"546465\",\"windowLength\":\"4656\",\"indexes\":[\"dqi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"45564\",\"deltaValue\":10,\"weightage\":\"456\",\"ttThreshold\":\"4\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"4\",\"weightage\":\"56\",\"ttThreshold\":\"46\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"46\",\"weightage\":\"5\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"56\",\"deltaValue\":60,\"ttThreshold\":\"4\",\"weightage\":\"64\"},{\"name\":\"latency\",\"status\":\"enable\",\"expectedValue\":\"564\",\"deltaValue\":60,\"ttThreshold\":\"56\",\"weightage\":\"46\"},{\"name\":\"minValue\",\"status\":\"enable\",\"expectedValue\":\"56\",\"deltaValue\":2,\"ttThreshold\":\"4\",\"weightage\":\"564\"},{\"name\":\"staleValue\",\"status\":\"disabled\",\"ttThreshold\":\"564\",\"weightage\":\"56\"},{\"name\":\"maxValue\",\"status\":\"disabled\",\"expectedValue\":\"56\",\"weightage\":\"456\",\"ttThreshold\":\"4\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"gfhgf\":{\"name\":\"gfhgf\",\"status\":\"enable\",\"slideBy\":\"65\",\"windowLength\":\"645562\",\"indexes\":[\"aswi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"5645\",\"deltaValue\":10,\"weightage\":\"6546\",\"ttThreshold\":\"465\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"546\",\"weightage\":\"546\",\"ttThreshold\":\"546\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"546\",\"weightage\":\"546\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"546\",\"deltaValue\":60,\"ttThreshold\":\"546\",\"weightage\":\"546\"},{\"name\":\"latency\",\"status\":\"disabled\",\"expectedValue\":\"546\",\"deltaValue\":60,\"ttThreshold\":\"546\",\"weightage\":\"54\"},{\"name\":\"minValue\",\"status\":\"disabled\",\"expectedValue\":\"54\",\"deltaValue\":2,\"ttThreshold\":\"65\",\"weightage\":\"4\"},{\"name\":\"staleValue\",\"status\":\"enable\",\"ttThreshold\":\"65465\",\"weightage\":\"546\"},{\"name\":\"maxValue\",\"status\":\"enable\",\"expectedValue\":\"4\",\"weightage\":\"5454\",\"ttThreshold\":\"546\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"mike\":{\"name\":\"mike\",\"status\":\"disabled\",\"slideBy\":\"65656\",\"windowLength\":\"5646\",\"indexes\":[\"aswi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"1\",\"deltaValue\":10,\"weightage\":\"2\",\"ttThreshold\":\"0\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"545\",\"weightage\":\"45\",\"ttThreshold\":\"4\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"65\",\"weightage\":\"46\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"4\",\"deltaValue\":60,\"ttThreshold\":\"64\",\"weightage\":\"65\"},{\"name\":\"latency\",\"status\":\"disabled\",\"expectedValue\":\"464\",\"deltaValue\":60,\"ttThreshold\":\"6\",\"weightage\":\"465\"},{\"name\":\"minValue\",\"status\":\"enable\",\"expectedValue\":\"64\",\"deltaValue\":2,\"ttThreshold\":\"6\",\"weightage\":\"4\"},{\"name\":\"staleValue\",\"status\":\"enable\",\"ttThreshold\":\"4\",\"weightage\":\"64\"},{\"name\":\"maxValue\",\"status\":\"disabled\",\"expectedValue\":\"65\",\"weightage\":\"4564\",\"ttThreshold\":\"645646\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"web\":{\"name\":\"web\",\"status\":\"enable\",\"slideBy\":\"4564\",\"windowLength\":\"4654\",\"indexes\":[\"aswi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"45646\",\"deltaValue\":10,\"weightage\":\"456\",\"ttThreshold\":\"4\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"65\",\"weightage\":\"456\",\"ttThreshold\":\"45\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"5456\",\"weightage\":\"456\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"456\",\"deltaValue\":60,\"ttThreshold\":\"54\",\"weightage\":\"6546\"},{\"name\":\"latency\",\"status\":\"disabled\",\"expectedValue\":\"5546\",\"deltaValue\":60,\"ttThreshold\":\"54\",\"weightage\":\"6546\"},{\"name\":\"minValue\",\"status\":\"disabled\",\"expectedValue\":\"546\",\"deltaValue\":2,\"ttThreshold\":\"546\",\"weightage\":\"546\"},{\"name\":\"staleValue\",\"status\":\"disabled\",\"ttThreshold\":\"546\",\"weightage\":\"546\"},{\"name\":\"maxValue\",\"status\":\"enable\",\"expectedValue\":\"456564564\",\"weightage\":\"6544654\",\"ttThreshold\":\"5464\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"Thread\":{\"name\":\"Thread\",\"status\":\"enable\",\"slideBy\":\"46546\",\"windowLength\":\"6456546\",\"indexes\":[\"dqi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"enable\",\"expectedValue\":\"45646\",\"deltaValue\":10,\"weightage\":\"456\",\"ttThreshold\":\"4\"},{\"name\":\"precision\",\"status\":\"enable\",\"expectedValue\":\"65\",\"weightage\":\"456\",\"ttThreshold\":\"45\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"5456\",\"weightage\":\"456\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"456\",\"deltaValue\":60,\"ttThreshold\":\"54\",\"weightage\":\"6546\"},{\"name\":\"latency\",\"status\":\"disabled\",\"expectedValue\":\"546\",\"deltaValue\":60,\"ttThreshold\":\"54\",\"weightage\":\"6546\"},{\"name\":\"minValue\",\"status\":\"disabled\",\"expectedValue\":\"546\",\"deltaValue\":2,\"ttThreshold\":\"546\",\"weightage\":\"546\"},{\"name\":\"staleValue\",\"status\":\"disabled\",\"ttThreshold\":\"546\",\"weightage\":\"546\"},{\"name\":\"maxValue\",\"status\":\"enable\",\"expectedValue\":\"456564564\",\"weightage\":\"6544654\",\"ttThreshold\":\"5464\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]},\"bottle\":{\"name\":\"bottle\",\"status\":\"enable\",\"slideBy\":\"879\",\"windowLength\":\"7898\",\"indexes\":[\"aswi\"],\"aspects\":[{\"name\":\"frequency\",\"status\":\"disabled\",\"expectedValue\":\"7879\",\"deltaValue\":10,\"weightage\":\"879987\",\"ttThreshold\":\"98987\"},{\"name\":\"precision\",\"status\":\"disabled\",\"expectedValue\":\"4564\",\"weightage\":\"654\",\"ttThreshold\":\"65\"},{\"name\":\"dataGap\",\"status\":\"disabled\",\"expectedValue\":\"65\",\"weightage\":\"465\"},{\"name\":\"dataCount\",\"status\":\"disabled\",\"expectedValue\":\"9\",\"deltaValue\":60,\"ttThreshold\":\"789\",\"weightage\":\"7\"},{\"name\":\"latency\",\"status\":\"disabled\",\"expectedValue\":\"789\",\"deltaValue\":60,\"ttThreshold\":\"7\",\"weightage\":\"86\"},{\"name\":\"minValue\",\"status\":\"enable\",\"expectedValue\":\"65\",\"deltaValue\":2,\"ttThreshold\":\"465\",\"weightage\":\"4\"},{\"name\":\"staleValue\",\"status\":\"enable\",\"ttThreshold\":\"46\",\"weightage\":\"54\"},{\"name\":\"maxValue\",\"status\":\"disabled\",\"expectedValue\":\"4\",\"weightage\":\"65465\",\"ttThreshold\":\"6464\",\"complexRules\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"validateCondition\":\"($Hole_depth - $Bit_Depth) > 30\",\"onSuccess\":\"#2\",\"onFailure\":\"#3\",\"id\":\"1\"},{\"mnemonics\":\"RPM\",\"validateCondition\":\"$RPM=1\",\"onSuccess\":\"#3\",\"onFailure\":\"=exit\",\"id\":\"2\"},{\"mnemonics\":\"FlowIn\",\"validateCondition\":\"$FlowIn > 34\",\"onSuccess\":\"continue\",\"onFailure\":\"exit\",\"id\":\"3\"}]}]}}}","data_type":"SIMULATED","frequency":1.0,"created_on":"Aug 18, 2023 6:24:39 AM","updated_on":"Nov 8, 2023 1:51:07 PM","lazyLoading":true,"manufacturer":"","device_type":"DEPTHSERIES","indexMnemonic":"Hole Depth","model_number":"","serial_number":"","channels":[],"recordCount":"0","nullValues":[],"timezone":"Etc/UTC","dstEnable":false,"metadata":{},"nodeInfo":""},{"feed_id":14,"devicename":"CG_IoT_Demo_1","asset_id":"DQAdvance","sub_asset_id":"DQAdvance","logid":"CG_Demo","feed_type":"CSV","device_id":"yellowhammer","dfbit":0,"server_address":"","source_address":"","active":"N","archive_status":"Y","isSecure":false,"username":"","startTime":"1692339902868","endTime":"1700540215565","password":"","socketid":"null","created_user_profile":"SOURCE","adaptorConfig":"{\"tsChannelName\":\"\",\"loopingEnable\":\"False\",\"freq\":\"100\",\"deepSleepTime\":\"100\",\"monitorDataFile\":\"False\",\"device_type\":\"TIMESERIES\",\"sparseDataStreaming\":\"True\",\"sourceFile\":\"/home/sigmastream/sample-data-with-torque-value.csv\",\"csvStreamDataCount\":\"\",\"speedupFactor\":\"\",\"dataQuality\":{\"Standpipe Pressure 2\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":300000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":120000,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Standpipe Pressure 1\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Hole Depth\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Hook Load\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Strks - Pump 2\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Date Time\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"ROP - Average\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Top Drive Torque\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"indexCount\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Top Drive RPM\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Strks - Pump 3\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Strks - Pump 1\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Bit Weight\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Block Height\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":300000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":180000,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Flow In Rate\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Bit Position\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Strks - Total\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"recordCount\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"frequency\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"channelCount\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"streamingDownTime\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"streamingUpTime\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}}},\"startIndex\":\"2023-08-18T06:30:48.126Z\",\"streamLoopingEvents\":\"False\",\"skipOverlap\":\"True\",\"csvMonitorTimeInterval\":\"5000\",\"indexMnemonic\":\"\"}","data_type":"RAW","frequency":1.0,"created_on":"Aug 18, 2023 6:25:02 AM","updated_on":"Nov 21, 2023 4:16:55 AM","lazyLoading":true,"manufacturer":"","device_type":"TIMESERIES","indexMnemonic":"","model_number":"","serial_number":"","channels":[],"recordCount":"0","nullValues":[],"timezone":"Etc/UTC","dstEnable":false,"metadata":{},"nodeInfo":""},{"feed_id":15,"devicename":"CG_IoT_Demo_2","asset_id":"DQAdvance","sub_asset_id":"DQAdvance","logid":"CG_Demo_2","feed_type":"CSV","device_id":"yellowhammer","dfbit":0,"server_address":"","source_address":"","active":"N","archive_status":"Y","isSecure":false,"username":"","startTime":"1692341213322","endTime":"1692341215964","password":"","socketid":"null","created_user_profile":"SOURCE","adaptorConfig":"{\"tsChannelName\":\"\",\"loopingEnable\":\"False\",\"freq\":\"100\",\"deepSleepTime\":\"100\",\"monitorDataFile\":\"False\",\"device_type\":\"TIMESERIES\",\"sparseDataStreaming\":\"True\",\"sourceFile\":\"/home/sigmastream/sample-data-with-torque-value.csv\",\"csvStreamDataCount\":\"\",\"speedupFactor\":\"\",\"dataQuality\":{\"Standpipe Pressure 2\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":300000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":120000,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Standpipe Pressure 1\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Hole Depth\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Hook Load\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Strks - Pump 2\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Date Time\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"ROP - Average\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Top Drive Torque\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"indexCount\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Top Drive RPM\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Strks - Pump 3\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Strks - Pump 1\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Bit Weight\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Block Height\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":300000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":180000,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Flow In Rate\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Bit Position\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"Strks - Total\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"recordCount\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"frequency\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"channelCount\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"streamingDownTime\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"streamingUpTime\":{\"enableDataQuality\":\"false\",\"enableDeviceDataQuality\":\"disabled\",\"aswiEnable\":true,\"aswiDuration\":60000,\"aswiSlideBy\":0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"min\":{\"status\":\"enable\",\"value\":\"100\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":0,\"newValue\":50},{\"mnemonic\":\"BC_OE\",\"value\":1,\"newValue\":20},{\"mnemonic\":\"BC_OE\",\"value\":2,\"newValue\":100}]}},\"freq\":{\"status\":\"enable\",\"value\":[1,10],\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"0.0\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":2000,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"enable\",\"latencyThreshold\":30000,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":1000,\"status\":\"enable\",\"weight\":\"0.0\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} = {Hole_depth}\",\"action\":\"valid\",\"sequence\":1},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} > 1\",\"action\":\"valid\",\"sequence\":2},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} > 1\",\"action\":\"valid\",\"sequence\":3}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}}},\"startIndex\":\"2023-08-18T06:30:48.126Z\",\"streamLoopingEvents\":\"False\",\"skipOverlap\":\"True\",\"csvMonitorTimeInterval\":\"5000\",\"indexMnemonic\":\"\"}","data_type":"RAW","frequency":1.0,"created_on":"Aug 18, 2023 6:46:53 AM","updated_on":"Aug 18, 2023 6:46:55 AM","lazyLoading":true,"manufacturer":"","device_type":"TIMESERIES","indexMnemonic":"","model_number":"","serial_number":"","channels":[],"recordCount":"0","nullValues":[],"timezone":"Etc/UTC","dstEnable":false,"metadata":{}},{"feed_id":18,"devicename":"DEPTH_MWD_WITSML_DEVICE","asset_id":"CMC_BUTTERCUP_25-37_E_0335LS","sub_asset_id":"EJ1836-00","logid":"DEPTH_MWD_WITSML","feed_type":"CSV","device_id":"yellowhammer","dfbit":0,"server_address":"","source_address":"","active":"N","archive_status":"Y","isSecure":false,"username":"","startTime":"1693235030553","endTime":"1693286609198","password":"","socketid":"null","created_user_profile":"SOURCE","adaptorConfig":"{\"isDeviceOffsetEnable\":false,\"issLiveStreaming\":false,\"deviceOffsetThreshold\":\"\",\"tsChannelName\":\"\",\"freq\":\"100\",\"device_type\":\"DEPTHSERIES\",\"sourceFile\":\"/home/sigmastream/yellowhammer/yellowhammer-server/DMWD.csv\",\"csvStreamDataCount\":\"\",\"issResumeStreaming\":false,\"startIndex\":\"\",\"endIndex\":\"\",\"streamLoopingEvents\":\"False\",\"deviceGapIntervalMinute\":\"60\",\"deviceOffset\":\"\",\"indexMnemonic\":\"Depth\",\"loopingEnable\":\"False\",\"deepSleepTime\":\"1000\",\"monitorDataFile\":\"False\",\"isDeviceThresholdbackfillEnable\":false,\"backfillPollInterval\":\"1\",\"sparseDataStreaming\":\"True\",\"backfillBatchSize\":\"100\",\"speedupFactor\":\"\",\"dataQuality\":{\"Depth\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":60.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"9144\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":20.0,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":15.0,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"TVD\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":60.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"4572\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":20.0,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":15.0,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"MWD GR\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":60.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"91\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":20.0,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":15.0,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"RSS RMS AXIAL\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":60.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"3\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":20.0,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":15.0,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"RSS RMS LATERAL\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":60.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"3\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":20.0,\"weight\":\"0.0\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":15.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":15.0,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"MWD AZI CONT\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":true,\"aswiEnable\":true,\"aswiDuration\":60.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"110\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":20.0,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":15.0,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"MWD INC CONT\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":60.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"42\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":20.0,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":15.0,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}},\"MWD TEMP\":{\"enableDataQuality\":\"true\",\"enableDeviceDataQuality\":false,\"aswiEnable\":true,\"aswiDuration\":60.0,\"aswiSlideBy\":0.0,\"formula\":\"cv\",\"inputDataStream\":{\"max\":{\"status\":\"enable\",\"value\":\"92\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"min\":{\"status\":\"enable\",\"value\":\"0\",\"weight\":\"2\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"contextual\":[{\"mnemonic\":\"BC_OE\",\"value\":\"0\",\"newValue\":\"50\"},{\"mnemonic\":\"BC_OE\",\"value\":\"1\",\"newValue\":\"20\"},{\"mnemonic\":\"BC_OE\",\"value\":\"2\",\"newValue\":\"100\"}]}},\"freq\":{\"status\":\"enable\",\"value\":[\"1\",\"10\"],\"weight\":\"4\",\"threshold\":\"0.0\"},\"precision\":{\"status\":\"enable\",\"value\":\"2\",\"weight\":\"1\",\"threshold\":\"0.0\"},\"dataCountStatus\":{\"status\":\"disabled\",\"weight\":\"0.0\"},\"dataGapStatus\":{\"status\":\"enable\",\"gapThreshold\":20.0,\"weight\":\"0.5\"},\"latencyEnable\":{\"status\":\"disabled\",\"latencyThreshold\":30000.0,\"weight\":\"0.0\"},\"staleValueMonitoring\":{\"windowLength\":15.0,\"status\":\"enable\",\"weight\":\"0.5\",\"threshold\":\"0.0\",\"rules\":{\"rulesStatus\":\"enable\",\"correlation\":[{\"mnemonics\":\"Bit_Depth,Hole_depth\",\"condition\":\"{Bit_Depth} \= {Hole_depth}\",\"action\":\"valid\",\"sequence\":\"1\"},{\"mnemonics\":\"RPM\",\"condition\":\"{RPM} \> 1\",\"action\":\"valid\",\"sequence\":\"2\"},{\"mnemonics\":\"FlowIn\",\"condition\":\"{FlowIn} \> 1\",\"action\":\"valid\",\"sequence\":\"3\"}],\"contextual\":[{\"mnemonics\":\"BC_OE\",\"value\":\"0\",\"action\":\"valid\"}]}}}}},\"devicePerformReportingEnable\":false,\"skipOverlap\":\"True\",\"csvMonitorTimeInterval\":\"5000\",\"isDeviceBackfillEnable\":false,\"deviceThresholdAutoBackFIllInterval\":\"120\",\"isDeviceAutoRestoreEnable\":false,\"deviceThresholdAutoRecoveryInterval\":\"\",\"deviceRestoreRetry\":\"\",\"devicePerformReportingInterval\":\"5\",\"deviceThresholdAutoBackFIllMergeInterval\":\"120\"}","data_type":"SIMULATED","frequency":1.0,"created_on":"Aug 28, 2023 3:03:50 PM","updated_on":"Aug 29, 2023 5:23:29 AM","lazyLoading":true,"manufacturer":"","device_type":"DEPTHSERIES","indexMnemonic":"Depth","model_number":"","serial_number":"","channels":[],"recordCount":"0","nullValues":[],"timezone":"Etc/UTC","dstEnable":false,"metadata":{},"nodeInfo":""}],"Result":"OK","TotalRecordCount":17,"metadataNames":["Metadata1","Metadata2","Metadata3"]}

export const yhAddress = "192.168.3.46"

export const yhPort = "8095"

export const aspectTemplateRecords = {
    "redirectPage": "/",
    "pageTitle": "Home",
    "status": "Success",
    "displayMsgs": [],
   
        "Result": "OK",
        "aspect": {
          "min": 200,
          "stale": 200,
          "max": 200,
          "latency": 200,
          "precision": 200,
          "dataGap": 200,
          "frequency": 200,
          "dataCount": 200
        },
        
    }


    export const ChannelTemplateRecords = {
        "redirectPage": "/",
        "pageTitle": "Home",
        "status": "Success",
        "displayMsgs": [],
        "data": {
          "data": {
            "Result": "OK",
            
            "data": {
              "TD SPEED_accumAswiForum3": 0,
              "DIFF PRESS_accumAswiForum3": 0,
              "FLOW OUT REL": 0,
              "FLOW OUT REL_accumAswiForum3": 0,
              "TD SPEED": 0,
              "DIFF PRESS": 0
            },
        }}}

        export const aspectTemplateDayRecords = {
            "redirectPage": "/",
            "pageTitle": "Home",
            "status": "Success",
            "displayMsgs": [],
            
                "Result": "OK",
                
                "processData": [
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    },
                    {
                      "endPoint": 10000,
                      "min": 200,
                      "stale": 200,
                      "max": 200,
                      "latency": 200,
                      "precision": 200,
                      "startPoint": 9800,
                      "dataGap": 200,
                      "frequency": 200,
                      "dataCount": 200
                    }
                  ] 

                // "aspectsData": [
                //     {
                //       "range": "9800 - 10000",
                //       "aspects": {
                //         "min": 200,
                //         "stale": 200,
                //         "max": 200,
                //         "latency": 200,
                //         "precision": 200,
                //         "dataGap": 200,
                //         "frequency": 200,
                //         "dataCount": 200,
                //         "startPoint":200,
                //         "endPoint":200,
                //       }
                //     },
                //     {
                //       "range": "9800 - 10000",
                //       "aspects": {
                //         "min": 200,
                //         "stale": 200,
                //         "max": 200,
                //         "latency": 200,
                //         "precision": 200,
                //         "dataGap": 200,
                //         "frequency": 200,
                //         "dataCount": 200,
                //         "startPoint":200,
                //         "endPoint":200,
                //       }
                //     }
                //     ]
            }

        
export const activeWells = {
    "PM131-2002": {
        "id": 47,
        "name": "PM131-2002",
        "rig_id": "18",
        "url": "https://192.168.1.131:7443",
        "display_name": "PM131-2002",
        "active_well_id": "TUPILCO-1DEL-131",
        "active_well_name": "TUPILCO-1DEL-131",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "wellVIew": {
        "id": 28,
        "name": "wellVIew",
        "rig_id": "26",
        "url": "https://192.168.1.19:8443",
        "display_name": "wellVIew",
        "active_well_id": "wellVIew",
        "active_well_name": "wellVIwellVIewew",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "P812": {
        "id": 8,
        "name": "P812",
        "rig_id": "20",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "P812",
        "active_well_id": "Null",
        "active_well_name": "Null",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "DEMO_RIG": {
        "id": 104,
        "name": "DEMO_RIG",
        "rig_id": "1",
        "url": "https://192.168.3.41:7443",
        "display_name": "DEMO RIG",
        "active_well_id": "DEMO_CSV",
        "active_well_name": "DEMO_CSV",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "MMR": {
        "id": 52,
        "name": "MMR",
        "rig_id": "22",
        "url": "https://192.168.1.131:7443",
        "display_name": "MMR",
        "active_well_id": "MMW",
        "active_well_name": "MMW",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "aasim": {
        "id": 30,
        "name": "aasim",
        "rig_id": "17",
        "url": "https://192.168.1.131:7443",
        "display_name": "aasim",
        "active_well_id": "aasim",
        "active_well_name": "aasim",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Test_ActiveD_Rig": {
        "id": 53,
        "name": "Test_ActiveD_Rig",
        "rig_id": "24",
        "url": "https://192.168.1.131:7443",
        "display_name": "Test_ActiveD_Rig",
        "active_well_id": "Test_ActiveD_Well",
        "active_well_name": "Test_ActiveD_Well",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "testtt": {
        "id": 31,
        "name": "testtt",
        "rig_id": "2",
        "url": "https://192.168.1.131:7443",
        "display_name": "testt",
        "active_well_id": "test_well",
        "active_well_name": "test_well",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "TestRIG1": {
        "id": 41,
        "name": "TestRIG1",
        "rig_id": "8",
        "url": "https://192.168.1.131:7443",
        "display_name": "TestRIG1",
        "active_well_id": "well1",
        "active_well_name": "well1",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "PY_DEMO_2": {
        "id": 45,
        "name": "PY_DEMO_2",
        "rig_id": "7",
        "url": "https://192.168.1.131:7443",
        "display_name": "PY_DEMO_2",
        "active_well_id": "PY_TEST_WELL",
        "active_well_name": "PY_TEST_WELL",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "TestRIG3": {
        "id": 40,
        "name": "TestRIG3",
        "rig_id": "10",
        "url": "https://192.168.1.131:7443",
        "display_name": "TestRIG3",
        "active_well_id": "well-3",
        "active_well_name": "well-3",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "rig1": {
        "id": 43,
        "name": "rig1",
        "rig_id": "4",
        "url": "https://192.168.1.131:7443",
        "display_name": "rig1",
        "active_well_id": "rig1",
        "active_well_name": "rig1",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Testr1": {
        "id": 42,
        "name": "Testr1",
        "rig_id": "20",
        "url": "https://192.168.1.131:7443",
        "display_name": "Testr1",
        "active_well_id": "wellR2",
        "active_well_name": "wellR2",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "TestRIG9": {
        "id": 34,
        "name": "TestRIG9",
        "rig_id": "16",
        "url": "https://192.168.1.131:7443",
        "display_name": "TestRIG9",
        "active_well_id": "well9",
        "active_well_name": "well9",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "TestRIG8": {
        "id": 33,
        "name": "TestRIG8",
        "rig_id": "15",
        "url": "https://192.168.1.131:7443",
        "display_name": "TestRIG8",
        "active_well_id": "well8",
        "active_well_name": "well8",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "TestRIG4": {
        "id": 37,
        "name": "TestRIG4",
        "rig_id": "11",
        "url": "https://192.168.1.131:7443",
        "display_name": "TestRIG4",
        "active_well_id": "well4",
        "active_well_name": "well4",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "TestRIG5": {
        "id": 38,
        "name": "TestRIG5",
        "rig_id": "12",
        "url": "https://192.168.1.131:7443",
        "display_name": "TestRIG5",
        "active_well_id": "well5",
        "active_well_name": "well5",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "TestRIG2": {
        "id": 39,
        "name": "TestRIG2",
        "rig_id": "9",
        "url": "https://192.168.1.131:7443",
        "display_name": "TestRIG2",
        "active_well_id": "well2",
        "active_well_name": "well2",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "TestRIG6": {
        "id": 35,
        "name": "TestRIG6",
        "rig_id": "13",
        "url": "https://192.168.1.131:7443",
        "display_name": "TestRIG6",
        "active_well_id": "well6",
        "active_well_name": "well6",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Ongc": {
        "id": 46,
        "name": "Ongc",
        "rig_id": "19",
        "url": "https://192.168.1.131:7443",
        "display_name": "ongc ",
        "active_well_id": "abc_1",
        "active_well_name": "abc_1",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "DEMO_TEST": {
        "id": 12,
        "name": "DEMO_TEST",
        "rig_id": "195",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "DEMO_TEST",
        "active_well_id": "DEMO_TEST",
        "active_well_name": "DEMO_TEST",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "PD-460": {
        "id": 56,
        "name": "PD-460",
        "rig_id": "204",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "PD-460",
        "active_well_id": "GUTTERSEN_DD08-784",
        "active_well_name": "GUTTERSEN DD08-784",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "HP-517_POC": {
        "id": 55,
        "name": "HP-517_POC",
        "rig_id": "206",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "HP-517 POC",
        "active_well_id": "JOHNSON_C32-775_POC",
        "active_well_name": "JOHNSON C32-775 POC",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_258_POC": {
        "id": 89,
        "name": "Patterson_258_POC",
        "rig_id": "23",
        "url": "https://yellowhammer.sigmastream.com:8443",
        "display_name": "Patterson_258_POC",
        "active_well_id": "REV_BX_T7-51-45_F_13WA_POC",
        "active_well_name": "REV BX T7 51-45 F 13WA POC",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_254_POC": {
        "id": 62,
        "name": "Patterson_254_POC",
        "rig_id": "210",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 254 POC",
        "active_well_id": "DR_STATE_WISE_UNIT_1_0154TB_POC",
        "active_well_name": "DR STATE WISE UNIT 1 0154TB POC",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "PD-460_POC": {
        "id": 58,
        "name": "PD-460_POC",
        "rig_id": "205",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "PD-460 POC",
        "active_well_id": "GUTTERSEN_C28-755_POC",
        "active_well_name": "GUTTERSEN C28-755 POC",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "P258": {
        "id": 4,
        "name": "P258",
        "rig_id": "186",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 258",
        "active_well_id": "REV_WOR_5-49_A_0031TB",
        "active_well_name": "REV WOR 5-49 A 0031TB",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_812": {
        "id": 91,
        "name": "Patterson_812",
        "rig_id": "40",
        "url": "https://yellowhammer.sigmastream.com:8443",
        "display_name": "Patterson 812",
        "active_well_id": "VLT_FALCON_JAY_JOHNSON_STATE_UNIT_0122WA",
        "active_well_name": "VLT FALCON JAY JOHNSON STATE UNIT 0122WA",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "HP-517": {
        "id": 5,
        "name": "HP-517",
        "rig_id": "28",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "HP 517",
        "active_well_id": "ARISTOCRAT_H14-715",
        "active_well_name": "ARISTOCRAT H14-715",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_278": {
        "id": 60,
        "name": "Patterson_278",
        "rig_id": "209",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 278",
        "active_well_id": "REV_WOR_5-49_G_0043TB_ST01_2",
        "active_well_name": "REV WOR 5-49 G 0043TB ST01 2",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_254": {
        "id": 82,
        "name": "Patterson_254",
        "rig_id": "19",
        "url": "https://yellowhammer.sigmastream.com:8443",
        "display_name": "Patterson 254",
        "active_well_id": "REV_TRINIDAD_SCORPION_T8-51-18_C_0023WA",
        "active_well_name": "REV TRINIDAD SCORPION T8-51-18 C 0023WA",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_289": {
        "id": 11,
        "name": "Patterson_289",
        "rig_id": "194",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 289",
        "active_well_id": "HAY_MIA_NO_0017WA",
        "active_well_name": "HAY MIA NO 0017WA",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_814": {
        "id": 92,
        "name": "Patterson_814",
        "rig_id": "5",
        "url": "https://192.168.2.104:8443",
        "display_name": "Patterson_814",
        "active_well_id": "CMC_BUTTERCUP_25-37_E_0335LS",
        "active_well_name": "CMC_BUTTERCUP_25-37_E_0335LS",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_327": {
        "id": 63,
        "name": "Patterson_327",
        "rig_id": "213",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 327",
        "active_well_id": "SD_18_19_FED_COM_P361_424H",
        "active_well_name": "SD 18 19 FED COM P361 424H",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "TestRIG7": {
        "id": 36,
        "name": "TestRIG7",
        "rig_id": "14",
        "url": "https://192.168.1.131:7443",
        "display_name": "TestRIG7",
        "active_well_id": "well7",
        "active_well_name": "well7",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "1000001": {
        "id": 54,
        "name": "1000001",
        "rig_id": "23",
        "url": "https://192.168.1.131:7443",
        "display_name": "KsyncRig",
        "active_well_id": "Ksyncwell",
        "active_well_name": "Ksyncwell",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "SigmaStream": {
        "id": 7,
        "name": "SigmaStream",
        "rig_id": "185",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "SigmaStream",
        "active_well_id": "Null",
        "active_well_name": "Null",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_333": {
        "id": 78,
        "name": "Patterson_333",
        "rig_id": "215",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 333",
        "active_well_id": "JAVELINA_UNIT_508H",
        "active_well_name": "JAVELINA UNIT 508H",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "P257_DQ": {
        "id": 93,
        "name": "P257_DQ",
        "rig_id": "44",
        "url": "https://yellowhammer.sigmastream.com:8443",
        "display_name": "P257_DQ",
        "active_well_id": "JAVELINA_UNIT_413H",
        "active_well_name": "JAVELINA_UNIT_413H",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_257": {
        "id": 6,
        "name": "Patterson_257",
        "rig_id": "188",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 257",
        "active_well_id": "JAVELINA_UNIT_615H",
        "active_well_name": "JAVELINA UNIT 615H",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Rig_Cluster_25": {
        "id": 94,
        "name": "Rig_Cluster_25",
        "rig_id": "63",
        "url": "https://yellowhammer.sigmastream.com:8443",
        "display_name": "Rig_Cluster_25",
        "active_well_id": "Well_Cluster_25",
        "active_well_name": "Well_Cluster_25",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson-815_POC": {
        "id": 86,
        "name": "Patterson-815_POC",
        "rig_id": "22",
        "url": "https://yellowhammer.sigmastream.com:443",
        "display_name": "Patterson815 POC",
        "active_well_id": "SD_24_13_FED_P416_17H_POC",
        "active_well_name": "SD 24 13 FED P416 17H POC",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_812_DQ": {
        "id": 75,
        "name": "Patterson_812_DQ",
        "rig_id": "38",
        "url": "https://yellowhammer.sigmastream.com:443",
        "display_name": "Patterson 812 DQ",
        "active_well_id": "VLT_THOR_STATE_UNIT_0161WA_DQ",
        "active_well_name": "VLT_THOR_STATE_UNIT_0161WA_DQ",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "IoT_Demo": {
        "id": 68,
        "name": "IoT_Demo",
        "rig_id": "32",
        "url": "https://yellowhammer.sigmastream.com:8443",
        "display_name": "IoT_Demo",
        "active_well_id": "CMC_CANDLESTICK_G_0090WA_POC_Loop_A",
        "active_well_name": "CMC_CANDLESTICK_G_0090WA_POC_Loop_A",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "IoT_Demo_1": {
        "id": 67,
        "name": "IoT_Demo_1",
        "rig_id": "33",
        "url": "https://yellowhammer.sigmastream.com:8443",
        "display_name": "IoT_Demo_1",
        "active_well_id": "CB_TANO_26-35_FEE_11-403H_POC_Loop",
        "active_well_name": "CB_TANO_26-35_FEE_11-403H_POC_Loop",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "IPT_Test_Rig": {
        "id": 65,
        "name": "IPT_Test_Rig",
        "rig_id": "54",
        "url": "https://yellowhammer.sigmastream.com:8443",
        "display_name": "IPT Test Rig",
        "active_well_id": "IPT_Test_well",
        "active_well_name": "IPT Test well",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "CG_POC_RIG": {
        "id": 76,
        "name": "CG_POC_RIG",
        "rig_id": "37",
        "url": "https://yellowhammer.sigmastream.com:443",
        "display_name": "CG_POC_RIG",
        "active_well_id": "CG_WELL",
        "active_well_name": "CG_WELL",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "P817_DQ": {
        "id": 69,
        "name": "P817_DQ",
        "rig_id": "48",
        "url": "https://yellowhammer.sigmastream.com:443",
        "display_name": "P817 DQ",
        "active_well_id": "HAY_MATTHEW_A_0011WA",
        "active_well_name": "HAY MATTHEW A 0011WA",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "P815_Test": {
        "id": 83,
        "name": "P815_Test",
        "rig_id": "58",
        "url": "https://yellowhammer.sigmastream.com:8443",
        "display_name": "P815 Test",
        "active_well_id": "SND_JAVELINA_UNIT_500H",
        "active_well_name": "SND JAVELINA UNIT 500H",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "DQAdvance": {
        "id": 88,
        "name": "DQAdvance",
        "rig_id": "4",
        "url": "https://192.168.2.104:8443",
        "display_name": "DQAdvance",
        "active_well_id": "DQAdvance",
        "active_well_name": "DQAdvance",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_284": {
        "id": 51,
        "name": "Patterson_284",
        "rig_id": "202",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 284",
        "active_well_id": "DR_STATE_WISE_UNIT_1_0411WA",
        "active_well_name": "DR STATE WISE UNIT 1 0411WA",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Test_Rig_K": {
        "id": 105,
        "name": "Test_Rig_K",
        "rig_id": "8",
        "url": "https://192.168.2.104:8443",
        "display_name": "Test_Rig_K",
        "active_well_id": "Test_Well_K",
        "active_well_name": "Test_Well_K",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "TEST_RIG_P": {
        "id": 80,
        "name": "TEST_RIG_P",
        "rig_id": "59",
        "url": "https://yellowhammer.sigmastream.com:443",
        "display_name": "TEST_RIG_P",
        "active_well_id": "TEST_WELL_P",
        "active_well_name": "TEST_WELL_P",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "HP-447": {
        "id": 59,
        "name": "HP-447",
        "rig_id": "207",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "HP 447",
        "active_well_id": "ET-2113",
        "active_well_name": "ET-2113",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "P815": {
        "id": 1,
        "name": "P815",
        "rig_id": "19",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 815",
        "active_well_id": "CICADA_UNIT_74H_ST01",
        "active_well_name": "CICADA UNIT 74H ST01",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "AG_RIG1": {
        "id": 95,
        "name": "AG_RIG1",
        "rig_id": "6",
        "url": "https://192.168.2.104:8443",
        "display_name": "Rig1",
        "active_well_id": "DEMO_W_2",
        "active_well_name": "DEMO_WELL_WB",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_817": {
        "id": 25,
        "name": "Patterson_817",
        "rig_id": "198",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 817",
        "active_well_id": "DR_A_JECKYLL_21_SWD_1",
        "active_well_name": "DR A JECKYLL 21 SWD 1",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_268": {
        "id": 13,
        "name": "Patterson_268",
        "rig_id": "197",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 268",
        "active_well_id": "VROOMAN_C22-745",
        "active_well_name": "VROOMAN C22-745",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "WellView": {
        "id": 97,
        "name": "WellView",
        "rig_id": "10",
        "url": "https://192.168.3.41:7443",
        "display_name": "WellView",
        "active_well_id": "WellView",
        "active_well_name": "WellView",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Parker_Test": {
        "id": 98,
        "name": "Parker_Test",
        "rig_id": "17",
        "url": "https://192.168.3.41:7443",
        "display_name": "Parker_Test",
        "active_well_id": "Parker_Test_2",
        "active_well_name": "Parker_Test_2",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "DQ": {
        "id": 87,
        "name": "DQ",
        "rig_id": "3",
        "url": "https://192.168.2.104:8443",
        "display_name": "DQ",
        "active_well_id": "DQ2",
        "active_well_name": "DQ2",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    },
    "Patterson_329": {
        "id": 48,
        "name": "Patterson_329",
        "rig_id": "201",
        "url": "https://yellowhammer-chevron.sigmastream.com:443",
        "display_name": "Patterson 329",
        "active_well_id": "DL_10_3_MORAG_FED_COM_412H",
        "active_well_name": "DL 10 3 MORAG FED COM 412H",
        "monitoring_state": true,
        "is_visible": true,
        "domain_name": "",
        "ip_address": "",
        "contacts": []
    }
};

export const dataQualityTime = {
    "Record": {
        "endPoint": "09/30/2023 07:34:34",
        "startPoint": "05/22/2023 23:00:00",
        "aswi": "3600000"
    }
}

export const dataQualityTotalRecord = {
        "startTime": "2023-05-21T19:00:00",
        "endTime": "2023-06-27T19:00:00",
        "rigs": [
            {
                "name": "Patterson_814",
                "totalASWI": 20.84,
                "totalDQI": 20.81,
                "wells": [
                    {
                        "name": "CMC_BUTTERCUP_25-37_E_0335LS",
                        "totalASWI": 20.84,
                        "totalDQI": 20.81,
                        "logs": [
                            {
                                "name": "TIME_SURFACE",
                                "totalASWI": 20.84,
                                "totalDQI": 20.81,
                                "logType": "TIMESERIES",
                                "mnemonics": [
                                    {
                                        "name": "HL",
                                        "totalASWI": 24.82,
                                        "totalDQI": 22.66,
                                        "pageSize": "10000000",
                                        "currentPage": "1",
                                        "totalRecord": 693.0,
                                        "records": [
                                            {
                                                "startPoint": "2023-05-22T23:00:00",
                                                "endPoint": "2023-05-23T00:00:00",
                                                "aswi": 75.98664,
                                                "dqi": 76.37446,
                                                "frequency": "1.00161",
                                                "dataCount": "622",
                                                "score_frequency": "10",
                                                "score_stale": "4.13184",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.96785",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "2979",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "12",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2113",
                                                "timestamp": 1.6847964E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T00:00:00",
                                                "endPoint": "2023-05-23T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T01:00:00",
                                                "endPoint": "2023-05-23T02:00:00",
                                                "aswi": 91.71748,
                                                "dqi": 82.08831,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "2.71315",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "6.53985",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "1246",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2623",
                                                "timestamp": 1.6848036E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T02:00:00",
                                                "endPoint": "2023-05-23T03:00:00",
                                                "aswi": 97.39038,
                                                "dqi": 92.59465,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.52319",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.0336",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "348",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1252",
                                                "timestamp": 1.6848072E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T03:00:00",
                                                "endPoint": "2023-05-23T04:00:00",
                                                "aswi": 96.61671,
                                                "dqi": 91.14135,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.42628",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.25854",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "267",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1647",
                                                "timestamp": 1.6848108E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T04:00:00",
                                                "endPoint": "2023-05-23T05:00:00",
                                                "aswi": 97.10311,
                                                "dqi": 92.15496,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.93725",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.35573",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "232",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1463",
                                                "timestamp": 1.6848144E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T05:00:00",
                                                "endPoint": "2023-05-23T06:00:00",
                                                "aswi": 97.93151,
                                                "dqi": 93.85819,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.31464",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.00028",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "360",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "967",
                                                "timestamp": 1.684818E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T06:00:00",
                                                "endPoint": "2023-05-23T07:00:00",
                                                "aswi": 97.71812,
                                                "dqi": 93.31667,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.04805",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "8.94196",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "381",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1063",
                                                "timestamp": 1.6848216E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T07:00:00",
                                                "endPoint": "2023-05-23T08:00:00",
                                                "aswi": 97.88525,
                                                "dqi": 93.75174,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.22578",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.02527",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "351",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "999",
                                                "timestamp": 1.6848252E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T21:00:00",
                                                "endPoint": "2023-05-26T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851348E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T22:00:00",
                                                "endPoint": "2023-05-26T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851384E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T23:00:00",
                                                "endPoint": "2023-05-27T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685142E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T00:00:00",
                                                "endPoint": "2023-05-27T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851456E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T22:00:00",
                                                "endPoint": "2023-06-09T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686348E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T23:00:00",
                                                "endPoint": "2023-06-10T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863516E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T00:00:00",
                                                "endPoint": "2023-06-10T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863552E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T01:00:00",
                                                "endPoint": "2023-06-10T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863588E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T02:00:00",
                                                "endPoint": "2023-06-10T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863624E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T03:00:00",
                                                "endPoint": "2023-06-10T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686366E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T04:00:00",
                                                "endPoint": "2023-06-10T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863696E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T05:00:00",
                                                "endPoint": "2023-06-10T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863732E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T06:00:00",
                                                "endPoint": "2023-06-10T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863768E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T07:00:00",
                                                "endPoint": "2023-06-10T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863804E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T08:00:00",
                                                "endPoint": "2023-06-10T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686384E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T09:00:00",
                                                "endPoint": "2023-06-10T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863876E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T10:00:00",
                                                "endPoint": "2023-06-10T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863912E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T11:00:00",
                                                "endPoint": "2023-06-10T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863948E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T12:00:00",
                                                "endPoint": "2023-06-10T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863984E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T13:00:00",
                                                "endPoint": "2023-06-10T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686402E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T14:00:00",
                                                "endPoint": "2023-06-10T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864056E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T15:00:00",
                                                "endPoint": "2023-06-10T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864092E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T16:00:00",
                                                "endPoint": "2023-06-10T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864128E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T17:00:00",
                                                "endPoint": "2023-06-10T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864164E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T18:00:00",
                                                "endPoint": "2023-06-10T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68642E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T19:00:00",
                                                "endPoint": "2023-06-10T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864236E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T20:00:00",
                                                "endPoint": "2023-06-10T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864272E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T21:00:00",
                                                "endPoint": "2023-06-10T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864308E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T22:00:00",
                                                "endPoint": "2023-06-10T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864344E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T23:00:00",
                                                "endPoint": "2023-06-11T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686438E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T00:00:00",
                                                "endPoint": "2023-06-11T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864416E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T01:00:00",
                                                "endPoint": "2023-06-11T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864452E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T02:00:00",
                                                "endPoint": "2023-06-11T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864488E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T03:00:00",
                                                "endPoint": "2023-06-11T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864524E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T04:00:00",
                                                "endPoint": "2023-06-11T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686456E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T05:00:00",
                                                "endPoint": "2023-06-11T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864596E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T06:00:00",
                                                "endPoint": "2023-06-11T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864632E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T07:00:00",
                                                "endPoint": "2023-06-11T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864668E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T08:00:00",
                                                "endPoint": "2023-06-11T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864704E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T09:00:00",
                                                "endPoint": "2023-06-11T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686474E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T10:00:00",
                                                "endPoint": "2023-06-11T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864776E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T11:00:00",
                                                "endPoint": "2023-06-11T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864812E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T12:00:00",
                                                "endPoint": "2023-06-11T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864848E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T13:00:00",
                                                "endPoint": "2023-06-11T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864884E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T14:00:00",
                                                "endPoint": "2023-06-11T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686492E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T15:00:00",
                                                "endPoint": "2023-06-11T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864956E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T16:00:00",
                                                "endPoint": "2023-06-11T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864992E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T17:00:00",
                                                "endPoint": "2023-06-11T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865028E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T18:00:00",
                                                "endPoint": "2023-06-11T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865064E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T19:00:00",
                                                "endPoint": "2023-06-11T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68651E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T20:00:00",
                                                "endPoint": "2023-06-11T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865136E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T21:00:00",
                                                "endPoint": "2023-06-11T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865172E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T22:00:00",
                                                "endPoint": "2023-06-11T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865208E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T23:00:00",
                                                "endPoint": "2023-06-12T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865244E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T00:00:00",
                                                "endPoint": "2023-06-12T01:00:00",
                                                "aswi": 49.62643,
                                                "dqi": 71.27162,
                                                "frequency": "1",
                                                "dataCount": "1738",
                                                "score_frequency": "10",
                                                "score_stale": "8.37222",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.80437",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "64",
                                                "tt_dataGap": "1864",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "70",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "607",
                                                "timestamp": 1.686528E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T01:00:00",
                                                "endPoint": "2023-06-12T02:00:00",
                                                "aswi": 62.46085,
                                                "dqi": 80.2416,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.28381",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.86115",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "50",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "618",
                                                "timestamp": 1.6865316E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T02:00:00",
                                                "endPoint": "2023-06-12T03:00:00",
                                                "aswi": 62.48643,
                                                "dqi": 80.34342,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.39212",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.81394",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "67",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "579",
                                                "timestamp": 1.6865352E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T03:00:00",
                                                "endPoint": "2023-06-12T04:00:00",
                                                "aswi": 62.25409,
                                                "dqi": 79.26039,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.99778",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.55846",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "159",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "721",
                                                "timestamp": 1.6865388E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T04:00:00",
                                                "endPoint": "2023-06-12T05:00:00",
                                                "aswi": 62.45121,
                                                "dqi": 80.1768,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.33102",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.77506",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "81",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "601",
                                                "timestamp": 1.6865424E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T05:00:00",
                                                "endPoint": "2023-06-12T06:00:00",
                                                "aswi": 62.46227,
                                                "dqi": 80.25086,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.27826",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.87226",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "46",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "620",
                                                "timestamp": 1.686546E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T06:00:00",
                                                "endPoint": "2023-06-12T07:00:00",
                                                "aswi": 62.49947,
                                                "dqi": 80.38508,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.49209",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.73896",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "94",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "543",
                                                "timestamp": 1.6865496E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T07:00:00",
                                                "endPoint": "2023-06-12T08:00:00",
                                                "aswi": 62.61607,
                                                "dqi": 80.94048,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.72258",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.84171",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "57",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "460",
                                                "timestamp": 1.6865532E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T08:00:00",
                                                "endPoint": "2023-06-12T09:00:00",
                                                "aswi": 62.70925,
                                                "dqi": 81.38017,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.98084",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.84726",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "55",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "367",
                                                "timestamp": 1.6865568E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T09:00:00",
                                                "endPoint": "2023-06-12T10:00:00",
                                                "aswi": 62.67151,
                                                "dqi": 81.19967,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.88087",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.83893",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "58",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "403",
                                                "timestamp": 1.6865604E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T10:00:00",
                                                "endPoint": "2023-06-12T11:00:00",
                                                "aswi": 62.47202,
                                                "dqi": 80.29251,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.30881",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.8667",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "48",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "609",
                                                "timestamp": 1.686564E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T11:00:00",
                                                "endPoint": "2023-06-12T12:00:00",
                                                "aswi": 62.57816,
                                                "dqi": 80.78312,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.54763",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.92224",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "28",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "523",
                                                "timestamp": 1.6865676E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T12:00:00",
                                                "endPoint": "2023-06-12T13:00:00",
                                                "aswi": 62.56155,
                                                "dqi": 80.68129,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.60595",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.80283",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "71",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "502",
                                                "timestamp": 1.6865712E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T13:00:00",
                                                "endPoint": "2023-06-12T14:00:00",
                                                "aswi": 62.61405,
                                                "dqi": 80.92197,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.76146",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.79172",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "75",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "446",
                                                "timestamp": 1.6865748E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T14:00:00",
                                                "endPoint": "2023-06-12T15:00:00",
                                                "aswi": 89.49659,
                                                "dqi": 91.41905,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.07248",
                                                "score_dataGap": "10",
                                                "score_maxValue": "5.90114",
                                                "score_minValue": "10",
                                                "score_precision": "9.87781",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "1476",
                                                "tt_minValue": "0",
                                                "tt_precision": "44",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "334",
                                                "timestamp": 1.6865784E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T15:00:00",
                                                "endPoint": "2023-06-12T16:00:00",
                                                "aswi": 62.66916,
                                                "dqi": 81.19041,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.86421",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.85004",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "54",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "409",
                                                "timestamp": 1.686582E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T16:00:00",
                                                "endPoint": "2023-06-12T17:00:00",
                                                "aswi": 62.63881,
                                                "dqi": 81.04693,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.78368",
                                                "score_dataGap": "10",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.84449",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "56",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "438",
                                                "timestamp": 1.6865856E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T17:00:00",
                                                "endPoint": "2023-06-12T18:00:00",
                                                "aswi": 62.55242,
                                                "dqi": 80.56234,
                                                "frequency": "1",
                                                "dataCount": "3553",
                                                "score_frequency": "10",
                                                "score_stale": "8.78889",
                                                "score_dataGap": "9.86389",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.83676",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "49",
                                                "tt_dataGap": "49",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "59",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "442",
                                                "timestamp": 1.6865892E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T18:00:00",
                                                "endPoint": "2023-06-12T19:00:00",
                                                "aswi": 62.31143,
                                                "dqi": 79.25185,
                                                "frequency": "0.9997",
                                                "dataCount": "3375",
                                                "score_frequency": "9.997",
                                                "score_stale": "9.0386",
                                                "score_dataGap": "9.36667",
                                                "score_maxValue": "1",
                                                "score_minValue": "10",
                                                "score_precision": "9.84296",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "228",
                                                "tt_dataGap": "228",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "0",
                                                "tt_precision": "57",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "369",
                                                "timestamp": 1.6865928E12
                                            }
                                        ]
                                    },
                                    {
                                        "name": "TV7",
                                        "totalASWI": 1.0,
                                        "totalDQI": 0.0,
                                        "pageSize": "10000000",
                                        "currentPage": "1",
                                        "totalRecord": 693.0,
                                        "records": [
                                            {
                                                "startPoint": "2023-05-22T23:00:00",
                                                "endPoint": "2023-05-23T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6847964E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T00:00:00",
                                                "endPoint": "2023-05-23T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T01:00:00",
                                                "endPoint": "2023-05-23T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848036E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T02:00:00",
                                                "endPoint": "2023-05-23T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848072E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T03:00:00",
                                                "endPoint": "2023-05-23T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848108E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T04:00:00",
                                                "endPoint": "2023-05-23T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848144E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T05:00:00",
                                                "endPoint": "2023-05-23T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684818E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T06:00:00",
                                                "endPoint": "2023-05-23T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848216E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T07:00:00",
                                                "endPoint": "2023-05-23T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848252E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T08:00:00",
                                                "endPoint": "2023-05-23T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848288E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T09:00:00",
                                                "endPoint": "2023-05-23T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848324E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T10:00:00",
                                                "endPoint": "2023-05-23T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684836E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T11:00:00",
                                                "endPoint": "2023-05-23T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848396E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T12:00:00",
                                                "endPoint": "2023-05-23T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848432E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T13:00:00",
                                                "endPoint": "2023-05-23T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848468E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T14:00:00",
                                                "endPoint": "2023-05-23T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848504E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T15:00:00",
                                                "endPoint": "2023-05-23T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684854E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T16:00:00",
                                                "endPoint": "2023-05-23T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848576E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T17:00:00",
                                                "endPoint": "2023-05-23T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848612E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T18:00:00",
                                                "endPoint": "2023-05-23T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848648E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T19:00:00",
                                                "endPoint": "2023-05-23T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848684E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T20:00:00",
                                                "endPoint": "2023-05-23T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684872E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T21:00:00",
                                                "endPoint": "2023-05-23T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848756E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T22:00:00",
                                                "endPoint": "2023-05-23T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848792E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T23:00:00",
                                                "endPoint": "2023-05-24T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848828E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T00:00:00",
                                                "endPoint": "2023-05-24T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848864E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T01:00:00",
                                                "endPoint": "2023-05-24T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68489E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T02:00:00",
                                                "endPoint": "2023-05-24T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848936E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T03:00:00",
                                                "endPoint": "2023-05-24T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848972E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T04:00:00",
                                                "endPoint": "2023-05-24T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849008E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T05:00:00",
                                                "endPoint": "2023-05-24T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849044E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T06:00:00",
                                                "endPoint": "2023-05-24T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684908E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T07:00:00",
                                                "endPoint": "2023-05-24T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849116E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T08:00:00",
                                                "endPoint": "2023-05-24T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849152E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T09:00:00",
                                                "endPoint": "2023-05-24T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849188E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T10:00:00",
                                                "endPoint": "2023-05-24T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849224E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T11:00:00",
                                                "endPoint": "2023-05-24T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684926E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T12:00:00",
                                                "endPoint": "2023-05-24T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849296E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T13:00:00",
                                                "endPoint": "2023-05-24T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849332E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T14:00:00",
                                                "endPoint": "2023-05-24T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849368E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T15:00:00",
                                                "endPoint": "2023-05-24T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849404E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T16:00:00",
                                                "endPoint": "2023-05-24T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684944E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T17:00:00",
                                                "endPoint": "2023-05-24T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849476E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T18:00:00",
                                                "endPoint": "2023-05-24T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849512E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T19:00:00",
                                                "endPoint": "2023-05-24T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849548E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T20:00:00",
                                                "endPoint": "2023-05-24T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849584E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T21:00:00",
                                                "endPoint": "2023-05-24T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684962E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T22:00:00",
                                                "endPoint": "2023-05-24T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849656E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T23:00:00",
                                                "endPoint": "2023-05-25T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849692E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T00:00:00",
                                                "endPoint": "2023-05-25T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849728E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T01:00:00",
                                                "endPoint": "2023-05-25T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849764E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T02:00:00",
                                                "endPoint": "2023-05-25T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68498E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T03:00:00",
                                                "endPoint": "2023-05-25T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849836E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T04:00:00",
                                                "endPoint": "2023-05-25T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849872E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T05:00:00",
                                                "endPoint": "2023-05-25T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849908E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T06:00:00",
                                                "endPoint": "2023-05-25T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849944E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T07:00:00",
                                                "endPoint": "2023-05-25T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684998E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T08:00:00",
                                                "endPoint": "2023-05-25T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850016E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T09:00:00",
                                                "endPoint": "2023-05-25T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850052E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T10:00:00",
                                                "endPoint": "2023-05-25T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850088E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T11:00:00",
                                                "endPoint": "2023-05-25T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850124E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T12:00:00",
                                                "endPoint": "2023-05-25T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685016E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T13:00:00",
                                                "endPoint": "2023-05-25T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850196E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T14:00:00",
                                                "endPoint": "2023-05-25T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850232E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T15:00:00",
                                                "endPoint": "2023-05-25T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850268E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T16:00:00",
                                                "endPoint": "2023-05-25T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850304E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T17:00:00",
                                                "endPoint": "2023-05-25T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685034E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T18:00:00",
                                                "endPoint": "2023-05-25T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850376E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T19:00:00",
                                                "endPoint": "2023-05-25T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850412E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T20:00:00",
                                                "endPoint": "2023-05-25T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850448E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T21:00:00",
                                                "endPoint": "2023-05-25T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850484E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T22:00:00",
                                                "endPoint": "2023-05-25T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685052E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T23:00:00",
                                                "endPoint": "2023-05-26T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850556E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T00:00:00",
                                                "endPoint": "2023-05-26T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850592E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T01:00:00",
                                                "endPoint": "2023-05-26T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850628E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T02:00:00",
                                                "endPoint": "2023-05-26T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850664E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T03:00:00",
                                                "endPoint": "2023-05-26T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68507E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T04:00:00",
                                                "endPoint": "2023-05-26T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850736E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T05:00:00",
                                                "endPoint": "2023-05-26T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850772E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T06:00:00",
                                                "endPoint": "2023-05-26T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850808E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T07:00:00",
                                                "endPoint": "2023-05-26T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850844E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T08:00:00",
                                                "endPoint": "2023-05-26T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685088E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T09:00:00",
                                                "endPoint": "2023-05-26T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850916E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T10:00:00",
                                                "endPoint": "2023-05-26T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850952E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T11:00:00",
                                                "endPoint": "2023-05-26T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850988E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T12:00:00",
                                                "endPoint": "2023-05-26T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851024E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T13:00:00",
                                                "endPoint": "2023-05-26T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685106E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T14:00:00",
                                                "endPoint": "2023-05-26T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851096E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T15:00:00",
                                                "endPoint": "2023-05-26T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851132E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T16:00:00",
                                                "endPoint": "2023-05-26T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851168E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T17:00:00",
                                                "endPoint": "2023-05-26T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851204E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T18:00:00",
                                                "endPoint": "2023-05-26T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685124E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T19:00:00",
                                                "endPoint": "2023-05-26T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851276E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T20:00:00",
                                                "endPoint": "2023-05-26T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851312E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T21:00:00",
                                                "endPoint": "2023-05-26T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851348E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T22:00:00",
                                                "endPoint": "2023-05-26T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851384E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T23:00:00",
                                                "endPoint": "2023-05-27T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685142E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T00:00:00",
                                                "endPoint": "2023-05-27T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851456E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T01:00:00",
                                                "endPoint": "2023-05-27T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851492E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T02:00:00",
                                                "endPoint": "2023-05-27T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851528E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T03:00:00",
                                                "endPoint": "2023-05-27T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851564E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T04:00:00",
                                                "endPoint": "2023-05-27T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68516E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T05:00:00",
                                                "endPoint": "2023-05-27T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851636E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T06:00:00",
                                                "endPoint": "2023-05-27T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851672E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T07:00:00",
                                                "endPoint": "2023-05-27T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851708E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T08:00:00",
                                                "endPoint": "2023-05-27T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851744E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T09:00:00",
                                                "endPoint": "2023-05-27T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685178E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T10:00:00",
                                                "endPoint": "2023-05-27T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851816E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T11:00:00",
                                                "endPoint": "2023-05-27T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851852E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T12:00:00",
                                                "endPoint": "2023-05-27T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851888E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T13:00:00",
                                                "endPoint": "2023-05-27T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851924E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T14:00:00",
                                                "endPoint": "2023-05-27T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685196E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T15:00:00",
                                                "endPoint": "2023-05-27T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851996E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T16:00:00",
                                                "endPoint": "2023-05-27T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852032E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T17:00:00",
                                                "endPoint": "2023-05-27T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852068E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T18:00:00",
                                                "endPoint": "2023-05-27T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852104E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T19:00:00",
                                                "endPoint": "2023-05-27T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685214E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T20:00:00",
                                                "endPoint": "2023-05-27T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852176E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T21:00:00",
                                                "endPoint": "2023-05-27T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852212E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T22:00:00",
                                                "endPoint": "2023-05-27T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852248E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T23:00:00",
                                                "endPoint": "2023-05-28T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852284E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T00:00:00",
                                                "endPoint": "2023-05-28T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685232E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T01:00:00",
                                                "endPoint": "2023-05-28T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852356E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T02:00:00",
                                                "endPoint": "2023-05-28T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852392E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T03:00:00",
                                                "endPoint": "2023-05-28T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852428E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T04:00:00",
                                                "endPoint": "2023-05-28T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852464E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T05:00:00",
                                                "endPoint": "2023-05-28T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68525E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T06:00:00",
                                                "endPoint": "2023-05-28T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852536E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T07:00:00",
                                                "endPoint": "2023-05-28T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852572E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T08:00:00",
                                                "endPoint": "2023-05-28T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852608E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T09:00:00",
                                                "endPoint": "2023-05-28T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852644E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T10:00:00",
                                                "endPoint": "2023-05-28T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685268E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T11:00:00",
                                                "endPoint": "2023-05-28T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852716E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T12:00:00",
                                                "endPoint": "2023-05-28T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852752E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T13:00:00",
                                                "endPoint": "2023-05-28T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852788E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T14:00:00",
                                                "endPoint": "2023-05-28T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852824E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T15:00:00",
                                                "endPoint": "2023-05-28T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685286E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T16:00:00",
                                                "endPoint": "2023-05-28T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852896E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T17:00:00",
                                                "endPoint": "2023-05-28T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852932E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T18:00:00",
                                                "endPoint": "2023-05-28T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852968E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T19:00:00",
                                                "endPoint": "2023-05-28T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853004E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T20:00:00",
                                                "endPoint": "2023-05-28T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685304E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T21:00:00",
                                                "endPoint": "2023-05-28T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853076E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T22:00:00",
                                                "endPoint": "2023-05-28T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853112E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T23:00:00",
                                                "endPoint": "2023-05-29T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853148E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T00:00:00",
                                                "endPoint": "2023-05-29T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853184E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T01:00:00",
                                                "endPoint": "2023-05-29T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685322E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T02:00:00",
                                                "endPoint": "2023-05-29T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853256E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T03:00:00",
                                                "endPoint": "2023-05-29T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853292E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T04:00:00",
                                                "endPoint": "2023-05-29T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853328E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T05:00:00",
                                                "endPoint": "2023-05-29T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853364E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T06:00:00",
                                                "endPoint": "2023-05-29T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68534E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T07:00:00",
                                                "endPoint": "2023-05-29T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853436E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T08:00:00",
                                                "endPoint": "2023-05-29T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853472E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T09:00:00",
                                                "endPoint": "2023-05-29T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853508E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T10:00:00",
                                                "endPoint": "2023-05-29T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853544E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T11:00:00",
                                                "endPoint": "2023-05-29T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685358E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T12:00:00",
                                                "endPoint": "2023-05-29T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853616E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T13:00:00",
                                                "endPoint": "2023-05-29T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853652E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T14:00:00",
                                                "endPoint": "2023-05-29T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853688E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T15:00:00",
                                                "endPoint": "2023-05-29T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853724E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T16:00:00",
                                                "endPoint": "2023-05-29T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685376E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T17:00:00",
                                                "endPoint": "2023-05-29T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853796E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T18:00:00",
                                                "endPoint": "2023-05-29T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853832E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T19:00:00",
                                                "endPoint": "2023-05-29T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853868E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T20:00:00",
                                                "endPoint": "2023-05-29T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853904E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T21:00:00",
                                                "endPoint": "2023-05-29T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685394E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T22:00:00",
                                                "endPoint": "2023-05-29T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853976E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T23:00:00",
                                                "endPoint": "2023-05-30T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854012E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T00:00:00",
                                                "endPoint": "2023-05-30T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854048E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T01:00:00",
                                                "endPoint": "2023-05-30T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854084E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T02:00:00",
                                                "endPoint": "2023-05-30T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685412E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T03:00:00",
                                                "endPoint": "2023-05-30T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854156E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T04:00:00",
                                                "endPoint": "2023-05-30T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854192E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T05:00:00",
                                                "endPoint": "2023-05-30T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854228E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T06:00:00",
                                                "endPoint": "2023-05-30T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854264E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T07:00:00",
                                                "endPoint": "2023-05-30T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68543E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T08:00:00",
                                                "endPoint": "2023-05-30T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854336E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T09:00:00",
                                                "endPoint": "2023-05-30T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854372E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T10:00:00",
                                                "endPoint": "2023-05-30T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854408E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T11:00:00",
                                                "endPoint": "2023-05-30T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854444E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T12:00:00",
                                                "endPoint": "2023-05-30T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685448E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T13:00:00",
                                                "endPoint": "2023-05-30T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854516E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T14:00:00",
                                                "endPoint": "2023-05-30T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854552E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T15:00:00",
                                                "endPoint": "2023-05-30T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854588E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T16:00:00",
                                                "endPoint": "2023-05-30T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854624E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T17:00:00",
                                                "endPoint": "2023-05-30T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685466E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T18:00:00",
                                                "endPoint": "2023-05-30T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854696E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T19:00:00",
                                                "endPoint": "2023-05-30T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854732E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T20:00:00",
                                                "endPoint": "2023-05-30T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854768E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T21:00:00",
                                                "endPoint": "2023-05-30T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854804E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T22:00:00",
                                                "endPoint": "2023-05-30T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685484E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T23:00:00",
                                                "endPoint": "2023-05-31T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854876E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T00:00:00",
                                                "endPoint": "2023-05-31T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854912E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T01:00:00",
                                                "endPoint": "2023-05-31T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854948E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T02:00:00",
                                                "endPoint": "2023-05-31T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854984E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T03:00:00",
                                                "endPoint": "2023-05-31T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685502E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T04:00:00",
                                                "endPoint": "2023-05-31T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855056E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T05:00:00",
                                                "endPoint": "2023-05-31T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855092E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T06:00:00",
                                                "endPoint": "2023-05-31T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855128E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T07:00:00",
                                                "endPoint": "2023-05-31T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855164E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T08:00:00",
                                                "endPoint": "2023-05-31T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68552E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T09:00:00",
                                                "endPoint": "2023-05-31T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855236E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T10:00:00",
                                                "endPoint": "2023-05-31T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855272E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T11:00:00",
                                                "endPoint": "2023-05-31T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855308E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T12:00:00",
                                                "endPoint": "2023-05-31T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855344E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T13:00:00",
                                                "endPoint": "2023-05-31T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685538E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T14:00:00",
                                                "endPoint": "2023-05-31T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855416E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T15:00:00",
                                                "endPoint": "2023-05-31T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855452E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T16:00:00",
                                                "endPoint": "2023-05-31T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855488E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T17:00:00",
                                                "endPoint": "2023-05-31T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855524E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T18:00:00",
                                                "endPoint": "2023-05-31T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685556E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T19:00:00",
                                                "endPoint": "2023-05-31T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855596E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T20:00:00",
                                                "endPoint": "2023-05-31T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855632E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T21:00:00",
                                                "endPoint": "2023-05-31T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855668E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T22:00:00",
                                                "endPoint": "2023-05-31T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855704E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T23:00:00",
                                                "endPoint": "2023-06-01T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685574E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T00:00:00",
                                                "endPoint": "2023-06-01T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855776E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T01:00:00",
                                                "endPoint": "2023-06-01T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855812E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T02:00:00",
                                                "endPoint": "2023-06-01T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855848E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T03:00:00",
                                                "endPoint": "2023-06-01T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855884E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T04:00:00",
                                                "endPoint": "2023-06-01T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685592E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T05:00:00",
                                                "endPoint": "2023-06-01T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855956E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T06:00:00",
                                                "endPoint": "2023-06-01T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855992E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T07:00:00",
                                                "endPoint": "2023-06-01T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856028E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T08:00:00",
                                                "endPoint": "2023-06-01T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856064E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T09:00:00",
                                                "endPoint": "2023-06-01T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68561E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T10:00:00",
                                                "endPoint": "2023-06-01T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856136E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T11:00:00",
                                                "endPoint": "2023-06-01T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856172E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T12:00:00",
                                                "endPoint": "2023-06-01T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856208E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T13:00:00",
                                                "endPoint": "2023-06-01T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856244E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T14:00:00",
                                                "endPoint": "2023-06-01T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685628E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T15:00:00",
                                                "endPoint": "2023-06-01T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856316E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T16:00:00",
                                                "endPoint": "2023-06-01T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856352E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T17:00:00",
                                                "endPoint": "2023-06-01T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856388E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T18:00:00",
                                                "endPoint": "2023-06-01T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856424E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T19:00:00",
                                                "endPoint": "2023-06-01T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685646E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T20:00:00",
                                                "endPoint": "2023-06-01T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856496E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T21:00:00",
                                                "endPoint": "2023-06-01T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856532E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T22:00:00",
                                                "endPoint": "2023-06-01T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856568E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T23:00:00",
                                                "endPoint": "2023-06-02T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856604E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T00:00:00",
                                                "endPoint": "2023-06-02T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685664E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T01:00:00",
                                                "endPoint": "2023-06-02T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856676E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T02:00:00",
                                                "endPoint": "2023-06-02T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856712E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T03:00:00",
                                                "endPoint": "2023-06-02T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856748E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T04:00:00",
                                                "endPoint": "2023-06-02T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856784E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T05:00:00",
                                                "endPoint": "2023-06-02T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685682E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T06:00:00",
                                                "endPoint": "2023-06-02T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856856E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T07:00:00",
                                                "endPoint": "2023-06-02T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856892E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T08:00:00",
                                                "endPoint": "2023-06-02T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856928E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T09:00:00",
                                                "endPoint": "2023-06-02T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856964E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T10:00:00",
                                                "endPoint": "2023-06-02T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T11:00:00",
                                                "endPoint": "2023-06-02T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857036E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T12:00:00",
                                                "endPoint": "2023-06-02T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857072E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T13:00:00",
                                                "endPoint": "2023-06-02T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857108E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T14:00:00",
                                                "endPoint": "2023-06-02T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857144E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T15:00:00",
                                                "endPoint": "2023-06-02T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685718E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T16:00:00",
                                                "endPoint": "2023-06-02T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857216E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T17:00:00",
                                                "endPoint": "2023-06-02T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857252E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T18:00:00",
                                                "endPoint": "2023-06-02T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857288E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T19:00:00",
                                                "endPoint": "2023-06-02T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857324E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T20:00:00",
                                                "endPoint": "2023-06-02T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685736E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T21:00:00",
                                                "endPoint": "2023-06-02T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857396E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T22:00:00",
                                                "endPoint": "2023-06-02T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857432E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T23:00:00",
                                                "endPoint": "2023-06-03T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857468E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T00:00:00",
                                                "endPoint": "2023-06-03T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857504E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T01:00:00",
                                                "endPoint": "2023-06-03T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685754E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T02:00:00",
                                                "endPoint": "2023-06-03T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857576E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T03:00:00",
                                                "endPoint": "2023-06-03T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857612E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T04:00:00",
                                                "endPoint": "2023-06-03T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857648E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T05:00:00",
                                                "endPoint": "2023-06-03T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857684E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T06:00:00",
                                                "endPoint": "2023-06-03T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685772E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T07:00:00",
                                                "endPoint": "2023-06-03T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857756E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T08:00:00",
                                                "endPoint": "2023-06-03T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857792E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T09:00:00",
                                                "endPoint": "2023-06-03T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857828E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T10:00:00",
                                                "endPoint": "2023-06-03T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857864E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T11:00:00",
                                                "endPoint": "2023-06-03T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68579E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T12:00:00",
                                                "endPoint": "2023-06-03T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857936E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T13:00:00",
                                                "endPoint": "2023-06-03T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857972E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T14:00:00",
                                                "endPoint": "2023-06-03T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858008E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T15:00:00",
                                                "endPoint": "2023-06-03T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858044E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T16:00:00",
                                                "endPoint": "2023-06-03T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685808E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T17:00:00",
                                                "endPoint": "2023-06-03T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858116E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T18:00:00",
                                                "endPoint": "2023-06-03T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858152E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T19:00:00",
                                                "endPoint": "2023-06-03T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858188E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T20:00:00",
                                                "endPoint": "2023-06-03T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858224E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T21:00:00",
                                                "endPoint": "2023-06-03T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685826E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T22:00:00",
                                                "endPoint": "2023-06-03T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858296E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T23:00:00",
                                                "endPoint": "2023-06-04T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858332E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T00:00:00",
                                                "endPoint": "2023-06-04T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858368E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T01:00:00",
                                                "endPoint": "2023-06-04T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858404E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T02:00:00",
                                                "endPoint": "2023-06-04T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685844E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T03:00:00",
                                                "endPoint": "2023-06-04T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858476E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T04:00:00",
                                                "endPoint": "2023-06-04T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858512E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T05:00:00",
                                                "endPoint": "2023-06-04T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858548E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T06:00:00",
                                                "endPoint": "2023-06-04T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858584E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T07:00:00",
                                                "endPoint": "2023-06-04T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685862E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T08:00:00",
                                                "endPoint": "2023-06-04T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858656E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T09:00:00",
                                                "endPoint": "2023-06-04T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858692E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T10:00:00",
                                                "endPoint": "2023-06-04T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858728E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T11:00:00",
                                                "endPoint": "2023-06-04T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858764E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T12:00:00",
                                                "endPoint": "2023-06-04T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68588E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T13:00:00",
                                                "endPoint": "2023-06-04T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858836E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T14:00:00",
                                                "endPoint": "2023-06-04T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858872E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T15:00:00",
                                                "endPoint": "2023-06-04T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858908E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T16:00:00",
                                                "endPoint": "2023-06-04T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858944E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T17:00:00",
                                                "endPoint": "2023-06-04T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685898E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T18:00:00",
                                                "endPoint": "2023-06-04T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859016E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T19:00:00",
                                                "endPoint": "2023-06-04T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859052E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T20:00:00",
                                                "endPoint": "2023-06-04T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859088E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T21:00:00",
                                                "endPoint": "2023-06-04T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859124E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T22:00:00",
                                                "endPoint": "2023-06-04T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685916E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T23:00:00",
                                                "endPoint": "2023-06-05T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859196E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T00:00:00",
                                                "endPoint": "2023-06-05T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859232E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T01:00:00",
                                                "endPoint": "2023-06-05T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859268E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T02:00:00",
                                                "endPoint": "2023-06-05T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859304E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T03:00:00",
                                                "endPoint": "2023-06-05T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685934E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T04:00:00",
                                                "endPoint": "2023-06-05T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859376E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T05:00:00",
                                                "endPoint": "2023-06-05T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859412E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T06:00:00",
                                                "endPoint": "2023-06-05T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859448E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T07:00:00",
                                                "endPoint": "2023-06-05T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859484E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T08:00:00",
                                                "endPoint": "2023-06-05T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685952E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T09:00:00",
                                                "endPoint": "2023-06-05T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859556E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T10:00:00",
                                                "endPoint": "2023-06-05T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859592E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T11:00:00",
                                                "endPoint": "2023-06-05T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859628E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T12:00:00",
                                                "endPoint": "2023-06-05T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859664E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T13:00:00",
                                                "endPoint": "2023-06-05T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68597E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T14:00:00",
                                                "endPoint": "2023-06-05T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859736E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T15:00:00",
                                                "endPoint": "2023-06-05T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859772E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T16:00:00",
                                                "endPoint": "2023-06-05T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859808E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T17:00:00",
                                                "endPoint": "2023-06-05T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859844E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T18:00:00",
                                                "endPoint": "2023-06-05T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685988E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T19:00:00",
                                                "endPoint": "2023-06-05T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859916E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T20:00:00",
                                                "endPoint": "2023-06-05T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859952E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T21:00:00",
                                                "endPoint": "2023-06-05T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859988E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T22:00:00",
                                                "endPoint": "2023-06-05T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860024E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T23:00:00",
                                                "endPoint": "2023-06-06T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686006E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T00:00:00",
                                                "endPoint": "2023-06-06T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860096E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T01:00:00",
                                                "endPoint": "2023-06-06T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860132E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T02:00:00",
                                                "endPoint": "2023-06-06T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860168E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T03:00:00",
                                                "endPoint": "2023-06-06T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860204E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T04:00:00",
                                                "endPoint": "2023-06-06T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686024E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T05:00:00",
                                                "endPoint": "2023-06-06T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860276E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T06:00:00",
                                                "endPoint": "2023-06-06T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860312E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T07:00:00",
                                                "endPoint": "2023-06-06T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860348E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T08:00:00",
                                                "endPoint": "2023-06-06T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860384E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T09:00:00",
                                                "endPoint": "2023-06-06T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686042E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T10:00:00",
                                                "endPoint": "2023-06-06T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860456E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T11:00:00",
                                                "endPoint": "2023-06-06T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860492E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T12:00:00",
                                                "endPoint": "2023-06-06T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860528E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T13:00:00",
                                                "endPoint": "2023-06-06T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860564E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T14:00:00",
                                                "endPoint": "2023-06-06T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68606E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T15:00:00",
                                                "endPoint": "2023-06-06T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860636E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T16:00:00",
                                                "endPoint": "2023-06-06T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860672E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T17:00:00",
                                                "endPoint": "2023-06-06T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860708E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T18:00:00",
                                                "endPoint": "2023-06-06T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860744E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T19:00:00",
                                                "endPoint": "2023-06-06T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686078E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T20:00:00",
                                                "endPoint": "2023-06-06T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860816E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T21:00:00",
                                                "endPoint": "2023-06-06T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860852E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T22:00:00",
                                                "endPoint": "2023-06-06T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860888E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T23:00:00",
                                                "endPoint": "2023-06-07T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860924E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T00:00:00",
                                                "endPoint": "2023-06-07T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686096E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T01:00:00",
                                                "endPoint": "2023-06-07T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860996E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T02:00:00",
                                                "endPoint": "2023-06-07T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861032E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T03:00:00",
                                                "endPoint": "2023-06-07T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861068E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T04:00:00",
                                                "endPoint": "2023-06-07T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861104E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T05:00:00",
                                                "endPoint": "2023-06-07T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686114E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T06:00:00",
                                                "endPoint": "2023-06-07T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861176E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T07:00:00",
                                                "endPoint": "2023-06-07T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861212E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T08:00:00",
                                                "endPoint": "2023-06-07T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861248E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T09:00:00",
                                                "endPoint": "2023-06-07T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861284E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T10:00:00",
                                                "endPoint": "2023-06-07T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686132E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T11:00:00",
                                                "endPoint": "2023-06-07T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861356E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T12:00:00",
                                                "endPoint": "2023-06-07T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861392E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T13:00:00",
                                                "endPoint": "2023-06-07T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861428E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T14:00:00",
                                                "endPoint": "2023-06-07T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861464E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T15:00:00",
                                                "endPoint": "2023-06-07T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68615E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T16:00:00",
                                                "endPoint": "2023-06-07T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861536E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T17:00:00",
                                                "endPoint": "2023-06-07T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861572E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T18:00:00",
                                                "endPoint": "2023-06-07T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861608E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T19:00:00",
                                                "endPoint": "2023-06-07T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861644E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T20:00:00",
                                                "endPoint": "2023-06-07T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686168E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T21:00:00",
                                                "endPoint": "2023-06-07T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861716E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T22:00:00",
                                                "endPoint": "2023-06-07T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861752E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T23:00:00",
                                                "endPoint": "2023-06-08T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861788E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T00:00:00",
                                                "endPoint": "2023-06-08T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861824E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T01:00:00",
                                                "endPoint": "2023-06-08T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686186E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T02:00:00",
                                                "endPoint": "2023-06-08T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861896E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T03:00:00",
                                                "endPoint": "2023-06-08T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861932E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T04:00:00",
                                                "endPoint": "2023-06-08T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6861968E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T05:00:00",
                                                "endPoint": "2023-06-08T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862004E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T06:00:00",
                                                "endPoint": "2023-06-08T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686204E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T07:00:00",
                                                "endPoint": "2023-06-08T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862076E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T08:00:00",
                                                "endPoint": "2023-06-08T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862112E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T09:00:00",
                                                "endPoint": "2023-06-08T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862148E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T10:00:00",
                                                "endPoint": "2023-06-08T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862184E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T11:00:00",
                                                "endPoint": "2023-06-08T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686222E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T12:00:00",
                                                "endPoint": "2023-06-08T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862256E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T13:00:00",
                                                "endPoint": "2023-06-08T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862292E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T14:00:00",
                                                "endPoint": "2023-06-08T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862328E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T15:00:00",
                                                "endPoint": "2023-06-08T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862364E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T16:00:00",
                                                "endPoint": "2023-06-08T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68624E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T17:00:00",
                                                "endPoint": "2023-06-08T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862436E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T18:00:00",
                                                "endPoint": "2023-06-08T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862472E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T19:00:00",
                                                "endPoint": "2023-06-08T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862508E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T20:00:00",
                                                "endPoint": "2023-06-08T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862544E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T21:00:00",
                                                "endPoint": "2023-06-08T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686258E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T22:00:00",
                                                "endPoint": "2023-06-08T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862616E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T23:00:00",
                                                "endPoint": "2023-06-09T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862652E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T00:00:00",
                                                "endPoint": "2023-06-09T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862688E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T01:00:00",
                                                "endPoint": "2023-06-09T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862724E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T02:00:00",
                                                "endPoint": "2023-06-09T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686276E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T03:00:00",
                                                "endPoint": "2023-06-09T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862796E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T04:00:00",
                                                "endPoint": "2023-06-09T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862832E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T05:00:00",
                                                "endPoint": "2023-06-09T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862868E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T06:00:00",
                                                "endPoint": "2023-06-09T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862904E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T07:00:00",
                                                "endPoint": "2023-06-09T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686294E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T08:00:00",
                                                "endPoint": "2023-06-09T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862976E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T09:00:00",
                                                "endPoint": "2023-06-09T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863012E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T10:00:00",
                                                "endPoint": "2023-06-09T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863048E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T11:00:00",
                                                "endPoint": "2023-06-09T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863084E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T12:00:00",
                                                "endPoint": "2023-06-09T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686312E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T13:00:00",
                                                "endPoint": "2023-06-09T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863156E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T14:00:00",
                                                "endPoint": "2023-06-09T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863192E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T15:00:00",
                                                "endPoint": "2023-06-09T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863228E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T16:00:00",
                                                "endPoint": "2023-06-09T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863264E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T17:00:00",
                                                "endPoint": "2023-06-09T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68633E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T18:00:00",
                                                "endPoint": "2023-06-09T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863336E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T19:00:00",
                                                "endPoint": "2023-06-09T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863372E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T20:00:00",
                                                "endPoint": "2023-06-09T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863408E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T21:00:00",
                                                "endPoint": "2023-06-09T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863444E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T22:00:00",
                                                "endPoint": "2023-06-09T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686348E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T23:00:00",
                                                "endPoint": "2023-06-10T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863516E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T00:00:00",
                                                "endPoint": "2023-06-10T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863552E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T01:00:00",
                                                "endPoint": "2023-06-10T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863588E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T02:00:00",
                                                "endPoint": "2023-06-10T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863624E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T03:00:00",
                                                "endPoint": "2023-06-10T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686366E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T04:00:00",
                                                "endPoint": "2023-06-10T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863696E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T05:00:00",
                                                "endPoint": "2023-06-10T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863732E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T06:00:00",
                                                "endPoint": "2023-06-10T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863768E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T07:00:00",
                                                "endPoint": "2023-06-10T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863804E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T08:00:00",
                                                "endPoint": "2023-06-10T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686384E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T09:00:00",
                                                "endPoint": "2023-06-10T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863876E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T10:00:00",
                                                "endPoint": "2023-06-10T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863912E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T11:00:00",
                                                "endPoint": "2023-06-10T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863948E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T12:00:00",
                                                "endPoint": "2023-06-10T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863984E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T13:00:00",
                                                "endPoint": "2023-06-10T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686402E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T14:00:00",
                                                "endPoint": "2023-06-10T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864056E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T15:00:00",
                                                "endPoint": "2023-06-10T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864092E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T16:00:00",
                                                "endPoint": "2023-06-10T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864128E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T17:00:00",
                                                "endPoint": "2023-06-10T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864164E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T18:00:00",
                                                "endPoint": "2023-06-10T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68642E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T19:00:00",
                                                "endPoint": "2023-06-10T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864236E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T20:00:00",
                                                "endPoint": "2023-06-10T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864272E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T21:00:00",
                                                "endPoint": "2023-06-10T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864308E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T22:00:00",
                                                "endPoint": "2023-06-10T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864344E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T23:00:00",
                                                "endPoint": "2023-06-11T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686438E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T00:00:00",
                                                "endPoint": "2023-06-11T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864416E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T01:00:00",
                                                "endPoint": "2023-06-11T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864452E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T02:00:00",
                                                "endPoint": "2023-06-11T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864488E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T03:00:00",
                                                "endPoint": "2023-06-11T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864524E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T04:00:00",
                                                "endPoint": "2023-06-11T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686456E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T05:00:00",
                                                "endPoint": "2023-06-11T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864596E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T06:00:00",
                                                "endPoint": "2023-06-11T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864632E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T07:00:00",
                                                "endPoint": "2023-06-11T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864668E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T08:00:00",
                                                "endPoint": "2023-06-11T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864704E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T09:00:00",
                                                "endPoint": "2023-06-11T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686474E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T10:00:00",
                                                "endPoint": "2023-06-11T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864776E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T11:00:00",
                                                "endPoint": "2023-06-11T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864812E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T12:00:00",
                                                "endPoint": "2023-06-11T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864848E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T13:00:00",
                                                "endPoint": "2023-06-11T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864884E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T14:00:00",
                                                "endPoint": "2023-06-11T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686492E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T15:00:00",
                                                "endPoint": "2023-06-11T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864956E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T16:00:00",
                                                "endPoint": "2023-06-11T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864992E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T17:00:00",
                                                "endPoint": "2023-06-11T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865028E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T18:00:00",
                                                "endPoint": "2023-06-11T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865064E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T19:00:00",
                                                "endPoint": "2023-06-11T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68651E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T20:00:00",
                                                "endPoint": "2023-06-11T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865136E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T21:00:00",
                                                "endPoint": "2023-06-11T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865172E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T22:00:00",
                                                "endPoint": "2023-06-11T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865208E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T23:00:00",
                                                "endPoint": "2023-06-12T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865244E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T00:00:00",
                                                "endPoint": "2023-06-12T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686528E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T01:00:00",
                                                "endPoint": "2023-06-12T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865316E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T02:00:00",
                                                "endPoint": "2023-06-12T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865352E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T03:00:00",
                                                "endPoint": "2023-06-12T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865388E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T04:00:00",
                                                "endPoint": "2023-06-12T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865424E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T05:00:00",
                                                "endPoint": "2023-06-12T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686546E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T06:00:00",
                                                "endPoint": "2023-06-12T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865496E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T07:00:00",
                                                "endPoint": "2023-06-12T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865532E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T08:00:00",
                                                "endPoint": "2023-06-12T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865568E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T09:00:00",
                                                "endPoint": "2023-06-12T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865604E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T10:00:00",
                                                "endPoint": "2023-06-12T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686564E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T11:00:00",
                                                "endPoint": "2023-06-12T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865676E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T12:00:00",
                                                "endPoint": "2023-06-12T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865712E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T13:00:00",
                                                "endPoint": "2023-06-12T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865748E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T14:00:00",
                                                "endPoint": "2023-06-12T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865784E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T15:00:00",
                                                "endPoint": "2023-06-12T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686582E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T16:00:00",
                                                "endPoint": "2023-06-12T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865856E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T17:00:00",
                                                "endPoint": "2023-06-12T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865892E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T18:00:00",
                                                "endPoint": "2023-06-12T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865928E12
                                            }
                                        ]
                                    },
                                    {
                                        "name": "TV6",
                                        "totalASWI": 24.72,
                                        "totalDQI": 23.21,
                                        "pageSize": "10000000",
                                        "currentPage": "1",
                                        "totalRecord": 693.0,
                                        "records": [
                                            {
                                                "startPoint": "2023-05-22T23:00:00",
                                                "endPoint": "2023-05-23T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6847964E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T00:00:00",
                                                "endPoint": "2023-05-23T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T01:00:00",
                                                "endPoint": "2023-05-23T02:00:00",
                                                "aswi": 78.85121,
                                                "dqi": 86.11827,
                                                "frequency": "1.00091",
                                                "dataCount": "1100",
                                                "score_frequency": "10",
                                                "score_stale": "8.73636",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.88182",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "2501",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "43",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "455",
                                                "timestamp": 1.6848036E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T02:00:00",
                                                "endPoint": "2023-05-23T03:00:00",
                                                "aswi": 98.98824,
                                                "dqi": 96.66039,
                                                "frequency": "1",
                                                "dataCount": "3451",
                                                "score_frequency": "10",
                                                "score_stale": "8.98611",
                                                "score_dataGap": "9.58056",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.89278",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "151",
                                                "tt_dataGap": "151",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "39",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "381",
                                                "timestamp": 1.6848072E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T03:00:00",
                                                "endPoint": "2023-05-23T04:00:00",
                                                "aswi": 99.1204,
                                                "dqi": 97.28316,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.43655",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93335",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "24",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "563",
                                                "timestamp": 1.6848108E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T04:00:00",
                                                "endPoint": "2023-05-23T05:00:00",
                                                "aswi": 99.43336,
                                                "dqi": 98.19957,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.97806",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94168",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "21",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "368",
                                                "timestamp": 1.6848144E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T05:00:00",
                                                "endPoint": "2023-05-23T06:00:00",
                                                "aswi": 99.46346,
                                                "dqi": 98.28751,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.05027",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92224",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "28",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "342",
                                                "timestamp": 1.684818E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T06:00:00",
                                                "endPoint": "2023-05-23T07:00:00",
                                                "aswi": 99.50704,
                                                "dqi": 98.42173,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.11969",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93335",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "24",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "317",
                                                "timestamp": 1.6848216E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T07:00:00",
                                                "endPoint": "2023-05-23T08:00:00",
                                                "aswi": 99.5731,
                                                "dqi": 98.63927,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.23633",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "9.99722",
                                                "score_precision": "9.95001",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "1",
                                                "tt_precision": "18",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "275",
                                                "timestamp": 1.6848252E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T08:00:00",
                                                "endPoint": "2023-05-23T09:00:00",
                                                "aswi": 98.91854,
                                                "dqi": 96.72313,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.09498",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93891",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "22",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "686",
                                                "timestamp": 1.6848288E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T09:00:00",
                                                "endPoint": "2023-05-23T10:00:00",
                                                "aswi": 99.51449,
                                                "dqi": 98.44488,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.1308",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93613",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "23",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "313",
                                                "timestamp": 1.6848324E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T10:00:00",
                                                "endPoint": "2023-05-23T11:00:00",
                                                "aswi": 99.09851,
                                                "dqi": 97.21837,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.40878",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92224",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "28",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "573",
                                                "timestamp": 1.684836E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T11:00:00",
                                                "endPoint": "2023-05-23T12:00:00",
                                                "aswi": 98.58082,
                                                "dqi": 95.83449,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.55346",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94724",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "19",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "881",
                                                "timestamp": 1.6848396E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T12:00:00",
                                                "endPoint": "2023-05-23T13:00:00",
                                                "aswi": 98.42121,
                                                "dqi": 95.39017,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.38684",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.84726",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "55",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "941",
                                                "timestamp": 1.6848432E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T13:00:00",
                                                "endPoint": "2023-05-23T14:00:00",
                                                "aswi": 98.65102,
                                                "dqi": 96.015,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.66177",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94724",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "19",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "842",
                                                "timestamp": 1.6848468E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T14:00:00",
                                                "endPoint": "2023-05-23T15:00:00",
                                                "aswi": 98.78837,
                                                "dqi": 96.36675,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.89781",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92224",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "28",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "757",
                                                "timestamp": 1.6848504E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T15:00:00",
                                                "endPoint": "2023-05-23T16:00:00",
                                                "aswi": 98.99652,
                                                "dqi": 96.94066,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.21439",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95001",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "18",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "643",
                                                "timestamp": 1.684854E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T16:00:00",
                                                "endPoint": "2023-05-23T17:00:00",
                                                "aswi": 98.95892,
                                                "dqi": 96.82958,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.17273",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92502",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "27",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "658",
                                                "timestamp": 1.6848576E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T17:00:00",
                                                "endPoint": "2023-05-23T18:00:00",
                                                "aswi": 98.56507,
                                                "dqi": 95.72341,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.67288",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.76118",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "86",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "838",
                                                "timestamp": 1.6848612E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T18:00:00",
                                                "endPoint": "2023-05-23T19:00:00",
                                                "aswi": 98.55478,
                                                "dqi": 95.75581,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.5368",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.91669",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "30",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "887",
                                                "timestamp": 1.6848648E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T19:00:00",
                                                "endPoint": "2023-05-23T20:00:00",
                                                "aswi": 95.244,
                                                "dqi": 88.06661,
                                                "frequency": "1",
                                                "dataCount": "3424",
                                                "score_frequency": "10",
                                                "score_stale": "4.21944",
                                                "score_dataGap": "9.50556",
                                                "score_maxValue": "10",
                                                "score_minValue": "9.99708",
                                                "score_precision": "9.90946",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "178",
                                                "tt_dataGap": "178",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "1",
                                                "tt_precision": "33",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2188",
                                                "timestamp": 1.6848684E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T20:00:00",
                                                "endPoint": "2023-05-23T21:00:00",
                                                "aswi": 93.14867,
                                                "dqi": 87.30445,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "2.4299",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95279",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "17",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2725",
                                                "timestamp": 1.684872E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T21:00:00",
                                                "endPoint": "2023-05-23T22:00:00",
                                                "aswi": 91.63723,
                                                "dqi": 86.15199,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.76897",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "9.97778",
                                                "score_precision": "9.94446",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "8",
                                                "tt_precision": "20",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2963",
                                                "timestamp": 1.6848756E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T22:00:00",
                                                "endPoint": "2023-05-23T23:00:00",
                                                "aswi": 91.69908,
                                                "dqi": 82.22545,
                                                "frequency": "0.99969",
                                                "dataCount": "3249",
                                                "score_frequency": "9.9969",
                                                "score_stale": "2.18924",
                                                "score_dataGap": "9.01667",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95383",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "354",
                                                "tt_dataGap": "354",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "17",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3115",
                                                "timestamp": 1.6848792E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T23:00:00",
                                                "endPoint": "2023-05-24T00:00:00",
                                                "aswi": 89.2705,
                                                "dqi": 84.9764,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.03862",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94724",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "19",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3226",
                                                "timestamp": 1.6848828E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T00:00:00",
                                                "endPoint": "2023-05-24T01:00:00",
                                                "aswi": 91.27736,
                                                "dqi": 77.74541,
                                                "frequency": "0.99896",
                                                "dataCount": "2877",
                                                "score_frequency": "9.9896",
                                                "score_stale": "2.55337",
                                                "score_dataGap": "7.97778",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "728",
                                                "tt_dataGap": "728",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3351",
                                                "timestamp": 1.6848864E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T01:00:00",
                                                "endPoint": "2023-05-24T02:00:00",
                                                "aswi": 89.88226,
                                                "dqi": 84.60613,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.24412",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.51958",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "173",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3152",
                                                "timestamp": 1.68489E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T02:00:00",
                                                "endPoint": "2023-05-24T03:00:00",
                                                "aswi": 88.41909,
                                                "dqi": 84.23586,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.88311",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.65843",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "123",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3282",
                                                "timestamp": 1.6848936E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T03:00:00",
                                                "endPoint": "2023-05-24T04:00:00",
                                                "aswi": 89.69882,
                                                "dqi": 85.17079,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.14137",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.96112",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "14",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3189",
                                                "timestamp": 1.6848972E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T04:00:00",
                                                "endPoint": "2023-05-24T05:00:00",
                                                "aswi": 88.74534,
                                                "dqi": 84.80052,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.92199",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95834",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "15",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3268",
                                                "timestamp": 1.6849008E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T05:00:00",
                                                "endPoint": "2023-05-24T06:00:00",
                                                "aswi": 87.81836,
                                                "dqi": 84.40248,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.75259",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.88892",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "40",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3329",
                                                "timestamp": 1.6849044E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T06:00:00",
                                                "endPoint": "2023-05-24T07:00:00",
                                                "aswi": 87.28045,
                                                "dqi": 84.43025,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.65817",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3363",
                                                "timestamp": 1.684908E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T07:00:00",
                                                "endPoint": "2023-05-24T08:00:00",
                                                "aswi": 78.29843,
                                                "dqi": 83.4583,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.075",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3573",
                                                "timestamp": 1.6849116E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T08:00:00",
                                                "endPoint": "2023-05-24T09:00:00",
                                                "aswi": 89.52701,
                                                "dqi": 85.1569,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.09416",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3206",
                                                "timestamp": 1.6849152E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T09:00:00",
                                                "endPoint": "2023-05-24T10:00:00",
                                                "aswi": 92.52269,
                                                "dqi": 86.8555,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "2.11332",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2839",
                                                "timestamp": 1.6849188E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T10:00:00",
                                                "endPoint": "2023-05-24T11:00:00",
                                                "aswi": 90.77514,
                                                "dqi": 81.59377,
                                                "frequency": "0.99969",
                                                "dataCount": "3253",
                                                "score_frequency": "9.9969",
                                                "score_stale": "1.77523",
                                                "score_dataGap": "9.02778",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "350",
                                                "tt_dataGap": "350",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3276",
                                                "timestamp": 1.6849224E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T11:00:00",
                                                "endPoint": "2023-05-24T12:00:00",
                                                "aswi": 62.10073,
                                                "dqi": 72.51015,
                                                "frequency": "1.00081",
                                                "dataCount": "1237",
                                                "score_frequency": "10",
                                                "score_stale": "0.07277",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "2364",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3574",
                                                "timestamp": 1.684926E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T12:00:00",
                                                "endPoint": "2023-05-24T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849296E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T13:00:00",
                                                "endPoint": "2023-05-24T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849332E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T14:00:00",
                                                "endPoint": "2023-05-24T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849368E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T15:00:00",
                                                "endPoint": "2023-05-24T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849404E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T16:00:00",
                                                "endPoint": "2023-05-24T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684944E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T17:00:00",
                                                "endPoint": "2023-05-24T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849476E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T18:00:00",
                                                "endPoint": "2023-05-24T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849512E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T19:00:00",
                                                "endPoint": "2023-05-24T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849548E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T20:00:00",
                                                "endPoint": "2023-05-24T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849584E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T21:00:00",
                                                "endPoint": "2023-05-24T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684962E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T22:00:00",
                                                "endPoint": "2023-05-24T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849656E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T23:00:00",
                                                "endPoint": "2023-05-25T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849692E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T00:00:00",
                                                "endPoint": "2023-05-25T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849728E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T01:00:00",
                                                "endPoint": "2023-05-25T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849764E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T02:00:00",
                                                "endPoint": "2023-05-25T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68498E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T03:00:00",
                                                "endPoint": "2023-05-25T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849836E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T04:00:00",
                                                "endPoint": "2023-05-25T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849872E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T05:00:00",
                                                "endPoint": "2023-05-25T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849908E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T06:00:00",
                                                "endPoint": "2023-05-25T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849944E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T07:00:00",
                                                "endPoint": "2023-05-25T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684998E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T08:00:00",
                                                "endPoint": "2023-05-25T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850016E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T09:00:00",
                                                "endPoint": "2023-05-25T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850052E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T10:00:00",
                                                "endPoint": "2023-05-25T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850088E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T11:00:00",
                                                "endPoint": "2023-05-25T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850124E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T12:00:00",
                                                "endPoint": "2023-05-25T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685016E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T13:00:00",
                                                "endPoint": "2023-05-25T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850196E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T14:00:00",
                                                "endPoint": "2023-05-25T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850232E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T15:00:00",
                                                "endPoint": "2023-05-25T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850268E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T16:00:00",
                                                "endPoint": "2023-05-25T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850304E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T17:00:00",
                                                "endPoint": "2023-05-25T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685034E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T18:00:00",
                                                "endPoint": "2023-05-25T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850376E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T19:00:00",
                                                "endPoint": "2023-05-25T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850412E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T20:00:00",
                                                "endPoint": "2023-05-25T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850448E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T21:00:00",
                                                "endPoint": "2023-05-25T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850484E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T22:00:00",
                                                "endPoint": "2023-05-25T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685052E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T23:00:00",
                                                "endPoint": "2023-05-26T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850556E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T00:00:00",
                                                "endPoint": "2023-05-26T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850592E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T01:00:00",
                                                "endPoint": "2023-05-26T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850628E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T02:00:00",
                                                "endPoint": "2023-05-26T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850664E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T03:00:00",
                                                "endPoint": "2023-05-26T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68507E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T04:00:00",
                                                "endPoint": "2023-05-26T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850736E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T05:00:00",
                                                "endPoint": "2023-05-26T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850772E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T06:00:00",
                                                "endPoint": "2023-05-26T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850808E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T07:00:00",
                                                "endPoint": "2023-05-26T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850844E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T08:00:00",
                                                "endPoint": "2023-05-26T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685088E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T09:00:00",
                                                "endPoint": "2023-05-26T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850916E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T10:00:00",
                                                "endPoint": "2023-05-26T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850952E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T11:00:00",
                                                "endPoint": "2023-05-26T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850988E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T12:00:00",
                                                "endPoint": "2023-05-26T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851024E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T13:00:00",
                                                "endPoint": "2023-05-26T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685106E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T14:00:00",
                                                "endPoint": "2023-05-26T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851096E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T15:00:00",
                                                "endPoint": "2023-05-26T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851132E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T16:00:00",
                                                "endPoint": "2023-05-26T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851168E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T17:00:00",
                                                "endPoint": "2023-05-26T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851204E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T18:00:00",
                                                "endPoint": "2023-05-26T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685124E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T19:00:00",
                                                "endPoint": "2023-05-26T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851276E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T20:00:00",
                                                "endPoint": "2023-05-26T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851312E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T21:00:00",
                                                "endPoint": "2023-05-26T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851348E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T22:00:00",
                                                "endPoint": "2023-05-26T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851384E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T23:00:00",
                                                "endPoint": "2023-05-27T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685142E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T00:00:00",
                                                "endPoint": "2023-05-27T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851456E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T01:00:00",
                                                "endPoint": "2023-05-27T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851492E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T02:00:00",
                                                "endPoint": "2023-05-27T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851528E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T03:00:00",
                                                "endPoint": "2023-05-27T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851564E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T04:00:00",
                                                "endPoint": "2023-05-27T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68516E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T05:00:00",
                                                "endPoint": "2023-05-27T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851636E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T06:00:00",
                                                "endPoint": "2023-05-27T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851672E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T07:00:00",
                                                "endPoint": "2023-05-27T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851708E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T08:00:00",
                                                "endPoint": "2023-05-27T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851744E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T09:00:00",
                                                "endPoint": "2023-05-27T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685178E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T10:00:00",
                                                "endPoint": "2023-05-27T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851816E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T11:00:00",
                                                "endPoint": "2023-05-27T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851852E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T12:00:00",
                                                "endPoint": "2023-05-27T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851888E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T13:00:00",
                                                "endPoint": "2023-05-27T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851924E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T14:00:00",
                                                "endPoint": "2023-05-27T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685196E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T15:00:00",
                                                "endPoint": "2023-05-27T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851996E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T16:00:00",
                                                "endPoint": "2023-05-27T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852032E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T17:00:00",
                                                "endPoint": "2023-05-27T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852068E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T18:00:00",
                                                "endPoint": "2023-05-27T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852104E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T19:00:00",
                                                "endPoint": "2023-05-27T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685214E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T20:00:00",
                                                "endPoint": "2023-05-27T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852176E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T21:00:00",
                                                "endPoint": "2023-05-27T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852212E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T22:00:00",
                                                "endPoint": "2023-05-27T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852248E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T23:00:00",
                                                "endPoint": "2023-05-28T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852284E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T00:00:00",
                                                "endPoint": "2023-05-28T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685232E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T01:00:00",
                                                "endPoint": "2023-05-28T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852356E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T02:00:00",
                                                "endPoint": "2023-05-28T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852392E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T03:00:00",
                                                "endPoint": "2023-05-28T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852428E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T04:00:00",
                                                "endPoint": "2023-05-28T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852464E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T05:00:00",
                                                "endPoint": "2023-05-28T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68525E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T06:00:00",
                                                "endPoint": "2023-05-28T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852536E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T07:00:00",
                                                "endPoint": "2023-05-28T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852572E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T08:00:00",
                                                "endPoint": "2023-05-28T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852608E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T09:00:00",
                                                "endPoint": "2023-05-28T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852644E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T10:00:00",
                                                "endPoint": "2023-05-28T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685268E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T11:00:00",
                                                "endPoint": "2023-05-28T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852716E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T12:00:00",
                                                "endPoint": "2023-05-28T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852752E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T13:00:00",
                                                "endPoint": "2023-05-28T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852788E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T14:00:00",
                                                "endPoint": "2023-05-28T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852824E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T15:00:00",
                                                "endPoint": "2023-05-28T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685286E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T16:00:00",
                                                "endPoint": "2023-05-28T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852896E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T17:00:00",
                                                "endPoint": "2023-05-28T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852932E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T18:00:00",
                                                "endPoint": "2023-05-28T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852968E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T19:00:00",
                                                "endPoint": "2023-05-28T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853004E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T20:00:00",
                                                "endPoint": "2023-05-28T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685304E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T21:00:00",
                                                "endPoint": "2023-05-28T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853076E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T22:00:00",
                                                "endPoint": "2023-05-28T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853112E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T23:00:00",
                                                "endPoint": "2023-05-29T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853148E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T00:00:00",
                                                "endPoint": "2023-05-29T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853184E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T01:00:00",
                                                "endPoint": "2023-05-29T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685322E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T02:00:00",
                                                "endPoint": "2023-05-29T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853256E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T03:00:00",
                                                "endPoint": "2023-05-29T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853292E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T04:00:00",
                                                "endPoint": "2023-05-29T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853328E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T05:00:00",
                                                "endPoint": "2023-05-29T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853364E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T06:00:00",
                                                "endPoint": "2023-05-29T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68534E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T07:00:00",
                                                "endPoint": "2023-05-29T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853436E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T08:00:00",
                                                "endPoint": "2023-05-29T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853472E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T09:00:00",
                                                "endPoint": "2023-05-29T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853508E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T10:00:00",
                                                "endPoint": "2023-05-29T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853544E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T11:00:00",
                                                "endPoint": "2023-05-29T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685358E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T12:00:00",
                                                "endPoint": "2023-05-29T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853616E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T13:00:00",
                                                "endPoint": "2023-05-29T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853652E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T14:00:00",
                                                "endPoint": "2023-05-29T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853688E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T15:00:00",
                                                "endPoint": "2023-05-29T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853724E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T16:00:00",
                                                "endPoint": "2023-05-29T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685376E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T17:00:00",
                                                "endPoint": "2023-05-29T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853796E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T18:00:00",
                                                "endPoint": "2023-05-29T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853832E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T19:00:00",
                                                "endPoint": "2023-05-29T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853868E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T20:00:00",
                                                "endPoint": "2023-05-29T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853904E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T21:00:00",
                                                "endPoint": "2023-05-29T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685394E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T22:00:00",
                                                "endPoint": "2023-05-29T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853976E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T23:00:00",
                                                "endPoint": "2023-05-30T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854012E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T00:00:00",
                                                "endPoint": "2023-05-30T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854048E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T01:00:00",
                                                "endPoint": "2023-05-30T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854084E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T02:00:00",
                                                "endPoint": "2023-05-30T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685412E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T03:00:00",
                                                "endPoint": "2023-05-30T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854156E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T04:00:00",
                                                "endPoint": "2023-05-30T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854192E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T05:00:00",
                                                "endPoint": "2023-05-30T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854228E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T06:00:00",
                                                "endPoint": "2023-05-30T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854264E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T07:00:00",
                                                "endPoint": "2023-05-30T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68543E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T08:00:00",
                                                "endPoint": "2023-05-30T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854336E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T09:00:00",
                                                "endPoint": "2023-05-30T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854372E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T10:00:00",
                                                "endPoint": "2023-05-30T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854408E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T11:00:00",
                                                "endPoint": "2023-05-30T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854444E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T12:00:00",
                                                "endPoint": "2023-05-30T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685448E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T13:00:00",
                                                "endPoint": "2023-05-30T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854516E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T14:00:00",
                                                "endPoint": "2023-05-30T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854552E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T15:00:00",
                                                "endPoint": "2023-05-30T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854588E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T16:00:00",
                                                "endPoint": "2023-05-30T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854624E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T17:00:00",
                                                "endPoint": "2023-05-30T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685466E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T18:00:00",
                                                "endPoint": "2023-05-30T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854696E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T19:00:00",
                                                "endPoint": "2023-05-30T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854732E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T20:00:00",
                                                "endPoint": "2023-05-30T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854768E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T21:00:00",
                                                "endPoint": "2023-05-30T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854804E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T22:00:00",
                                                "endPoint": "2023-05-30T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685484E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T23:00:00",
                                                "endPoint": "2023-05-31T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854876E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T00:00:00",
                                                "endPoint": "2023-05-31T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854912E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T01:00:00",
                                                "endPoint": "2023-05-31T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854948E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T02:00:00",
                                                "endPoint": "2023-05-31T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854984E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T03:00:00",
                                                "endPoint": "2023-05-31T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685502E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T04:00:00",
                                                "endPoint": "2023-05-31T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855056E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T05:00:00",
                                                "endPoint": "2023-05-31T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855092E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T06:00:00",
                                                "endPoint": "2023-05-31T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855128E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T07:00:00",
                                                "endPoint": "2023-05-31T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855164E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T08:00:00",
                                                "endPoint": "2023-05-31T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68552E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T09:00:00",
                                                "endPoint": "2023-05-31T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855236E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T10:00:00",
                                                "endPoint": "2023-05-31T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855272E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T11:00:00",
                                                "endPoint": "2023-05-31T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855308E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T12:00:00",
                                                "endPoint": "2023-05-31T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855344E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T13:00:00",
                                                "endPoint": "2023-05-31T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685538E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T14:00:00",
                                                "endPoint": "2023-05-31T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855416E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T15:00:00",
                                                "endPoint": "2023-05-31T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855452E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T16:00:00",
                                                "endPoint": "2023-05-31T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855488E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T17:00:00",
                                                "endPoint": "2023-05-31T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855524E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T18:00:00",
                                                "endPoint": "2023-05-31T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685556E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T19:00:00",
                                                "endPoint": "2023-05-31T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855596E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T20:00:00",
                                                "endPoint": "2023-05-31T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855632E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T21:00:00",
                                                "endPoint": "2023-05-31T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855668E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T22:00:00",
                                                "endPoint": "2023-05-31T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855704E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T23:00:00",
                                                "endPoint": "2023-06-01T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685574E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T00:00:00",
                                                "endPoint": "2023-06-01T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855776E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T01:00:00",
                                                "endPoint": "2023-06-01T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855812E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T02:00:00",
                                                "endPoint": "2023-06-01T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855848E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T03:00:00",
                                                "endPoint": "2023-06-01T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855884E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T04:00:00",
                                                "endPoint": "2023-06-01T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685592E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T05:00:00",
                                                "endPoint": "2023-06-01T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855956E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T06:00:00",
                                                "endPoint": "2023-06-01T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855992E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T07:00:00",
                                                "endPoint": "2023-06-01T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856028E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T08:00:00",
                                                "endPoint": "2023-06-01T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856064E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T09:00:00",
                                                "endPoint": "2023-06-01T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68561E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T10:00:00",
                                                "endPoint": "2023-06-01T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856136E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T11:00:00",
                                                "endPoint": "2023-06-01T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856172E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T12:00:00",
                                                "endPoint": "2023-06-01T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856208E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T13:00:00",
                                                "endPoint": "2023-06-01T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856244E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T14:00:00",
                                                "endPoint": "2023-06-01T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685628E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T15:00:00",
                                                "endPoint": "2023-06-01T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856316E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T16:00:00",
                                                "endPoint": "2023-06-01T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856352E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T17:00:00",
                                                "endPoint": "2023-06-01T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856388E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T18:00:00",
                                                "endPoint": "2023-06-01T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856424E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T19:00:00",
                                                "endPoint": "2023-06-01T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685646E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T20:00:00",
                                                "endPoint": "2023-06-01T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856496E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T21:00:00",
                                                "endPoint": "2023-06-01T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856532E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T22:00:00",
                                                "endPoint": "2023-06-01T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856568E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T23:00:00",
                                                "endPoint": "2023-06-02T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856604E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T00:00:00",
                                                "endPoint": "2023-06-02T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685664E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T01:00:00",
                                                "endPoint": "2023-06-02T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856676E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T02:00:00",
                                                "endPoint": "2023-06-02T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856712E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T03:00:00",
                                                "endPoint": "2023-06-02T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856748E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T04:00:00",
                                                "endPoint": "2023-06-02T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856784E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T05:00:00",
                                                "endPoint": "2023-06-02T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685682E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T06:00:00",
                                                "endPoint": "2023-06-02T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856856E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T07:00:00",
                                                "endPoint": "2023-06-02T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856892E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T08:00:00",
                                                "endPoint": "2023-06-02T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856928E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T09:00:00",
                                                "endPoint": "2023-06-02T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856964E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T10:00:00",
                                                "endPoint": "2023-06-02T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T11:00:00",
                                                "endPoint": "2023-06-02T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857036E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T12:00:00",
                                                "endPoint": "2023-06-02T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857072E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T13:00:00",
                                                "endPoint": "2023-06-02T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857108E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T14:00:00",
                                                "endPoint": "2023-06-02T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857144E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T15:00:00",
                                                "endPoint": "2023-06-02T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685718E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T16:00:00",
                                                "endPoint": "2023-06-02T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857216E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T17:00:00",
                                                "endPoint": "2023-06-02T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857252E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T18:00:00",
                                                "endPoint": "2023-06-02T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857288E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T19:00:00",
                                                "endPoint": "2023-06-02T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857324E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T20:00:00",
                                                "endPoint": "2023-06-02T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685736E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T21:00:00",
                                                "endPoint": "2023-06-02T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857396E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T22:00:00",
                                                "endPoint": "2023-06-02T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857432E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T23:00:00",
                                                "endPoint": "2023-06-03T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857468E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T00:00:00",
                                                "endPoint": "2023-06-03T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857504E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T01:00:00",
                                                "endPoint": "2023-06-03T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685754E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T02:00:00",
                                                "endPoint": "2023-06-03T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857576E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T03:00:00",
                                                "endPoint": "2023-06-03T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857612E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T04:00:00",
                                                "endPoint": "2023-06-03T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857648E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T05:00:00",
                                                "endPoint": "2023-06-03T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857684E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T06:00:00",
                                                "endPoint": "2023-06-03T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685772E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T07:00:00",
                                                "endPoint": "2023-06-03T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857756E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T08:00:00",
                                                "endPoint": "2023-06-03T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857792E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T09:00:00",
                                                "endPoint": "2023-06-03T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857828E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T10:00:00",
                                                "endPoint": "2023-06-03T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857864E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T11:00:00",
                                                "endPoint": "2023-06-03T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68579E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T12:00:00",
                                                "endPoint": "2023-06-03T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857936E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T13:00:00",
                                                "endPoint": "2023-06-03T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857972E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T14:00:00",
                                                "endPoint": "2023-06-03T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858008E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T15:00:00",
                                                "endPoint": "2023-06-03T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858044E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T16:00:00",
                                                "endPoint": "2023-06-03T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685808E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T17:00:00",
                                                "endPoint": "2023-06-03T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858116E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T18:00:00",
                                                "endPoint": "2023-06-03T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858152E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T19:00:00",
                                                "endPoint": "2023-06-03T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858188E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T20:00:00",
                                                "endPoint": "2023-06-03T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858224E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T21:00:00",
                                                "endPoint": "2023-06-03T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685826E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T22:00:00",
                                                "endPoint": "2023-06-03T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858296E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T23:00:00",
                                                "endPoint": "2023-06-04T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858332E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T00:00:00",
                                                "endPoint": "2023-06-04T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858368E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T01:00:00",
                                                "endPoint": "2023-06-04T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858404E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T02:00:00",
                                                "endPoint": "2023-06-04T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685844E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T03:00:00",
                                                "endPoint": "2023-06-04T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858476E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T04:00:00",
                                                "endPoint": "2023-06-04T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858512E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T05:00:00",
                                                "endPoint": "2023-06-04T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858548E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T06:00:00",
                                                "endPoint": "2023-06-04T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858584E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T07:00:00",
                                                "endPoint": "2023-06-04T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685862E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T08:00:00",
                                                "endPoint": "2023-06-04T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858656E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T09:00:00",
                                                "endPoint": "2023-06-04T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858692E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T10:00:00",
                                                "endPoint": "2023-06-04T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858728E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T11:00:00",
                                                "endPoint": "2023-06-04T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858764E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T12:00:00",
                                                "endPoint": "2023-06-04T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68588E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T13:00:00",
                                                "endPoint": "2023-06-04T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858836E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T14:00:00",
                                                "endPoint": "2023-06-04T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858872E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T15:00:00",
                                                "endPoint": "2023-06-04T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858908E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T16:00:00",
                                                "endPoint": "2023-06-04T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858944E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T17:00:00",
                                                "endPoint": "2023-06-04T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685898E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T18:00:00",
                                                "endPoint": "2023-06-04T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859016E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T19:00:00",
                                                "endPoint": "2023-06-04T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859052E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T20:00:00",
                                                "endPoint": "2023-06-04T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859088E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T21:00:00",
                                                "endPoint": "2023-06-04T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859124E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T22:00:00",
                                                "endPoint": "2023-06-04T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685916E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T23:00:00",
                                                "endPoint": "2023-06-05T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859196E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T00:00:00",
                                                "endPoint": "2023-06-05T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859232E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T01:00:00",
                                                "endPoint": "2023-06-05T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859268E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T02:00:00",
                                                "endPoint": "2023-06-05T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859304E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T03:00:00",
                                                "endPoint": "2023-06-05T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685934E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T04:00:00",
                                                "endPoint": "2023-06-05T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859376E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T05:00:00",
                                                "endPoint": "2023-06-05T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859412E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T06:00:00",
                                                "endPoint": "2023-06-05T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859448E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T07:00:00",
                                                "endPoint": "2023-06-05T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859484E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T08:00:00",
                                                "endPoint": "2023-06-05T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685952E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T09:00:00",
                                                "endPoint": "2023-06-05T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859556E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T10:00:00",
                                                "endPoint": "2023-06-05T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859592E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T11:00:00",
                                                "endPoint": "2023-06-05T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859628E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T12:00:00",
                                                "endPoint": "2023-06-05T13:00:00",
                                                "aswi": 94.29111,
                                                "dqi": 90.73029,
                                                "frequency": "1.00037",
                                                "dataCount": "2701",
                                                "score_frequency": "10",
                                                "score_stale": "6.95668",
                                                "score_dataGap": "6.66667",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98149",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "900",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "7",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1096",
                                                "timestamp": 1.6859664E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T13:00:00",
                                                "endPoint": "2023-06-05T14:00:00",
                                                "aswi": 98.26445,
                                                "dqi": 95.07081,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.0536",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98889",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1061",
                                                "timestamp": 1.68597E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T14:00:00",
                                                "endPoint": "2023-06-05T15:00:00",
                                                "aswi": 96.61042,
                                                "dqi": 88.83414,
                                                "frequency": "1",
                                                "dataCount": "2882",
                                                "score_frequency": "10",
                                                "score_stale": "7.9",
                                                "score_dataGap": "8",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92366",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "720",
                                                "tt_dataGap": "720",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "27",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "944",
                                                "timestamp": 1.6859736E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T15:00:00",
                                                "endPoint": "2023-06-05T16:00:00",
                                                "aswi": 96.66823,
                                                "dqi": 91.53476,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.25133",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.66954",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "119",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1710",
                                                "timestamp": 1.6859772E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T16:00:00",
                                                "endPoint": "2023-06-05T17:00:00",
                                                "aswi": 99.01439,
                                                "dqi": 96.98695,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.29492",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "9.99722",
                                                "score_precision": "9.90003",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "1",
                                                "tt_precision": "36",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "614",
                                                "timestamp": 1.6859808E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T17:00:00",
                                                "endPoint": "2023-06-05T18:00:00",
                                                "aswi": 99.39811,
                                                "dqi": 98.08387,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.96973",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.88059",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "43",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "371",
                                                "timestamp": 1.6859844E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T18:00:00",
                                                "endPoint": "2023-06-05T19:00:00",
                                                "aswi": 98.91118,
                                                "dqi": 96.69536,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.10331",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.91391",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "31",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "683",
                                                "timestamp": 1.685988E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T19:00:00",
                                                "endPoint": "2023-06-05T20:00:00",
                                                "aswi": 99.17304,
                                                "dqi": 97.43056,
                                                "frequency": "1",
                                                "dataCount": "3600",
                                                "score_frequency": "10",
                                                "score_stale": "8.53611",
                                                "score_dataGap": "9.99444",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93333",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "2",
                                                "tt_dataGap": "2",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "24",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "527",
                                                "timestamp": 1.6859916E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T20:00:00",
                                                "endPoint": "2023-06-05T21:00:00",
                                                "aswi": 99.36879,
                                                "dqi": 98.00056,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.89198",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.90836",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "33",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "399",
                                                "timestamp": 1.6859952E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T21:00:00",
                                                "endPoint": "2023-06-05T22:00:00",
                                                "aswi": 95.78968,
                                                "dqi": 90.248,
                                                "frequency": "1.00028",
                                                "dataCount": "3552",
                                                "score_frequency": "10",
                                                "score_stale": "4.40033",
                                                "score_dataGap": "9.86201",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.88457",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "49",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "42",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2016",
                                                "timestamp": 1.6859988E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T22:00:00",
                                                "endPoint": "2023-06-05T23:00:00",
                                                "aswi": 71.58043,
                                                "dqi": 68.75917,
                                                "frequency": "0.98089",
                                                "dataCount": "159",
                                                "score_frequency": "9.8089",
                                                "score_stale": "1.4552",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "19",
                                                "tt_dataGap": "3446",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3283",
                                                "timestamp": 1.6860024E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T23:00:00",
                                                "endPoint": "2023-06-06T00:00:00",
                                                "aswi": 95.10189,
                                                "dqi": 89.18872,
                                                "frequency": "0.99929",
                                                "dataCount": "2817",
                                                "score_frequency": "9.9929",
                                                "score_stale": "6.70574",
                                                "score_dataGap": "7.42726",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.9574",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "246",
                                                "tt_dataGap": "787",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "15",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1287",
                                                "timestamp": 1.686006E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T00:00:00",
                                                "endPoint": "2023-06-06T01:00:00",
                                                "aswi": 98.27641,
                                                "dqi": 95.02916,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.17857",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.83893",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "58",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1016",
                                                "timestamp": 1.6860096E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T01:00:00",
                                                "endPoint": "2023-06-06T02:00:00",
                                                "aswi": 98.43916,
                                                "dqi": 95.45959,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.37018",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.90558",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "34",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "947",
                                                "timestamp": 1.6860132E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T02:00:00",
                                                "endPoint": "2023-06-06T03:00:00",
                                                "aswi": 98.3077,
                                                "dqi": 95.12173,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.19801",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.87503",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "45",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1009",
                                                "timestamp": 1.6860168E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T03:00:00",
                                                "endPoint": "2023-06-06T04:00:00",
                                                "aswi": 97.45539,
                                                "dqi": 93.2241,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.02889",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.90558",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "34",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1430",
                                                "timestamp": 1.6860204E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T04:00:00",
                                                "endPoint": "2023-06-06T05:00:00",
                                                "aswi": 95.43603,
                                                "dqi": 89.78062,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.96836",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.90003",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "36",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2171",
                                                "timestamp": 1.686024E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T05:00:00",
                                                "endPoint": "2023-06-06T06:00:00",
                                                "aswi": 96.13792,
                                                "dqi": 90.85439,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.57929",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93335",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "24",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1951",
                                                "timestamp": 1.6860276E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T06:00:00",
                                                "endPoint": "2023-06-06T07:00:00",
                                                "aswi": 97.30738,
                                                "dqi": 92.92326,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.84838",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.90558",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "34",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1495",
                                                "timestamp": 1.6860312E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T07:00:00",
                                                "endPoint": "2023-06-06T08:00:00",
                                                "aswi": 98.15412,
                                                "dqi": 94.73757,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.99806",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.84449",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "56",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1081",
                                                "timestamp": 1.6860348E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T08:00:00",
                                                "endPoint": "2023-06-06T09:00:00",
                                                "aswi": 98.56793,
                                                "dqi": 95.78358,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.59512",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "9.99722",
                                                "score_precision": "9.87781",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "1",
                                                "tt_precision": "44",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "866",
                                                "timestamp": 1.6860384E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T09:00:00",
                                                "endPoint": "2023-06-06T10:00:00",
                                                "aswi": 99.29605,
                                                "dqi": 97.75525,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.9253",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.72785",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "98",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "387",
                                                "timestamp": 1.686042E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T10:00:00",
                                                "endPoint": "2023-06-06T11:00:00",
                                                "aswi": 99.50577,
                                                "dqi": 98.42636,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.06415",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99167",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "337",
                                                "timestamp": 1.6860456E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T11:00:00",
                                                "endPoint": "2023-06-06T12:00:00",
                                                "aswi": 99.40192,
                                                "dqi": 98.08849,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.01972",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.83338",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "60",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "353",
                                                "timestamp": 1.6860492E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T12:00:00",
                                                "endPoint": "2023-06-06T13:00:00",
                                                "aswi": 98.95264,
                                                "dqi": 96.80181,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.19217",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.88892",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "40",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "651",
                                                "timestamp": 1.6860528E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T13:00:00",
                                                "endPoint": "2023-06-06T14:00:00",
                                                "aswi": 98.85139,
                                                "dqi": 96.5056,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.07832",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.82505",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "63",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "692",
                                                "timestamp": 1.6860564E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T14:00:00",
                                                "endPoint": "2023-06-06T15:00:00",
                                                "aswi": 98.88018,
                                                "dqi": 96.59817,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.08665",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.87226",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "46",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "689",
                                                "timestamp": 1.68606E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T15:00:00",
                                                "endPoint": "2023-06-06T16:00:00",
                                                "aswi": 99.26412,
                                                "dqi": 97.6812,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.75313",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.8556",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "52",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "449",
                                                "timestamp": 1.6860636E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T16:00:00",
                                                "endPoint": "2023-06-06T17:00:00",
                                                "aswi": 99.30252,
                                                "dqi": 97.78986,
                                                "frequency": "1",
                                                "dataCount": "3597",
                                                "score_frequency": "10",
                                                "score_stale": "8.83333",
                                                "score_dataGap": "9.98611",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.86934",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "5",
                                                "tt_dataGap": "5",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "47",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "420",
                                                "timestamp": 1.6860672E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T17:00:00",
                                                "endPoint": "2023-06-06T18:00:00",
                                                "aswi": 99.27558,
                                                "dqi": 97.70897,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.80311",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.82227",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "64",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "431",
                                                "timestamp": 1.6860708E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T18:00:00",
                                                "endPoint": "2023-06-06T19:00:00",
                                                "aswi": 99.32618,
                                                "dqi": 97.87096,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.83088",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.8917",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "39",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "421",
                                                "timestamp": 1.6860744E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T19:00:00",
                                                "endPoint": "2023-06-06T20:00:00",
                                                "aswi": 99.56463,
                                                "dqi": 98.60687,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.1669",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99722",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "1",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "300",
                                                "timestamp": 1.686078E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T20:00:00",
                                                "endPoint": "2023-06-06T21:00:00",
                                                "aswi": 99.63801,
                                                "dqi": 98.83366,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.30297",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99722",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "1",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "251",
                                                "timestamp": 1.6860816E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T21:00:00",
                                                "endPoint": "2023-06-06T22:00:00",
                                                "aswi": 99.60658,
                                                "dqi": 98.73646,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.24188",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "273",
                                                "timestamp": 1.6860852E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T22:00:00",
                                                "endPoint": "2023-06-06T23:00:00",
                                                "aswi": 99.52084,
                                                "dqi": 98.54207,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.17801",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "9.98334",
                                                "score_precision": "9.9639",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "6",
                                                "tt_precision": "13",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "296",
                                                "timestamp": 1.6860888E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T23:00:00",
                                                "endPoint": "2023-06-07T00:00:00",
                                                "aswi": 99.56408,
                                                "dqi": 98.59761,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.21966",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93891",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "22",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "281",
                                                "timestamp": 1.6860924E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T00:00:00",
                                                "endPoint": "2023-06-07T01:00:00",
                                                "aswi": 98.63352,
                                                "dqi": 95.96871,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.63677",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94446",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "20",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "851",
                                                "timestamp": 1.686096E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T01:00:00",
                                                "endPoint": "2023-06-07T02:00:00",
                                                "aswi": 98.09502,
                                                "dqi": 94.53393,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.00917",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.71119",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "104",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1077",
                                                "timestamp": 1.6860996E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T02:00:00",
                                                "endPoint": "2023-06-07T03:00:00",
                                                "aswi": 94.59938,
                                                "dqi": 88.66056,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.34353",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.85282",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "53",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2396",
                                                "timestamp": 1.6861032E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T03:00:00",
                                                "endPoint": "2023-06-07T04:00:00",
                                                "aswi": 91.49678,
                                                "dqi": 86.03629,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.7051",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.91669",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "30",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2986",
                                                "timestamp": 1.6861068E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T04:00:00",
                                                "endPoint": "2023-06-07T05:00:00",
                                                "aswi": 92.71417,
                                                "dqi": 86.92493,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "2.21607",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93891",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "22",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2802",
                                                "timestamp": 1.6861104E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T05:00:00",
                                                "endPoint": "2023-06-07T06:00:00",
                                                "aswi": 93.22651,
                                                "dqi": 87.34148,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "2.51876",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "9.95834",
                                                "score_precision": "9.9278",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "15",
                                                "tt_precision": "26",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2693",
                                                "timestamp": 1.686114E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T06:00:00",
                                                "endPoint": "2023-06-07T07:00:00",
                                                "aswi": 98.72822,
                                                "dqi": 96.0408,
                                                "frequency": "1",
                                                "dataCount": "3540",
                                                "score_frequency": "10",
                                                "score_stale": "8.07222",
                                                "score_dataGap": "9.82778",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92938",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "62",
                                                "tt_dataGap": "62",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "25",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "706",
                                                "timestamp": 1.6861176E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T07:00:00",
                                                "endPoint": "2023-06-07T08:00:00",
                                                "aswi": 98.89046,
                                                "dqi": 96.65834,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.02",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.97501",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "9",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "713",
                                                "timestamp": 1.6861212E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T08:00:00",
                                                "endPoint": "2023-06-07T09:00:00",
                                                "aswi": 98.69863,
                                                "dqi": 96.14922,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.71453",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.97501",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "9",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "823",
                                                "timestamp": 1.6861248E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T09:00:00",
                                                "endPoint": "2023-06-07T10:00:00",
                                                "aswi": 98.96725,
                                                "dqi": 96.87124,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.17273",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "9.99722",
                                                "score_precision": "9.95279",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "1",
                                                "tt_precision": "17",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "658",
                                                "timestamp": 1.6861284E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T10:00:00",
                                                "endPoint": "2023-06-07T11:00:00",
                                                "aswi": 93.21094,
                                                "dqi": 87.29982,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "2.47433",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.90558",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "34",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2709",
                                                "timestamp": 1.686132E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T11:00:00",
                                                "endPoint": "2023-06-07T12:00:00",
                                                "aswi": 97.84165,
                                                "dqi": 94.03406,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.54541",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.87503",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "45",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1244",
                                                "timestamp": 1.6861356E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T12:00:00",
                                                "endPoint": "2023-06-07T13:00:00",
                                                "aswi": 98.9716,
                                                "dqi": 96.85735,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.21439",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.90003",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "36",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "643",
                                                "timestamp": 1.6861392E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T13:00:00",
                                                "endPoint": "2023-06-07T14:00:00",
                                                "aswi": 98.63035,
                                                "dqi": 95.95946,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.63399",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94168",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "21",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "852",
                                                "timestamp": 1.6861428E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T14:00:00",
                                                "endPoint": "2023-06-07T15:00:00",
                                                "aswi": 98.72308,
                                                "dqi": 96.19087,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.80062",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.91391",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "31",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "792",
                                                "timestamp": 1.6861464E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T15:00:00",
                                                "endPoint": "2023-06-07T16:00:00",
                                                "aswi": 98.92024,
                                                "dqi": 96.72776,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.09776",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93891",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "22",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "685",
                                                "timestamp": 1.68615E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T16:00:00",
                                                "endPoint": "2023-06-07T17:00:00",
                                                "aswi": 99.27697,
                                                "dqi": 97.746,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.65871",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98889",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "483",
                                                "timestamp": 1.6861536E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T17:00:00",
                                                "endPoint": "2023-06-07T18:00:00",
                                                "aswi": 99.47691,
                                                "dqi": 98.32917,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.06971",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.9278",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "26",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "335",
                                                "timestamp": 1.6861572E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T18:00:00",
                                                "endPoint": "2023-06-07T19:00:00",
                                                "aswi": 99.17625,
                                                "dqi": 97.44053,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.5393",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92502",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "27",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "526",
                                                "timestamp": 1.6861608E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T19:00:00",
                                                "endPoint": "2023-06-07T20:00:00",
                                                "aswi": 98.73577,
                                                "dqi": 96.25104,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.79229",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "9.99722",
                                                "score_precision": "9.96112",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "1",
                                                "tt_precision": "14",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "795",
                                                "timestamp": 1.6861644E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T20:00:00",
                                                "endPoint": "2023-06-07T21:00:00",
                                                "aswi": 99.24089,
                                                "dqi": 97.63954,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.60317",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98056",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "7",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "503",
                                                "timestamp": 1.686168E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T21:00:00",
                                                "endPoint": "2023-06-07T22:00:00",
                                                "aswi": 98.88911,
                                                "dqi": 96.66296,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.99778",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "721",
                                                "timestamp": 1.6861716E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T22:00:00",
                                                "endPoint": "2023-06-07T23:00:00",
                                                "aswi": 98.80953,
                                                "dqi": 96.45006,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.87004",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "767",
                                                "timestamp": 1.6861752E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T23:00:00",
                                                "endPoint": "2023-06-08T00:00:00",
                                                "aswi": 98.92163,
                                                "dqi": 96.7509,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.05055",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "702",
                                                "timestamp": 1.6861788E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T00:00:00",
                                                "endPoint": "2023-06-08T01:00:00",
                                                "aswi": 98.87019,
                                                "dqi": 96.61205,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.96724",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "732",
                                                "timestamp": 1.6861824E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T01:00:00",
                                                "endPoint": "2023-06-08T02:00:00",
                                                "aswi": 98.87513,
                                                "dqi": 96.57812,
                                                "frequency": "1",
                                                "dataCount": "3584",
                                                "score_frequency": "10",
                                                "score_stale": "8.05556",
                                                "score_dataGap": "9.95",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "18",
                                                "tt_dataGap": "18",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "703",
                                                "timestamp": 1.686186E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T02:00:00",
                                                "endPoint": "2023-06-08T03:00:00",
                                                "aswi": 98.0756,
                                                "dqi": 94.60798,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.812",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95279",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "17",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1148",
                                                "timestamp": 1.6861896E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T03:00:00",
                                                "endPoint": "2023-06-08T04:00:00",
                                                "aswi": 95.73668,
                                                "dqi": 86.10359,
                                                "frequency": "0.99892",
                                                "dataCount": "2777",
                                                "score_frequency": "9.9892",
                                                "score_stale": "7.17194",
                                                "score_dataGap": "7.7",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92438",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "828",
                                                "tt_dataGap": "828",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "27",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1318",
                                                "timestamp": 1.6861932E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T04:00:00",
                                                "endPoint": "2023-06-08T05:00:00",
                                                "aswi": 99.44971,
                                                "dqi": 98.24586,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.02527",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92224",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "28",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "351",
                                                "timestamp": 1.6861968E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T05:00:00",
                                                "endPoint": "2023-06-08T06:00:00",
                                                "aswi": 99.50122,
                                                "dqi": 98.40322,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.11414",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.9278",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "26",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "319",
                                                "timestamp": 1.6862004E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T06:00:00",
                                                "endPoint": "2023-06-08T07:00:00",
                                                "aswi": 99.47436,
                                                "dqi": 98.31528,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "9.10581",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.88337",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "42",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "322",
                                                "timestamp": 1.686204E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T07:00:00",
                                                "endPoint": "2023-06-08T08:00:00",
                                                "aswi": 98.2508,
                                                "dqi": 94.9875,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.10914",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.88337",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "42",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1041",
                                                "timestamp": 1.6862076E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T08:00:00",
                                                "endPoint": "2023-06-08T09:00:00",
                                                "aswi": 95.82706,
                                                "dqi": 91.501,
                                                "frequency": "1.00033",
                                                "dataCount": "3022",
                                                "score_frequency": "10",
                                                "score_stale": "6.55526",
                                                "score_dataGap": "8.08342",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95367",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "579",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "17",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1240",
                                                "timestamp": 1.6862112E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T09:00:00",
                                                "endPoint": "2023-06-08T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862148E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T10:00:00",
                                                "endPoint": "2023-06-08T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862184E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T11:00:00",
                                                "endPoint": "2023-06-08T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686222E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T12:00:00",
                                                "endPoint": "2023-06-08T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862256E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T13:00:00",
                                                "endPoint": "2023-06-08T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862292E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T14:00:00",
                                                "endPoint": "2023-06-08T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862328E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T15:00:00",
                                                "endPoint": "2023-06-08T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862364E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T16:00:00",
                                                "endPoint": "2023-06-08T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68624E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T17:00:00",
                                                "endPoint": "2023-06-08T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862436E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T18:00:00",
                                                "endPoint": "2023-06-08T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862472E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T19:00:00",
                                                "endPoint": "2023-06-08T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862508E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T20:00:00",
                                                "endPoint": "2023-06-08T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862544E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T21:00:00",
                                                "endPoint": "2023-06-08T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686258E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T22:00:00",
                                                "endPoint": "2023-06-08T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862616E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T23:00:00",
                                                "endPoint": "2023-06-09T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862652E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T00:00:00",
                                                "endPoint": "2023-06-09T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862688E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T01:00:00",
                                                "endPoint": "2023-06-09T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862724E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T02:00:00",
                                                "endPoint": "2023-06-09T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686276E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T03:00:00",
                                                "endPoint": "2023-06-09T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862796E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T04:00:00",
                                                "endPoint": "2023-06-09T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862832E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T05:00:00",
                                                "endPoint": "2023-06-09T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862868E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T06:00:00",
                                                "endPoint": "2023-06-09T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862904E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T07:00:00",
                                                "endPoint": "2023-06-09T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686294E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T08:00:00",
                                                "endPoint": "2023-06-09T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862976E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T09:00:00",
                                                "endPoint": "2023-06-09T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863012E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T10:00:00",
                                                "endPoint": "2023-06-09T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863048E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T11:00:00",
                                                "endPoint": "2023-06-09T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863084E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T12:00:00",
                                                "endPoint": "2023-06-09T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686312E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T13:00:00",
                                                "endPoint": "2023-06-09T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863156E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T14:00:00",
                                                "endPoint": "2023-06-09T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863192E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T15:00:00",
                                                "endPoint": "2023-06-09T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863228E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T16:00:00",
                                                "endPoint": "2023-06-09T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863264E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T17:00:00",
                                                "endPoint": "2023-06-09T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68633E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T18:00:00",
                                                "endPoint": "2023-06-09T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863336E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T19:00:00",
                                                "endPoint": "2023-06-09T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863372E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T20:00:00",
                                                "endPoint": "2023-06-09T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863408E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T21:00:00",
                                                "endPoint": "2023-06-09T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863444E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T22:00:00",
                                                "endPoint": "2023-06-09T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686348E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T23:00:00",
                                                "endPoint": "2023-06-10T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863516E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T00:00:00",
                                                "endPoint": "2023-06-10T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863552E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T01:00:00",
                                                "endPoint": "2023-06-10T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863588E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T02:00:00",
                                                "endPoint": "2023-06-10T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863624E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T03:00:00",
                                                "endPoint": "2023-06-10T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686366E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T04:00:00",
                                                "endPoint": "2023-06-10T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863696E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T05:00:00",
                                                "endPoint": "2023-06-10T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863732E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T06:00:00",
                                                "endPoint": "2023-06-10T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863768E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T07:00:00",
                                                "endPoint": "2023-06-10T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863804E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T08:00:00",
                                                "endPoint": "2023-06-10T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686384E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T09:00:00",
                                                "endPoint": "2023-06-10T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863876E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T10:00:00",
                                                "endPoint": "2023-06-10T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863912E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T11:00:00",
                                                "endPoint": "2023-06-10T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863948E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T12:00:00",
                                                "endPoint": "2023-06-10T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863984E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T13:00:00",
                                                "endPoint": "2023-06-10T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686402E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T14:00:00",
                                                "endPoint": "2023-06-10T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864056E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T15:00:00",
                                                "endPoint": "2023-06-10T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864092E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T16:00:00",
                                                "endPoint": "2023-06-10T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864128E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T17:00:00",
                                                "endPoint": "2023-06-10T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864164E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T18:00:00",
                                                "endPoint": "2023-06-10T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68642E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T19:00:00",
                                                "endPoint": "2023-06-10T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864236E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T20:00:00",
                                                "endPoint": "2023-06-10T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864272E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T21:00:00",
                                                "endPoint": "2023-06-10T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864308E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T22:00:00",
                                                "endPoint": "2023-06-10T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864344E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T23:00:00",
                                                "endPoint": "2023-06-11T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686438E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T00:00:00",
                                                "endPoint": "2023-06-11T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864416E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T01:00:00",
                                                "endPoint": "2023-06-11T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864452E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T02:00:00",
                                                "endPoint": "2023-06-11T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864488E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T03:00:00",
                                                "endPoint": "2023-06-11T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864524E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T04:00:00",
                                                "endPoint": "2023-06-11T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686456E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T05:00:00",
                                                "endPoint": "2023-06-11T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864596E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T06:00:00",
                                                "endPoint": "2023-06-11T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864632E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T07:00:00",
                                                "endPoint": "2023-06-11T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864668E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T08:00:00",
                                                "endPoint": "2023-06-11T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864704E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T09:00:00",
                                                "endPoint": "2023-06-11T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686474E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T10:00:00",
                                                "endPoint": "2023-06-11T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864776E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T11:00:00",
                                                "endPoint": "2023-06-11T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864812E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T12:00:00",
                                                "endPoint": "2023-06-11T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864848E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T13:00:00",
                                                "endPoint": "2023-06-11T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864884E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T14:00:00",
                                                "endPoint": "2023-06-11T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686492E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T15:00:00",
                                                "endPoint": "2023-06-11T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864956E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T16:00:00",
                                                "endPoint": "2023-06-11T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864992E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T17:00:00",
                                                "endPoint": "2023-06-11T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865028E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T18:00:00",
                                                "endPoint": "2023-06-11T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865064E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T19:00:00",
                                                "endPoint": "2023-06-11T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68651E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T20:00:00",
                                                "endPoint": "2023-06-11T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865136E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T21:00:00",
                                                "endPoint": "2023-06-11T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865172E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T22:00:00",
                                                "endPoint": "2023-06-11T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865208E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T23:00:00",
                                                "endPoint": "2023-06-12T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865244E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T00:00:00",
                                                "endPoint": "2023-06-12T01:00:00",
                                                "aswi": 72.90048,
                                                "dqi": 76.85275,
                                                "frequency": "1",
                                                "dataCount": "1738",
                                                "score_frequency": "10",
                                                "score_stale": "1.80556",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95397",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "64",
                                                "tt_dataGap": "1864",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "17",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3055",
                                                "timestamp": 1.686528E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T01:00:00",
                                                "endPoint": "2023-06-12T02:00:00",
                                                "aswi": 91.7217,
                                                "dqi": 86.19828,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.78841",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93057",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "25",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2956",
                                                "timestamp": 1.6865316E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T02:00:00",
                                                "endPoint": "2023-06-12T03:00:00",
                                                "aswi": 91.67287,
                                                "dqi": 86.17051,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.76897",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93335",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "24",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2963",
                                                "timestamp": 1.6865352E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T03:00:00",
                                                "endPoint": "2023-06-12T04:00:00",
                                                "aswi": 90.53019,
                                                "dqi": 85.39295,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.38852",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.84726",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "55",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3100",
                                                "timestamp": 1.6865388E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T04:00:00",
                                                "endPoint": "2023-06-12T05:00:00",
                                                "aswi": 94.77903,
                                                "dqi": 88.91512,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.46016",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.88892",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "40",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2354",
                                                "timestamp": 1.6865424E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T05:00:00",
                                                "endPoint": "2023-06-12T06:00:00",
                                                "aswi": 91.37856,
                                                "dqi": 86.06406,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.64956",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98889",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3006",
                                                "timestamp": 1.686546E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T06:00:00",
                                                "endPoint": "2023-06-12T07:00:00",
                                                "aswi": 87.91681,
                                                "dqi": 84.38397,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.77203",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.85837",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "51",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3322",
                                                "timestamp": 1.6865496E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T07:00:00",
                                                "endPoint": "2023-06-12T08:00:00",
                                                "aswi": 89.16865,
                                                "dqi": 84.75886,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.02751",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.82783",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "62",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3230",
                                                "timestamp": 1.6865532E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T08:00:00",
                                                "endPoint": "2023-06-12T09:00:00",
                                                "aswi": 89.64727,
                                                "dqi": 84.98102,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.14137",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.84726",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "55",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3189",
                                                "timestamp": 1.6865568E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T09:00:00",
                                                "endPoint": "2023-06-12T10:00:00",
                                                "aswi": 88.89567,
                                                "dqi": 84.91623,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.94976",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3258",
                                                "timestamp": 1.6865604E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T10:00:00",
                                                "endPoint": "2023-06-12T11:00:00",
                                                "aswi": 89.68998,
                                                "dqi": 85.03194,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.1497",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.86948",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "47",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3186",
                                                "timestamp": 1.686564E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T11:00:00",
                                                "endPoint": "2023-06-12T12:00:00",
                                                "aswi": 99.1794,
                                                "dqi": 97.43127,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.61705",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.84171",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "57",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "498",
                                                "timestamp": 1.6865676E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T12:00:00",
                                                "endPoint": "2023-06-12T13:00:00",
                                                "aswi": 99.19333,
                                                "dqi": 97.49607,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.54485",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95279",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "17",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "524",
                                                "timestamp": 1.6865712E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T13:00:00",
                                                "endPoint": "2023-06-12T14:00:00",
                                                "aswi": 99.1372,
                                                "dqi": 97.34796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.40878",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "573",
                                                "timestamp": 1.6865748E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T14:00:00",
                                                "endPoint": "2023-06-12T15:00:00",
                                                "aswi": 98.11163,
                                                "dqi": 94.6774,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.88143",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92502",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "27",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1123",
                                                "timestamp": 1.6865784E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T15:00:00",
                                                "endPoint": "2023-06-12T16:00:00",
                                                "aswi": 98.68618,
                                                "dqi": 96.11682,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.69509",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.97501",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "9",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "830",
                                                "timestamp": 1.686582E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T16:00:00",
                                                "endPoint": "2023-06-12T17:00:00",
                                                "aswi": 98.93404,
                                                "dqi": 96.77404,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.09776",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.96668",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "12",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "685",
                                                "timestamp": 1.6865856E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T17:00:00",
                                                "endPoint": "2023-06-12T18:00:00",
                                                "aswi": 98.65135,
                                                "dqi": 95.84051,
                                                "frequency": "1",
                                                "dataCount": "3553",
                                                "score_frequency": "10",
                                                "score_stale": "7.95",
                                                "score_dataGap": "9.86389",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.85364",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "49",
                                                "tt_dataGap": "49",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "53",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "748",
                                                "timestamp": 1.6865892E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T18:00:00",
                                                "endPoint": "2023-06-12T19:00:00",
                                                "aswi": 98.14796,
                                                "dqi": 94.08642,
                                                "frequency": "0.9997",
                                                "dataCount": "3375",
                                                "score_frequency": "9.997",
                                                "score_stale": "7.86603",
                                                "score_dataGap": "9.36667",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99407",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "228",
                                                "tt_dataGap": "228",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "2",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "819",
                                                "timestamp": 1.6865928E12
                                            }
                                        ]
                                    },
                                    {
                                        "name": "TOR",
                                        "totalASWI": 21.35,
                                        "totalDQI": 21.86,
                                        "pageSize": "10000000",
                                        "currentPage": "1",
                                        "totalRecord": 693.0,
                                        "records": [
                                            {
                                                "startPoint": "2023-05-22T23:00:00",
                                                "endPoint": "2023-05-23T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6847964E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T00:00:00",
                                                "endPoint": "2023-05-23T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T01:00:00",
                                                "endPoint": "2023-05-23T02:00:00",
                                                "aswi": 55.96653,
                                                "dqi": 71.76978,
                                                "frequency": "1.00091",
                                                "dataCount": "1100",
                                                "score_frequency": "10",
                                                "score_stale": "0.00909",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "2501",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3597",
                                                "timestamp": 1.6848036E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T02:00:00",
                                                "endPoint": "2023-05-23T03:00:00",
                                                "aswi": 97.90775,
                                                "dqi": 94.27474,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.58984",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.98889",
                                                "score_minValue": "10",
                                                "score_precision": "9.98611",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "4",
                                                "tt_minValue": "0",
                                                "tt_precision": "5",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1228",
                                                "timestamp": 1.6848072E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T03:00:00",
                                                "endPoint": "2023-05-23T04:00:00",
                                                "aswi": 95.99112,
                                                "dqi": 90.68777,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.43767",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.98889",
                                                "score_minValue": "10",
                                                "score_precision": "9.98611",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "4",
                                                "tt_minValue": "0",
                                                "tt_precision": "5",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2002",
                                                "timestamp": 1.6848108E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T04:00:00",
                                                "endPoint": "2023-05-23T05:00:00",
                                                "aswi": 95.18154,
                                                "dqi": 89.53994,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.75453",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.98334",
                                                "score_minValue": "10",
                                                "score_precision": "9.98611",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "6",
                                                "tt_minValue": "0",
                                                "tt_precision": "5",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2248",
                                                "timestamp": 1.6848144E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T05:00:00",
                                                "endPoint": "2023-05-23T06:00:00",
                                                "aswi": 98.3965,
                                                "dqi": 95.46422,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.30631",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.97778",
                                                "score_minValue": "10",
                                                "score_precision": "9.99445",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "8",
                                                "tt_minValue": "0",
                                                "tt_precision": "2",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "970",
                                                "timestamp": 1.684818E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T06:00:00",
                                                "endPoint": "2023-05-23T07:00:00",
                                                "aswi": 98.32129,
                                                "dqi": 95.22818,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.16746",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.99167",
                                                "score_minValue": "10",
                                                "score_precision": "9.97778",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3",
                                                "tt_minValue": "0",
                                                "tt_precision": "8",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1020",
                                                "timestamp": 1.6848216E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T07:00:00",
                                                "endPoint": "2023-05-23T08:00:00",
                                                "aswi": 98.56364,
                                                "dqi": 95.84838,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.52292",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.98889",
                                                "score_minValue": "10",
                                                "score_precision": "9.99722",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "4",
                                                "tt_minValue": "0",
                                                "tt_precision": "1",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "892",
                                                "timestamp": 1.6848252E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T08:00:00",
                                                "endPoint": "2023-05-23T09:00:00",
                                                "aswi": 98.22348,
                                                "dqi": 95.02916,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.0536",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.98056",
                                                "score_minValue": "10",
                                                "score_precision": "9.98334",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "7",
                                                "tt_minValue": "0",
                                                "tt_precision": "6",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1061",
                                                "timestamp": 1.6848288E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T09:00:00",
                                                "endPoint": "2023-05-23T10:00:00",
                                                "aswi": 98.27187,
                                                "dqi": 95.13561,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.11748",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.98334",
                                                "score_minValue": "10",
                                                "score_precision": "9.98056",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "6",
                                                "tt_minValue": "0",
                                                "tt_precision": "7",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1038",
                                                "timestamp": 1.6848324E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T10:00:00",
                                                "endPoint": "2023-05-23T11:00:00",
                                                "aswi": 92.56552,
                                                "dqi": 86.88327,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "2.13831",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.99445",
                                                "score_minValue": "10",
                                                "score_precision": "9.99722",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "2",
                                                "tt_minValue": "0",
                                                "tt_precision": "1",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2830",
                                                "timestamp": 1.684836E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T11:00:00",
                                                "endPoint": "2023-05-23T12:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848396E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T12:00:00",
                                                "endPoint": "2023-05-23T13:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848432E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T13:00:00",
                                                "endPoint": "2023-05-23T14:00:00",
                                                "aswi": 96.58011,
                                                "dqi": 91.66898,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.02917",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.98056",
                                                "score_minValue": "10",
                                                "score_precision": "9.99167",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "7",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1790",
                                                "timestamp": 1.6848468E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T14:00:00",
                                                "endPoint": "2023-05-23T15:00:00",
                                                "aswi": 98.52898,
                                                "dqi": 95.76507,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.48681",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.98611",
                                                "score_minValue": "10",
                                                "score_precision": "9.98611",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "5",
                                                "tt_minValue": "0",
                                                "tt_precision": "5",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "905",
                                                "timestamp": 1.6848504E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T15:00:00",
                                                "endPoint": "2023-05-23T16:00:00",
                                                "aswi": 98.12998,
                                                "dqi": 94.81163,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.91475",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.98056",
                                                "score_minValue": "10",
                                                "score_precision": "9.99167",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "7",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1111",
                                                "timestamp": 1.684854E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T16:00:00",
                                                "endPoint": "2023-05-23T17:00:00",
                                                "aswi": 98.16455,
                                                "dqi": 94.90419,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.96752",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.97778",
                                                "score_minValue": "10",
                                                "score_precision": "9.99722",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "8",
                                                "tt_minValue": "0",
                                                "tt_precision": "1",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1092",
                                                "timestamp": 1.6848576E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T17:00:00",
                                                "endPoint": "2023-05-23T18:00:00",
                                                "aswi": 98.38326,
                                                "dqi": 95.3948,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.25633",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.98889",
                                                "score_minValue": "10",
                                                "score_precision": "9.99167",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "4",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "988",
                                                "timestamp": 1.6848612E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T18:00:00",
                                                "endPoint": "2023-05-23T19:00:00",
                                                "aswi": 98.01795,
                                                "dqi": 94.51078,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.7398",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.99167",
                                                "score_minValue": "10",
                                                "score_precision": "9.97501",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3",
                                                "tt_minValue": "0",
                                                "tt_precision": "9",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1174",
                                                "timestamp": 1.6848648E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T19:00:00",
                                                "endPoint": "2023-05-23T20:00:00",
                                                "aswi": 96.25149,
                                                "dqi": 89.84328,
                                                "frequency": "1",
                                                "dataCount": "3424",
                                                "score_frequency": "10",
                                                "score_stale": "5.16667",
                                                "score_dataGap": "9.50556",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.97664",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "178",
                                                "tt_dataGap": "178",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "8",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1829",
                                                "timestamp": 1.6848684E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T20:00:00",
                                                "endPoint": "2023-05-23T21:00:00",
                                                "aswi": 84.91885,
                                                "dqi": 83.95816,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.38047",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99445",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "2",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3463",
                                                "timestamp": 1.684872E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T21:00:00",
                                                "endPoint": "2023-05-23T22:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848756E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T22:00:00",
                                                "endPoint": "2023-05-23T23:00:00",
                                                "aswi": 89.56679,
                                                "dqi": 80.77373,
                                                "frequency": "0.99969",
                                                "dataCount": "3249",
                                                "score_frequency": "9.9969",
                                                "score_stale": "1.36121",
                                                "score_dataGap": "9.01667",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "354",
                                                "tt_dataGap": "354",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3445",
                                                "timestamp": 1.6848792E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T23:00:00",
                                                "endPoint": "2023-05-24T00:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848828E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T00:00:00",
                                                "endPoint": "2023-05-24T01:00:00",
                                                "aswi": 90.17564,
                                                "dqi": 76.59839,
                                                "frequency": "0.99896",
                                                "dataCount": "2877",
                                                "score_frequency": "9.9896",
                                                "score_stale": "2.00279",
                                                "score_dataGap": "7.97778",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "728",
                                                "tt_dataGap": "728",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848864E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T01:00:00",
                                                "endPoint": "2023-05-24T02:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.68489E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T02:00:00",
                                                "endPoint": "2023-05-24T03:00:00",
                                                "aswi": 73.68102,
                                                "dqi": 83.37036,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.02224",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3592",
                                                "timestamp": 1.6848936E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T03:00:00",
                                                "endPoint": "2023-05-24T04:00:00",
                                                "aswi": 90.09373,
                                                "dqi": 85.4022,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.24134",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3153",
                                                "timestamp": 1.6848972E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T04:00:00",
                                                "endPoint": "2023-05-24T05:00:00",
                                                "aswi": 78.712,
                                                "dqi": 83.47218,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.08333",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3570",
                                                "timestamp": 1.6849008E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T05:00:00",
                                                "endPoint": "2023-05-24T06:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6849044E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T06:00:00",
                                                "endPoint": "2023-05-24T07:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.684908E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T07:00:00",
                                                "endPoint": "2023-05-24T08:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6849116E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T08:00:00",
                                                "endPoint": "2023-05-24T09:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6849152E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T09:00:00",
                                                "endPoint": "2023-05-24T10:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6849188E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T10:00:00",
                                                "endPoint": "2023-05-24T11:00:00",
                                                "aswi": 88.04508,
                                                "dqi": 80.09772,
                                                "frequency": "0.99969",
                                                "dataCount": "3253",
                                                "score_frequency": "9.9969",
                                                "score_stale": "0.96387",
                                                "score_dataGap": "9.02778",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "350",
                                                "tt_dataGap": "350",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6849224E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T11:00:00",
                                                "endPoint": "2023-05-24T12:00:00",
                                                "aswi": 55.64312,
                                                "dqi": 72.41622,
                                                "frequency": "1.00081",
                                                "dataCount": "1240",
                                                "score_frequency": "10",
                                                "score_stale": "0.0081",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "2361",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3597",
                                                "timestamp": 1.684926E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T12:00:00",
                                                "endPoint": "2023-05-24T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849296E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T13:00:00",
                                                "endPoint": "2023-05-24T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849332E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T14:00:00",
                                                "endPoint": "2023-05-24T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849368E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T15:00:00",
                                                "endPoint": "2023-05-24T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849404E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T16:00:00",
                                                "endPoint": "2023-05-24T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684944E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T17:00:00",
                                                "endPoint": "2023-05-24T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849476E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T18:00:00",
                                                "endPoint": "2023-05-24T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849512E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T19:00:00",
                                                "endPoint": "2023-05-24T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849548E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T20:00:00",
                                                "endPoint": "2023-05-24T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849584E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T21:00:00",
                                                "endPoint": "2023-05-24T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684962E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T22:00:00",
                                                "endPoint": "2023-05-24T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849656E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T23:00:00",
                                                "endPoint": "2023-05-25T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849692E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T00:00:00",
                                                "endPoint": "2023-05-25T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849728E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T01:00:00",
                                                "endPoint": "2023-05-25T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849764E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T02:00:00",
                                                "endPoint": "2023-05-25T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68498E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T03:00:00",
                                                "endPoint": "2023-05-25T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849836E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T04:00:00",
                                                "endPoint": "2023-05-25T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849872E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T05:00:00",
                                                "endPoint": "2023-05-25T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849908E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T06:00:00",
                                                "endPoint": "2023-05-25T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849944E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T07:00:00",
                                                "endPoint": "2023-05-25T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684998E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T08:00:00",
                                                "endPoint": "2023-05-25T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850016E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T09:00:00",
                                                "endPoint": "2023-05-25T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850052E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T10:00:00",
                                                "endPoint": "2023-05-25T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850088E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T11:00:00",
                                                "endPoint": "2023-05-25T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850124E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T12:00:00",
                                                "endPoint": "2023-05-25T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685016E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T13:00:00",
                                                "endPoint": "2023-05-25T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850196E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T14:00:00",
                                                "endPoint": "2023-05-25T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850232E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T15:00:00",
                                                "endPoint": "2023-05-25T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850268E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T16:00:00",
                                                "endPoint": "2023-05-25T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850304E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T17:00:00",
                                                "endPoint": "2023-05-25T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685034E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T18:00:00",
                                                "endPoint": "2023-05-25T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850376E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T19:00:00",
                                                "endPoint": "2023-05-25T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850412E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T20:00:00",
                                                "endPoint": "2023-05-25T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850448E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T21:00:00",
                                                "endPoint": "2023-05-25T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850484E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T22:00:00",
                                                "endPoint": "2023-05-25T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685052E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T23:00:00",
                                                "endPoint": "2023-05-26T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850556E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T00:00:00",
                                                "endPoint": "2023-05-26T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850592E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T01:00:00",
                                                "endPoint": "2023-05-26T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850628E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T02:00:00",
                                                "endPoint": "2023-05-26T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850664E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T03:00:00",
                                                "endPoint": "2023-05-26T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68507E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T04:00:00",
                                                "endPoint": "2023-05-26T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850736E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T05:00:00",
                                                "endPoint": "2023-05-26T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850772E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T06:00:00",
                                                "endPoint": "2023-05-26T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850808E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T07:00:00",
                                                "endPoint": "2023-05-26T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850844E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T08:00:00",
                                                "endPoint": "2023-05-26T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685088E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T09:00:00",
                                                "endPoint": "2023-05-26T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850916E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T10:00:00",
                                                "endPoint": "2023-05-26T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850952E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T11:00:00",
                                                "endPoint": "2023-05-26T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850988E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T12:00:00",
                                                "endPoint": "2023-05-26T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851024E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T13:00:00",
                                                "endPoint": "2023-05-26T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685106E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T14:00:00",
                                                "endPoint": "2023-05-26T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851096E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T15:00:00",
                                                "endPoint": "2023-05-26T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851132E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T16:00:00",
                                                "endPoint": "2023-05-26T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851168E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T17:00:00",
                                                "endPoint": "2023-05-26T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851204E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T18:00:00",
                                                "endPoint": "2023-05-26T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685124E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T19:00:00",
                                                "endPoint": "2023-05-26T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851276E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T20:00:00",
                                                "endPoint": "2023-05-26T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851312E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T21:00:00",
                                                "endPoint": "2023-05-26T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851348E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T22:00:00",
                                                "endPoint": "2023-05-26T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851384E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T23:00:00",
                                                "endPoint": "2023-05-27T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685142E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T00:00:00",
                                                "endPoint": "2023-05-27T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851456E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T01:00:00",
                                                "endPoint": "2023-05-27T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851492E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T02:00:00",
                                                "endPoint": "2023-05-27T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851528E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T03:00:00",
                                                "endPoint": "2023-05-27T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851564E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T04:00:00",
                                                "endPoint": "2023-05-27T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68516E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T05:00:00",
                                                "endPoint": "2023-05-27T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851636E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T06:00:00",
                                                "endPoint": "2023-05-27T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851672E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T07:00:00",
                                                "endPoint": "2023-05-27T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851708E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T08:00:00",
                                                "endPoint": "2023-05-27T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851744E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T09:00:00",
                                                "endPoint": "2023-05-27T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685178E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T10:00:00",
                                                "endPoint": "2023-05-27T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851816E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T11:00:00",
                                                "endPoint": "2023-05-27T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851852E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T12:00:00",
                                                "endPoint": "2023-05-27T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851888E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T13:00:00",
                                                "endPoint": "2023-05-27T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851924E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T14:00:00",
                                                "endPoint": "2023-05-27T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685196E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T15:00:00",
                                                "endPoint": "2023-05-27T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851996E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T16:00:00",
                                                "endPoint": "2023-05-27T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852032E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T17:00:00",
                                                "endPoint": "2023-05-27T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852068E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T18:00:00",
                                                "endPoint": "2023-05-27T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852104E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T19:00:00",
                                                "endPoint": "2023-05-27T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685214E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T20:00:00",
                                                "endPoint": "2023-05-27T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852176E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T21:00:00",
                                                "endPoint": "2023-05-27T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852212E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T22:00:00",
                                                "endPoint": "2023-05-27T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852248E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T23:00:00",
                                                "endPoint": "2023-05-28T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852284E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T00:00:00",
                                                "endPoint": "2023-05-28T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685232E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T01:00:00",
                                                "endPoint": "2023-05-28T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852356E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T02:00:00",
                                                "endPoint": "2023-05-28T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852392E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T03:00:00",
                                                "endPoint": "2023-05-28T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852428E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T04:00:00",
                                                "endPoint": "2023-05-28T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852464E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T05:00:00",
                                                "endPoint": "2023-05-28T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68525E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T06:00:00",
                                                "endPoint": "2023-05-28T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852536E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T07:00:00",
                                                "endPoint": "2023-05-28T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852572E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T08:00:00",
                                                "endPoint": "2023-05-28T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852608E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T09:00:00",
                                                "endPoint": "2023-05-28T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852644E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T10:00:00",
                                                "endPoint": "2023-05-28T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685268E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T11:00:00",
                                                "endPoint": "2023-05-28T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852716E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T12:00:00",
                                                "endPoint": "2023-05-28T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852752E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T13:00:00",
                                                "endPoint": "2023-05-28T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852788E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T14:00:00",
                                                "endPoint": "2023-05-28T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852824E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T15:00:00",
                                                "endPoint": "2023-05-28T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685286E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T16:00:00",
                                                "endPoint": "2023-05-28T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852896E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T17:00:00",
                                                "endPoint": "2023-05-28T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852932E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T18:00:00",
                                                "endPoint": "2023-05-28T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852968E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T19:00:00",
                                                "endPoint": "2023-05-28T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853004E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T20:00:00",
                                                "endPoint": "2023-05-28T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685304E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T21:00:00",
                                                "endPoint": "2023-05-28T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853076E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T22:00:00",
                                                "endPoint": "2023-05-28T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853112E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T23:00:00",
                                                "endPoint": "2023-05-29T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853148E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T00:00:00",
                                                "endPoint": "2023-05-29T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853184E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T01:00:00",
                                                "endPoint": "2023-05-29T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685322E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T02:00:00",
                                                "endPoint": "2023-05-29T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853256E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T03:00:00",
                                                "endPoint": "2023-05-29T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853292E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T04:00:00",
                                                "endPoint": "2023-05-29T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853328E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T05:00:00",
                                                "endPoint": "2023-05-29T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853364E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T06:00:00",
                                                "endPoint": "2023-05-29T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68534E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T07:00:00",
                                                "endPoint": "2023-05-29T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853436E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T08:00:00",
                                                "endPoint": "2023-05-29T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853472E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T09:00:00",
                                                "endPoint": "2023-05-29T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853508E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T10:00:00",
                                                "endPoint": "2023-05-29T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853544E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T11:00:00",
                                                "endPoint": "2023-05-29T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685358E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T12:00:00",
                                                "endPoint": "2023-05-29T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853616E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T13:00:00",
                                                "endPoint": "2023-05-29T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853652E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T14:00:00",
                                                "endPoint": "2023-05-29T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853688E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T15:00:00",
                                                "endPoint": "2023-05-29T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853724E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T16:00:00",
                                                "endPoint": "2023-05-29T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685376E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T17:00:00",
                                                "endPoint": "2023-05-29T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853796E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T18:00:00",
                                                "endPoint": "2023-05-29T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853832E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T19:00:00",
                                                "endPoint": "2023-05-29T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853868E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T20:00:00",
                                                "endPoint": "2023-05-29T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853904E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T21:00:00",
                                                "endPoint": "2023-05-29T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685394E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T22:00:00",
                                                "endPoint": "2023-05-29T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853976E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T23:00:00",
                                                "endPoint": "2023-05-30T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854012E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T00:00:00",
                                                "endPoint": "2023-05-30T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854048E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T01:00:00",
                                                "endPoint": "2023-05-30T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854084E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T02:00:00",
                                                "endPoint": "2023-05-30T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685412E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T03:00:00",
                                                "endPoint": "2023-05-30T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854156E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T04:00:00",
                                                "endPoint": "2023-05-30T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854192E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T05:00:00",
                                                "endPoint": "2023-05-30T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854228E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T06:00:00",
                                                "endPoint": "2023-05-30T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854264E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T07:00:00",
                                                "endPoint": "2023-05-30T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68543E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T08:00:00",
                                                "endPoint": "2023-05-30T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854336E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T09:00:00",
                                                "endPoint": "2023-05-30T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854372E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T10:00:00",
                                                "endPoint": "2023-05-30T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854408E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T11:00:00",
                                                "endPoint": "2023-05-30T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854444E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T12:00:00",
                                                "endPoint": "2023-05-30T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685448E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T13:00:00",
                                                "endPoint": "2023-05-30T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854516E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T14:00:00",
                                                "endPoint": "2023-05-30T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854552E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T15:00:00",
                                                "endPoint": "2023-05-30T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854588E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T16:00:00",
                                                "endPoint": "2023-05-30T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854624E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T17:00:00",
                                                "endPoint": "2023-05-30T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685466E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T18:00:00",
                                                "endPoint": "2023-05-30T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854696E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T19:00:00",
                                                "endPoint": "2023-05-30T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854732E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T20:00:00",
                                                "endPoint": "2023-05-30T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854768E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T21:00:00",
                                                "endPoint": "2023-05-30T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854804E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T22:00:00",
                                                "endPoint": "2023-05-30T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685484E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T23:00:00",
                                                "endPoint": "2023-05-31T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854876E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T00:00:00",
                                                "endPoint": "2023-05-31T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854912E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T01:00:00",
                                                "endPoint": "2023-05-31T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854948E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T02:00:00",
                                                "endPoint": "2023-05-31T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854984E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T03:00:00",
                                                "endPoint": "2023-05-31T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685502E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T04:00:00",
                                                "endPoint": "2023-05-31T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855056E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T05:00:00",
                                                "endPoint": "2023-05-31T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855092E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T06:00:00",
                                                "endPoint": "2023-05-31T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855128E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T07:00:00",
                                                "endPoint": "2023-05-31T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855164E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T08:00:00",
                                                "endPoint": "2023-05-31T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68552E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T09:00:00",
                                                "endPoint": "2023-05-31T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855236E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T10:00:00",
                                                "endPoint": "2023-05-31T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855272E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T11:00:00",
                                                "endPoint": "2023-05-31T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855308E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T12:00:00",
                                                "endPoint": "2023-05-31T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855344E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T13:00:00",
                                                "endPoint": "2023-05-31T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685538E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T14:00:00",
                                                "endPoint": "2023-05-31T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855416E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T15:00:00",
                                                "endPoint": "2023-05-31T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855452E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T16:00:00",
                                                "endPoint": "2023-05-31T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855488E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T17:00:00",
                                                "endPoint": "2023-05-31T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855524E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T18:00:00",
                                                "endPoint": "2023-05-31T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685556E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T19:00:00",
                                                "endPoint": "2023-05-31T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855596E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T20:00:00",
                                                "endPoint": "2023-05-31T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855632E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T21:00:00",
                                                "endPoint": "2023-05-31T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855668E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T22:00:00",
                                                "endPoint": "2023-05-31T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855704E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T23:00:00",
                                                "endPoint": "2023-06-01T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685574E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T00:00:00",
                                                "endPoint": "2023-06-01T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855776E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T01:00:00",
                                                "endPoint": "2023-06-01T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855812E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T02:00:00",
                                                "endPoint": "2023-06-01T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855848E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T03:00:00",
                                                "endPoint": "2023-06-01T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855884E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T04:00:00",
                                                "endPoint": "2023-06-01T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685592E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T05:00:00",
                                                "endPoint": "2023-06-01T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855956E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T06:00:00",
                                                "endPoint": "2023-06-01T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855992E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T07:00:00",
                                                "endPoint": "2023-06-01T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856028E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T08:00:00",
                                                "endPoint": "2023-06-01T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856064E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T09:00:00",
                                                "endPoint": "2023-06-01T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68561E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T10:00:00",
                                                "endPoint": "2023-06-01T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856136E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T11:00:00",
                                                "endPoint": "2023-06-01T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856172E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T12:00:00",
                                                "endPoint": "2023-06-01T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856208E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T13:00:00",
                                                "endPoint": "2023-06-01T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856244E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T14:00:00",
                                                "endPoint": "2023-06-01T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685628E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T15:00:00",
                                                "endPoint": "2023-06-01T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856316E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T16:00:00",
                                                "endPoint": "2023-06-01T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856352E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T17:00:00",
                                                "endPoint": "2023-06-01T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856388E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T18:00:00",
                                                "endPoint": "2023-06-01T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856424E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T19:00:00",
                                                "endPoint": "2023-06-01T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685646E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T20:00:00",
                                                "endPoint": "2023-06-01T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856496E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T21:00:00",
                                                "endPoint": "2023-06-01T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856532E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T22:00:00",
                                                "endPoint": "2023-06-01T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856568E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T23:00:00",
                                                "endPoint": "2023-06-02T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856604E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T00:00:00",
                                                "endPoint": "2023-06-02T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685664E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T01:00:00",
                                                "endPoint": "2023-06-02T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856676E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T02:00:00",
                                                "endPoint": "2023-06-02T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856712E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T03:00:00",
                                                "endPoint": "2023-06-02T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856748E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T04:00:00",
                                                "endPoint": "2023-06-02T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856784E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T05:00:00",
                                                "endPoint": "2023-06-02T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685682E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T06:00:00",
                                                "endPoint": "2023-06-02T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856856E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T07:00:00",
                                                "endPoint": "2023-06-02T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856892E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T08:00:00",
                                                "endPoint": "2023-06-02T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856928E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T09:00:00",
                                                "endPoint": "2023-06-02T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856964E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T10:00:00",
                                                "endPoint": "2023-06-02T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T11:00:00",
                                                "endPoint": "2023-06-02T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857036E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T12:00:00",
                                                "endPoint": "2023-06-02T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857072E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T13:00:00",
                                                "endPoint": "2023-06-02T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857108E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T14:00:00",
                                                "endPoint": "2023-06-02T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857144E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T15:00:00",
                                                "endPoint": "2023-06-02T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685718E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T16:00:00",
                                                "endPoint": "2023-06-02T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857216E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T17:00:00",
                                                "endPoint": "2023-06-02T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857252E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T18:00:00",
                                                "endPoint": "2023-06-02T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857288E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T19:00:00",
                                                "endPoint": "2023-06-02T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857324E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T20:00:00",
                                                "endPoint": "2023-06-02T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685736E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T21:00:00",
                                                "endPoint": "2023-06-02T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857396E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T22:00:00",
                                                "endPoint": "2023-06-02T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857432E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T23:00:00",
                                                "endPoint": "2023-06-03T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857468E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T00:00:00",
                                                "endPoint": "2023-06-03T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857504E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T01:00:00",
                                                "endPoint": "2023-06-03T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685754E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T02:00:00",
                                                "endPoint": "2023-06-03T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857576E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T03:00:00",
                                                "endPoint": "2023-06-03T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857612E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T04:00:00",
                                                "endPoint": "2023-06-03T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857648E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T05:00:00",
                                                "endPoint": "2023-06-03T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857684E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T06:00:00",
                                                "endPoint": "2023-06-03T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685772E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T07:00:00",
                                                "endPoint": "2023-06-03T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857756E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T08:00:00",
                                                "endPoint": "2023-06-03T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857792E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T09:00:00",
                                                "endPoint": "2023-06-03T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857828E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T10:00:00",
                                                "endPoint": "2023-06-03T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857864E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T11:00:00",
                                                "endPoint": "2023-06-03T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68579E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T12:00:00",
                                                "endPoint": "2023-06-03T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857936E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T13:00:00",
                                                "endPoint": "2023-06-03T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857972E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T14:00:00",
                                                "endPoint": "2023-06-03T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858008E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T15:00:00",
                                                "endPoint": "2023-06-03T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858044E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T16:00:00",
                                                "endPoint": "2023-06-03T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685808E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T17:00:00",
                                                "endPoint": "2023-06-03T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858116E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T18:00:00",
                                                "endPoint": "2023-06-03T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858152E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T19:00:00",
                                                "endPoint": "2023-06-03T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858188E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T20:00:00",
                                                "endPoint": "2023-06-03T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858224E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T21:00:00",
                                                "endPoint": "2023-06-03T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685826E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T22:00:00",
                                                "endPoint": "2023-06-03T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858296E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T23:00:00",
                                                "endPoint": "2023-06-04T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858332E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T00:00:00",
                                                "endPoint": "2023-06-04T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858368E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T01:00:00",
                                                "endPoint": "2023-06-04T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858404E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T02:00:00",
                                                "endPoint": "2023-06-04T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685844E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T03:00:00",
                                                "endPoint": "2023-06-04T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858476E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T04:00:00",
                                                "endPoint": "2023-06-04T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858512E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T05:00:00",
                                                "endPoint": "2023-06-04T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858548E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T06:00:00",
                                                "endPoint": "2023-06-04T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858584E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T07:00:00",
                                                "endPoint": "2023-06-04T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685862E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T08:00:00",
                                                "endPoint": "2023-06-04T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858656E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T09:00:00",
                                                "endPoint": "2023-06-04T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858692E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T10:00:00",
                                                "endPoint": "2023-06-04T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858728E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T11:00:00",
                                                "endPoint": "2023-06-04T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858764E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T12:00:00",
                                                "endPoint": "2023-06-04T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68588E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T13:00:00",
                                                "endPoint": "2023-06-04T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858836E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T14:00:00",
                                                "endPoint": "2023-06-04T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858872E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T15:00:00",
                                                "endPoint": "2023-06-04T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858908E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T16:00:00",
                                                "endPoint": "2023-06-04T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858944E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T17:00:00",
                                                "endPoint": "2023-06-04T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685898E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T18:00:00",
                                                "endPoint": "2023-06-04T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859016E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T19:00:00",
                                                "endPoint": "2023-06-04T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859052E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T20:00:00",
                                                "endPoint": "2023-06-04T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859088E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T21:00:00",
                                                "endPoint": "2023-06-04T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859124E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T22:00:00",
                                                "endPoint": "2023-06-04T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685916E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T23:00:00",
                                                "endPoint": "2023-06-05T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859196E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T00:00:00",
                                                "endPoint": "2023-06-05T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859232E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T01:00:00",
                                                "endPoint": "2023-06-05T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859268E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T02:00:00",
                                                "endPoint": "2023-06-05T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859304E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T03:00:00",
                                                "endPoint": "2023-06-05T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685934E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T04:00:00",
                                                "endPoint": "2023-06-05T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859376E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T05:00:00",
                                                "endPoint": "2023-06-05T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859412E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T06:00:00",
                                                "endPoint": "2023-06-05T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859448E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T07:00:00",
                                                "endPoint": "2023-06-05T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859484E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T08:00:00",
                                                "endPoint": "2023-06-05T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685952E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T09:00:00",
                                                "endPoint": "2023-06-05T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859556E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T10:00:00",
                                                "endPoint": "2023-06-05T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859592E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T11:00:00",
                                                "endPoint": "2023-06-05T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859628E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T12:00:00",
                                                "endPoint": "2023-06-05T13:00:00",
                                                "aswi": 64.68461,
                                                "dqi": 79.17284,
                                                "frequency": "1.00037",
                                                "dataCount": "2701",
                                                "score_frequency": "10",
                                                "score_stale": "0.0037",
                                                "score_dataGap": "6.66667",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "900",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6859664E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T13:00:00",
                                                "endPoint": "2023-06-05T14:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.68597E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T14:00:00",
                                                "endPoint": "2023-06-05T15:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6859736E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T15:00:00",
                                                "endPoint": "2023-06-05T16:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6859772E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T16:00:00",
                                                "endPoint": "2023-06-05T17:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6859808E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T17:00:00",
                                                "endPoint": "2023-06-05T18:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6859844E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T18:00:00",
                                                "endPoint": "2023-06-05T19:00:00",
                                                "aswi": 74.1155,
                                                "dqi": 83.37499,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.02501",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3591",
                                                "timestamp": 1.685988E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T19:00:00",
                                                "endPoint": "2023-06-05T20:00:00",
                                                "aswi": 97.0744,
                                                "dqi": 92.51389,
                                                "frequency": "1",
                                                "dataCount": "3600",
                                                "score_frequency": "10",
                                                "score_stale": "5.53889",
                                                "score_dataGap": "9.99444",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98056",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "2",
                                                "tt_dataGap": "2",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "7",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1606",
                                                "timestamp": 1.6859916E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T20:00:00",
                                                "endPoint": "2023-06-05T21:00:00",
                                                "aswi": 95.98905,
                                                "dqi": 90.66,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.42101",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.97501",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "9",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2008",
                                                "timestamp": 1.6859952E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T21:00:00",
                                                "endPoint": "2023-06-05T22:00:00",
                                                "aswi": 97.36198,
                                                "dqi": 93.13839,
                                                "frequency": "1.00028",
                                                "dataCount": "3552",
                                                "score_frequency": "10",
                                                "score_stale": "6.0304",
                                                "score_dataGap": "9.86201",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98874",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "49",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1429",
                                                "timestamp": 1.6859988E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T22:00:00",
                                                "endPoint": "2023-06-05T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6860024E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T23:00:00",
                                                "endPoint": "2023-06-06T00:00:00",
                                                "aswi": 93.93429,
                                                "dqi": 86.50856,
                                                "frequency": "0.99929",
                                                "dataCount": "2817",
                                                "score_frequency": "9.9929",
                                                "score_stale": "5.25652",
                                                "score_dataGap": "7.42726",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.9219",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "246",
                                                "tt_dataGap": "787",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "28",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1853",
                                                "timestamp": 1.686006E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T00:00:00",
                                                "endPoint": "2023-06-06T01:00:00",
                                                "aswi": 95.70725,
                                                "dqi": 90.25271,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.16274",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98889",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2101",
                                                "timestamp": 1.6860096E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T01:00:00",
                                                "endPoint": "2023-06-06T02:00:00",
                                                "aswi": 97.07167,
                                                "dqi": 92.52522,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.52347",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99167",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1612",
                                                "timestamp": 1.6860132E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T02:00:00",
                                                "endPoint": "2023-06-06T03:00:00",
                                                "aswi": 97.55746,
                                                "dqi": 93.49718,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.09831",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1405",
                                                "timestamp": 1.6860168E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T03:00:00",
                                                "endPoint": "2023-06-06T04:00:00",
                                                "aswi": 96.81503,
                                                "dqi": 92.04388,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.243",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98334",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "6",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1713",
                                                "timestamp": 1.6860204E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T04:00:00",
                                                "endPoint": "2023-06-06T05:00:00",
                                                "aswi": 96.30011,
                                                "dqi": 91.15986,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.71259",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98334",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "6",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1903",
                                                "timestamp": 1.686024E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T05:00:00",
                                                "endPoint": "2023-06-06T06:00:00",
                                                "aswi": 97.05946,
                                                "dqi": 92.50208,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.50959",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99167",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1617",
                                                "timestamp": 1.6860276E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T06:00:00",
                                                "endPoint": "2023-06-06T07:00:00",
                                                "aswi": 96.57722,
                                                "dqi": 91.5579,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.03195",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.9028",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "35",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1789",
                                                "timestamp": 1.6860312E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T07:00:00",
                                                "endPoint": "2023-06-06T08:00:00",
                                                "aswi": 96.60827,
                                                "dqi": 91.66435,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.03195",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.96668",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "12",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1789",
                                                "timestamp": 1.6860348E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T08:00:00",
                                                "endPoint": "2023-06-06T09:00:00",
                                                "aswi": 96.80733,
                                                "dqi": 92.02999,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.23467",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98334",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "6",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1716",
                                                "timestamp": 1.6860384E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T09:00:00",
                                                "endPoint": "2023-06-06T10:00:00",
                                                "aswi": 97.65567,
                                                "dqi": 93.69157,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.23439",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98056",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "7",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1356",
                                                "timestamp": 1.686042E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T10:00:00",
                                                "endPoint": "2023-06-06T11:00:00",
                                                "aswi": 97.8936,
                                                "dqi": 94.21457,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.53986",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98889",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1246",
                                                "timestamp": 1.6860456E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T11:00:00",
                                                "endPoint": "2023-06-06T12:00:00",
                                                "aswi": 98.20199,
                                                "dqi": 94.91808,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.97029",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98056",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "7",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1091",
                                                "timestamp": 1.6860492E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T12:00:00",
                                                "endPoint": "2023-06-06T13:00:00",
                                                "aswi": 96.48126,
                                                "dqi": 91.46071,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.8931",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98334",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "6",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1838",
                                                "timestamp": 1.6860528E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T13:00:00",
                                                "endPoint": "2023-06-06T14:00:00",
                                                "aswi": 97.19804,
                                                "dqi": 92.7659,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.67066",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98889",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1559",
                                                "timestamp": 1.6860564E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T14:00:00",
                                                "endPoint": "2023-06-06T15:00:00",
                                                "aswi": 96.82336,
                                                "dqi": 92.03925,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.26521",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95834",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "15",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1705",
                                                "timestamp": 1.68606E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T15:00:00",
                                                "endPoint": "2023-06-06T16:00:00",
                                                "aswi": 97.41516,
                                                "dqi": 93.20096,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.92614",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99445",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "2",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1467",
                                                "timestamp": 1.6860636E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T16:00:00",
                                                "endPoint": "2023-06-06T17:00:00",
                                                "aswi": 96.60159,
                                                "dqi": 91.64122,
                                                "frequency": "1",
                                                "dataCount": "3597",
                                                "score_frequency": "10",
                                                "score_stale": "5.02778",
                                                "score_dataGap": "9.98611",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98888",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "5",
                                                "tt_dataGap": "5",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1791",
                                                "timestamp": 1.6860672E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T17:00:00",
                                                "endPoint": "2023-06-06T18:00:00",
                                                "aswi": 98.17409,
                                                "dqi": 94.85791,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.92308",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99167",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1108",
                                                "timestamp": 1.6860708E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T18:00:00",
                                                "endPoint": "2023-06-06T19:00:00",
                                                "aswi": 96.29576,
                                                "dqi": 91.10895,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.73203",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93335",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "24",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1896",
                                                "timestamp": 1.6860744E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T19:00:00",
                                                "endPoint": "2023-06-06T20:00:00",
                                                "aswi": 96.42566,
                                                "dqi": 91.30797,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.87088",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.91391",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "31",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1846",
                                                "timestamp": 1.686078E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T20:00:00",
                                                "endPoint": "2023-06-06T21:00:00",
                                                "aswi": 98.44465,
                                                "dqi": 95.50588,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.32297",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98056",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "7",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "964",
                                                "timestamp": 1.6860816E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T21:00:00",
                                                "endPoint": "2023-06-06T22:00:00",
                                                "aswi": 96.46609,
                                                "dqi": 91.44219,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.87366",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99167",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1845",
                                                "timestamp": 1.6860852E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T22:00:00",
                                                "endPoint": "2023-06-06T23:00:00",
                                                "aswi": 98.5252,
                                                "dqi": 95.70953,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.43961",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98611",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "5",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "922",
                                                "timestamp": 1.6860888E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T23:00:00",
                                                "endPoint": "2023-06-07T00:00:00",
                                                "aswi": 98.39571,
                                                "dqi": 95.39017,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.24244",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99167",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "993",
                                                "timestamp": 1.6860924E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T00:00:00",
                                                "endPoint": "2023-06-07T01:00:00",
                                                "aswi": 95.45258,
                                                "dqi": 89.88707,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.94892",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98334",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "6",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2178",
                                                "timestamp": 1.686096E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T01:00:00",
                                                "endPoint": "2023-06-07T02:00:00",
                                                "aswi": 98.42068,
                                                "dqi": 95.45034,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.28132",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98889",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "979",
                                                "timestamp": 1.6860996E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T02:00:00",
                                                "endPoint": "2023-06-07T03:00:00",
                                                "aswi": 97.48228,
                                                "dqi": 93.33981,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.00667",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99722",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "1",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1438",
                                                "timestamp": 1.6861032E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T03:00:00",
                                                "endPoint": "2023-06-07T04:00:00",
                                                "aswi": 95.24043,
                                                "dqi": 89.58623,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.7823",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.96945",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "11",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2238",
                                                "timestamp": 1.6861068E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T04:00:00",
                                                "endPoint": "2023-06-07T05:00:00",
                                                "aswi": 95.57003,
                                                "dqi": 90.05369,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.04611",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98611",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "5",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2143",
                                                "timestamp": 1.6861104E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T05:00:00",
                                                "endPoint": "2023-06-07T06:00:00",
                                                "aswi": 97.54748,
                                                "dqi": 93.46015,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.10109",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.97501",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "9",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1404",
                                                "timestamp": 1.686114E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T06:00:00",
                                                "endPoint": "2023-06-07T07:00:00",
                                                "aswi": 98.20595,
                                                "dqi": 94.68958,
                                                "frequency": "1",
                                                "dataCount": "3540",
                                                "score_frequency": "10",
                                                "score_stale": "7.21667",
                                                "score_dataGap": "9.82778",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.9887",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "62",
                                                "tt_dataGap": "62",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1019",
                                                "timestamp": 1.6861176E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T07:00:00",
                                                "endPoint": "2023-06-07T08:00:00",
                                                "aswi": 92.92808,
                                                "dqi": 87.17023,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "2.30771",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99445",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "2",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2769",
                                                "timestamp": 1.6861212E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T08:00:00",
                                                "endPoint": "2023-06-07T09:00:00",
                                                "aswi": 96.05505,
                                                "dqi": 90.78497,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.47099",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1990",
                                                "timestamp": 1.6861248E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T09:00:00",
                                                "endPoint": "2023-06-07T10:00:00",
                                                "aswi": 87.53126,
                                                "dqi": 84.49505,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.69705",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3349",
                                                "timestamp": 1.6861284E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T10:00:00",
                                                "endPoint": "2023-06-07T11:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.686132E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T11:00:00",
                                                "endPoint": "2023-06-07T12:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861356E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T12:00:00",
                                                "endPoint": "2023-06-07T13:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861392E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T13:00:00",
                                                "endPoint": "2023-06-07T14:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861428E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T14:00:00",
                                                "endPoint": "2023-06-07T15:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861464E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T15:00:00",
                                                "endPoint": "2023-06-07T16:00:00",
                                                "aswi": 81.3492,
                                                "dqi": 83.60178,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.16109",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3542",
                                                "timestamp": 1.68615E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T16:00:00",
                                                "endPoint": "2023-06-07T17:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861536E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T17:00:00",
                                                "endPoint": "2023-06-07T18:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861572E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T18:00:00",
                                                "endPoint": "2023-06-07T19:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861608E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T19:00:00",
                                                "endPoint": "2023-06-07T20:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861644E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T20:00:00",
                                                "endPoint": "2023-06-07T21:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.686168E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T21:00:00",
                                                "endPoint": "2023-06-07T22:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861716E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T22:00:00",
                                                "endPoint": "2023-06-07T23:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861752E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T23:00:00",
                                                "endPoint": "2023-06-08T00:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861788E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T00:00:00",
                                                "endPoint": "2023-06-08T01:00:00",
                                                "aswi": 81.13351,
                                                "dqi": 83.58789,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.15276",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3545",
                                                "timestamp": 1.6861824E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T01:00:00",
                                                "endPoint": "2023-06-08T02:00:00",
                                                "aswi": 81.70904,
                                                "dqi": 83.38523,
                                                "frequency": "1",
                                                "dataCount": "3584",
                                                "score_frequency": "10",
                                                "score_stale": "0.17778",
                                                "score_dataGap": "9.95",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99721",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "18",
                                                "tt_dataGap": "18",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "1",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3552",
                                                "timestamp": 1.686186E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T02:00:00",
                                                "endPoint": "2023-06-08T03:00:00",
                                                "aswi": 80.23346,
                                                "dqi": 83.53698,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.12221",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3556",
                                                "timestamp": 1.6861896E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T03:00:00",
                                                "endPoint": "2023-06-08T04:00:00",
                                                "aswi": 90.44058,
                                                "dqi": 75.67267,
                                                "frequency": "0.99892",
                                                "dataCount": "2777",
                                                "score_frequency": "9.9892",
                                                "score_stale": "2.28055",
                                                "score_dataGap": "7.7",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "828",
                                                "tt_dataGap": "828",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861932E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T04:00:00",
                                                "endPoint": "2023-06-08T05:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861968E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T05:00:00",
                                                "endPoint": "2023-06-08T06:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6862004E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T06:00:00",
                                                "endPoint": "2023-06-08T07:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.686204E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T07:00:00",
                                                "endPoint": "2023-06-08T08:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6862076E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T08:00:00",
                                                "endPoint": "2023-06-08T09:00:00",
                                                "aswi": 65.56721,
                                                "dqi": 80.65829,
                                                "frequency": "1.00033",
                                                "dataCount": "3022",
                                                "score_frequency": "10",
                                                "score_stale": "0.0033",
                                                "score_dataGap": "8.08342",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "579",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6862112E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T09:00:00",
                                                "endPoint": "2023-06-08T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862148E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T10:00:00",
                                                "endPoint": "2023-06-08T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862184E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T11:00:00",
                                                "endPoint": "2023-06-08T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686222E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T12:00:00",
                                                "endPoint": "2023-06-08T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862256E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T13:00:00",
                                                "endPoint": "2023-06-08T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862292E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T14:00:00",
                                                "endPoint": "2023-06-08T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862328E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T15:00:00",
                                                "endPoint": "2023-06-08T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862364E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T16:00:00",
                                                "endPoint": "2023-06-08T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68624E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T17:00:00",
                                                "endPoint": "2023-06-08T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862436E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T18:00:00",
                                                "endPoint": "2023-06-08T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862472E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T19:00:00",
                                                "endPoint": "2023-06-08T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862508E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T20:00:00",
                                                "endPoint": "2023-06-08T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862544E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T21:00:00",
                                                "endPoint": "2023-06-08T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686258E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T22:00:00",
                                                "endPoint": "2023-06-08T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862616E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T23:00:00",
                                                "endPoint": "2023-06-09T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862652E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T00:00:00",
                                                "endPoint": "2023-06-09T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862688E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T01:00:00",
                                                "endPoint": "2023-06-09T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862724E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T02:00:00",
                                                "endPoint": "2023-06-09T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686276E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T03:00:00",
                                                "endPoint": "2023-06-09T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862796E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T04:00:00",
                                                "endPoint": "2023-06-09T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862832E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T05:00:00",
                                                "endPoint": "2023-06-09T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862868E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T06:00:00",
                                                "endPoint": "2023-06-09T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862904E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T07:00:00",
                                                "endPoint": "2023-06-09T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686294E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T08:00:00",
                                                "endPoint": "2023-06-09T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862976E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T09:00:00",
                                                "endPoint": "2023-06-09T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863012E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T10:00:00",
                                                "endPoint": "2023-06-09T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863048E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T11:00:00",
                                                "endPoint": "2023-06-09T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863084E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T12:00:00",
                                                "endPoint": "2023-06-09T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686312E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T13:00:00",
                                                "endPoint": "2023-06-09T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863156E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T14:00:00",
                                                "endPoint": "2023-06-09T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863192E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T15:00:00",
                                                "endPoint": "2023-06-09T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863228E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T16:00:00",
                                                "endPoint": "2023-06-09T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863264E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T17:00:00",
                                                "endPoint": "2023-06-09T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68633E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T18:00:00",
                                                "endPoint": "2023-06-09T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863336E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T19:00:00",
                                                "endPoint": "2023-06-09T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863372E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T20:00:00",
                                                "endPoint": "2023-06-09T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863408E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T21:00:00",
                                                "endPoint": "2023-06-09T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863444E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T22:00:00",
                                                "endPoint": "2023-06-09T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686348E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T23:00:00",
                                                "endPoint": "2023-06-10T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863516E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T00:00:00",
                                                "endPoint": "2023-06-10T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863552E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T01:00:00",
                                                "endPoint": "2023-06-10T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863588E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T02:00:00",
                                                "endPoint": "2023-06-10T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863624E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T03:00:00",
                                                "endPoint": "2023-06-10T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686366E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T04:00:00",
                                                "endPoint": "2023-06-10T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863696E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T05:00:00",
                                                "endPoint": "2023-06-10T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863732E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T06:00:00",
                                                "endPoint": "2023-06-10T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863768E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T07:00:00",
                                                "endPoint": "2023-06-10T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863804E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T08:00:00",
                                                "endPoint": "2023-06-10T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686384E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T09:00:00",
                                                "endPoint": "2023-06-10T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863876E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T10:00:00",
                                                "endPoint": "2023-06-10T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863912E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T11:00:00",
                                                "endPoint": "2023-06-10T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863948E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T12:00:00",
                                                "endPoint": "2023-06-10T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863984E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T13:00:00",
                                                "endPoint": "2023-06-10T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686402E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T14:00:00",
                                                "endPoint": "2023-06-10T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864056E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T15:00:00",
                                                "endPoint": "2023-06-10T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864092E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T16:00:00",
                                                "endPoint": "2023-06-10T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864128E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T17:00:00",
                                                "endPoint": "2023-06-10T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864164E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T18:00:00",
                                                "endPoint": "2023-06-10T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68642E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T19:00:00",
                                                "endPoint": "2023-06-10T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864236E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T20:00:00",
                                                "endPoint": "2023-06-10T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864272E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T21:00:00",
                                                "endPoint": "2023-06-10T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864308E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T22:00:00",
                                                "endPoint": "2023-06-10T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864344E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T23:00:00",
                                                "endPoint": "2023-06-11T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686438E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T00:00:00",
                                                "endPoint": "2023-06-11T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864416E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T01:00:00",
                                                "endPoint": "2023-06-11T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864452E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T02:00:00",
                                                "endPoint": "2023-06-11T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864488E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T03:00:00",
                                                "endPoint": "2023-06-11T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864524E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T04:00:00",
                                                "endPoint": "2023-06-11T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686456E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T05:00:00",
                                                "endPoint": "2023-06-11T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864596E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T06:00:00",
                                                "endPoint": "2023-06-11T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864632E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T07:00:00",
                                                "endPoint": "2023-06-11T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864668E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T08:00:00",
                                                "endPoint": "2023-06-11T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864704E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T09:00:00",
                                                "endPoint": "2023-06-11T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686474E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T10:00:00",
                                                "endPoint": "2023-06-11T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864776E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T11:00:00",
                                                "endPoint": "2023-06-11T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864812E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T12:00:00",
                                                "endPoint": "2023-06-11T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864848E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T13:00:00",
                                                "endPoint": "2023-06-11T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864884E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T14:00:00",
                                                "endPoint": "2023-06-11T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686492E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T15:00:00",
                                                "endPoint": "2023-06-11T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864956E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T16:00:00",
                                                "endPoint": "2023-06-11T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864992E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T17:00:00",
                                                "endPoint": "2023-06-11T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865028E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T18:00:00",
                                                "endPoint": "2023-06-11T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865064E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T19:00:00",
                                                "endPoint": "2023-06-11T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68651E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T20:00:00",
                                                "endPoint": "2023-06-11T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865136E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T21:00:00",
                                                "endPoint": "2023-06-11T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865172E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T22:00:00",
                                                "endPoint": "2023-06-11T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865208E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T23:00:00",
                                                "endPoint": "2023-06-12T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865244E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T00:00:00",
                                                "endPoint": "2023-06-12T01:00:00",
                                                "aswi": 54.62455,
                                                "dqi": 75.00925,
                                                "frequency": "1.00056",
                                                "dataCount": "1801",
                                                "score_frequency": "10",
                                                "score_stale": "0.00559",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "1800",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3598",
                                                "timestamp": 1.686528E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T01:00:00",
                                                "endPoint": "2023-06-12T02:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865316E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T02:00:00",
                                                "endPoint": "2023-06-12T03:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865352E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T03:00:00",
                                                "endPoint": "2023-06-12T04:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865388E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T04:00:00",
                                                "endPoint": "2023-06-12T05:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865424E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T05:00:00",
                                                "endPoint": "2023-06-12T06:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.686546E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T06:00:00",
                                                "endPoint": "2023-06-12T07:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865496E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T07:00:00",
                                                "endPoint": "2023-06-12T08:00:00",
                                                "aswi": 95.30138,
                                                "dqi": 89.71582,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.8545",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.97778",
                                                "score_minValue": "10",
                                                "score_precision": "9.99722",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "8",
                                                "tt_minValue": "0",
                                                "tt_precision": "1",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2212",
                                                "timestamp": 1.6865532E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T08:00:00",
                                                "endPoint": "2023-06-12T09:00:00",
                                                "aswi": 98.67699,
                                                "dqi": 96.09831,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.6701",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98889",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "839",
                                                "timestamp": 1.6865568E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T09:00:00",
                                                "endPoint": "2023-06-12T10:00:00",
                                                "aswi": 95.92591,
                                                "dqi": 90.57669,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.35714",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98889",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "4",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2031",
                                                "timestamp": 1.6865604E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T10:00:00",
                                                "endPoint": "2023-06-12T11:00:00",
                                                "aswi": 82.47309,
                                                "dqi": 83.65269,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.21385",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.97778",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "8",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3523",
                                                "timestamp": 1.686564E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T11:00:00",
                                                "endPoint": "2023-06-12T12:00:00",
                                                "aswi": 95.06351,
                                                "dqi": 89.38258,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.63512",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99445",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "2",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2291",
                                                "timestamp": 1.6865676E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T12:00:00",
                                                "endPoint": "2023-06-12T13:00:00",
                                                "aswi": 96.5101,
                                                "dqi": 91.53013,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.93475",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.99167",
                                                "score_minValue": "10",
                                                "score_precision": "9.99167",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1823",
                                                "timestamp": 1.6865712E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T13:00:00",
                                                "endPoint": "2023-06-12T14:00:00",
                                                "aswi": 97.54982,
                                                "dqi": 93.52958,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.1483",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.97778",
                                                "score_minValue": "10",
                                                "score_precision": "9.99167",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "8",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1387",
                                                "timestamp": 1.6865748E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T14:00:00",
                                                "endPoint": "2023-06-12T15:00:00",
                                                "aswi": 95.11289,
                                                "dqi": 89.46126,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.70176",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.98056",
                                                "score_minValue": "10",
                                                "score_precision": "9.99445",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "7",
                                                "tt_minValue": "0",
                                                "tt_precision": "2",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2267",
                                                "timestamp": 1.6865784E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T15:00:00",
                                                "endPoint": "2023-06-12T16:00:00",
                                                "aswi": 95.50467,
                                                "dqi": 89.97038,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.00446",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.99167",
                                                "score_minValue": "10",
                                                "score_precision": "9.98611",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "3",
                                                "tt_minValue": "0",
                                                "tt_precision": "5",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2158",
                                                "timestamp": 1.686582E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T16:00:00",
                                                "endPoint": "2023-06-12T17:00:00",
                                                "aswi": 97.21954,
                                                "dqi": 92.88161,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.75952",
                                                "score_dataGap": "10",
                                                "score_maxValue": "9.96945",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "11",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1527",
                                                "timestamp": 1.6865856E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T17:00:00",
                                                "endPoint": "2023-06-12T18:00:00",
                                                "aswi": 95.41172,
                                                "dqi": 89.44685,
                                                "frequency": "1",
                                                "dataCount": "3553",
                                                "score_frequency": "10",
                                                "score_stale": "4.03889",
                                                "score_dataGap": "9.86389",
                                                "score_maxValue": "9.98874",
                                                "score_minValue": "10",
                                                "score_precision": "9.99156",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "49",
                                                "tt_dataGap": "49",
                                                "tt_maxValue": "4",
                                                "tt_minValue": "0",
                                                "tt_precision": "3",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2174",
                                                "timestamp": 1.6865892E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T18:00:00",
                                                "endPoint": "2023-06-12T19:00:00",
                                                "aswi": 97.68901,
                                                "dqi": 92.95556,
                                                "frequency": "0.9997",
                                                "dataCount": "3375",
                                                "score_frequency": "9.997",
                                                "score_stale": "7.2714",
                                                "score_dataGap": "9.36667",
                                                "score_maxValue": "9.96444",
                                                "score_minValue": "10",
                                                "score_precision": "9.98519",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "228",
                                                "tt_dataGap": "228",
                                                "tt_maxValue": "13",
                                                "tt_minValue": "0",
                                                "tt_precision": "5",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1047",
                                                "timestamp": 1.6865928E12
                                            }
                                        ]
                                    },
                                    {
                                        "name": "DEPT",
                                        "totalASWI": 20.61,
                                        "totalDQI": 21.84,
                                        "pageSize": "10000000",
                                        "currentPage": "1",
                                        "totalRecord": 693.0,
                                        "records": [
                                            {
                                                "startPoint": "2023-05-22T23:00:00",
                                                "endPoint": "2023-05-23T00:00:00",
                                                "aswi": 58.46337,
                                                "dqi": 68.83245,
                                                "frequency": "1.00218",
                                                "dataCount": "461",
                                                "score_frequency": "10",
                                                "score_stale": "0.02176",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "3140",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3592",
                                                "timestamp": 1.6847964E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T00:00:00",
                                                "endPoint": "2023-05-23T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6848E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T01:00:00",
                                                "endPoint": "2023-05-23T02:00:00",
                                                "aswi": 74.1155,
                                                "dqi": 83.37499,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.02501",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3591",
                                                "timestamp": 1.6848036E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T02:00:00",
                                                "endPoint": "2023-05-23T03:00:00",
                                                "aswi": 91.16499,
                                                "dqi": 85.93446,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "1.57458",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.98611",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "5",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3033",
                                                "timestamp": 1.6848072E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T03:00:00",
                                                "endPoint": "2023-05-23T04:00:00",
                                                "aswi": 94.66671,
                                                "dqi": 88.84106,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.36019",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94446",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "20",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2390",
                                                "timestamp": 1.6848108E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T04:00:00",
                                                "endPoint": "2023-05-23T05:00:00",
                                                "aswi": 92.52892,
                                                "dqi": 86.80922,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "2.12443",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.96112",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "14",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2835",
                                                "timestamp": 1.6848144E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T05:00:00",
                                                "endPoint": "2023-05-23T06:00:00",
                                                "aswi": 95.91083,
                                                "dqi": 90.46561,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.38491",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.89447",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "38",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2021",
                                                "timestamp": 1.684818E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T06:00:00",
                                                "endPoint": "2023-05-23T07:00:00",
                                                "aswi": 99.14622,
                                                "dqi": 97.35259,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.49487",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.91669",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "30",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "542",
                                                "timestamp": 1.6848216E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T07:00:00",
                                                "endPoint": "2023-05-23T08:00:00",
                                                "aswi": 97.89397,
                                                "dqi": 94.17754,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.58429",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92224",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "28",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1230",
                                                "timestamp": 1.6848252E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T08:00:00",
                                                "endPoint": "2023-05-23T09:00:00",
                                                "aswi": 97.64964,
                                                "dqi": 93.65454,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.25105",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94168",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "21",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1350",
                                                "timestamp": 1.6848288E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T09:00:00",
                                                "endPoint": "2023-05-23T10:00:00",
                                                "aswi": 97.59789,
                                                "dqi": 93.5342,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.19551",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92502",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "27",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1370",
                                                "timestamp": 1.6848324E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T10:00:00",
                                                "endPoint": "2023-05-23T11:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.684836E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T11:00:00",
                                                "endPoint": "2023-05-23T12:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848396E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T12:00:00",
                                                "endPoint": "2023-05-23T13:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848432E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T13:00:00",
                                                "endPoint": "2023-05-23T14:00:00",
                                                "aswi": 95.39063,
                                                "dqi": 89.78524,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.90448",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.96668",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "12",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2194",
                                                "timestamp": 1.6848468E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T14:00:00",
                                                "endPoint": "2023-05-23T15:00:00",
                                                "aswi": 99.14112,
                                                "dqi": 97.33407,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.50042",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.90003",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "36",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "540",
                                                "timestamp": 1.6848504E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T15:00:00",
                                                "endPoint": "2023-05-23T16:00:00",
                                                "aswi": 97.42231,
                                                "dqi": 92.37249,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.31742",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "8.10608",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "682",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "966",
                                                "timestamp": 1.684854E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T16:00:00",
                                                "endPoint": "2023-05-23T17:00:00",
                                                "aswi": 98.70516,
                                                "dqi": 96.15385,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.75063",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94168",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "21",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "810",
                                                "timestamp": 1.6848576E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T17:00:00",
                                                "endPoint": "2023-05-23T18:00:00",
                                                "aswi": 98.63559,
                                                "dqi": 95.96871,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.65066",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93057",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "25",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "846",
                                                "timestamp": 1.6848612E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T18:00:00",
                                                "endPoint": "2023-05-23T19:00:00",
                                                "aswi": 98.65685,
                                                "dqi": 96.01962,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.69231",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.91947",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "29",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "831",
                                                "timestamp": 1.6848648E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T19:00:00",
                                                "endPoint": "2023-05-23T20:00:00",
                                                "aswi": 95.86014,
                                                "dqi": 89.10341,
                                                "frequency": "1",
                                                "dataCount": "3424",
                                                "score_frequency": "10",
                                                "score_stale": "4.78056",
                                                "score_dataGap": "9.50556",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93867",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "178",
                                                "tt_dataGap": "178",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "22",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1976",
                                                "timestamp": 1.6848684E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T20:00:00",
                                                "endPoint": "2023-05-23T21:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.684872E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T21:00:00",
                                                "endPoint": "2023-05-23T22:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848756E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T22:00:00",
                                                "endPoint": "2023-05-23T23:00:00",
                                                "aswi": 88.08471,
                                                "dqi": 80.06069,
                                                "frequency": "0.99969",
                                                "dataCount": "3249",
                                                "score_frequency": "9.9969",
                                                "score_stale": "0.97498",
                                                "score_dataGap": "9.01667",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "354",
                                                "tt_dataGap": "354",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848792E12
                                            },
                                            {
                                                "startPoint": "2023-05-23T23:00:00",
                                                "endPoint": "2023-05-24T00:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848828E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T00:00:00",
                                                "endPoint": "2023-05-24T01:00:00",
                                                "aswi": 90.17564,
                                                "dqi": 76.59839,
                                                "frequency": "0.99896",
                                                "dataCount": "2877",
                                                "score_frequency": "9.9896",
                                                "score_stale": "2.00279",
                                                "score_dataGap": "7.97778",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "728",
                                                "tt_dataGap": "728",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848864E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T01:00:00",
                                                "endPoint": "2023-05-24T02:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.68489E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T02:00:00",
                                                "endPoint": "2023-05-24T03:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848936E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T03:00:00",
                                                "endPoint": "2023-05-24T04:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6848972E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T04:00:00",
                                                "endPoint": "2023-05-24T05:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6849008E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T05:00:00",
                                                "endPoint": "2023-05-24T06:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6849044E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T06:00:00",
                                                "endPoint": "2023-05-24T07:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.684908E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T07:00:00",
                                                "endPoint": "2023-05-24T08:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6849116E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T08:00:00",
                                                "endPoint": "2023-05-24T09:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6849152E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T09:00:00",
                                                "endPoint": "2023-05-24T10:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6849188E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T10:00:00",
                                                "endPoint": "2023-05-24T11:00:00",
                                                "aswi": 88.04508,
                                                "dqi": 80.09772,
                                                "frequency": "0.99969",
                                                "dataCount": "3253",
                                                "score_frequency": "9.9969",
                                                "score_stale": "0.96387",
                                                "score_dataGap": "9.02778",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "350",
                                                "tt_dataGap": "350",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6849224E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T11:00:00",
                                                "endPoint": "2023-05-24T12:00:00",
                                                "aswi": 55.64312,
                                                "dqi": 72.41622,
                                                "frequency": "1.00081",
                                                "dataCount": "1240",
                                                "score_frequency": "10",
                                                "score_stale": "0.0081",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "2361",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3597",
                                                "timestamp": 1.684926E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T12:00:00",
                                                "endPoint": "2023-05-24T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849296E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T13:00:00",
                                                "endPoint": "2023-05-24T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849332E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T14:00:00",
                                                "endPoint": "2023-05-24T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849368E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T15:00:00",
                                                "endPoint": "2023-05-24T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849404E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T16:00:00",
                                                "endPoint": "2023-05-24T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684944E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T17:00:00",
                                                "endPoint": "2023-05-24T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849476E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T18:00:00",
                                                "endPoint": "2023-05-24T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849512E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T19:00:00",
                                                "endPoint": "2023-05-24T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849548E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T20:00:00",
                                                "endPoint": "2023-05-24T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849584E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T21:00:00",
                                                "endPoint": "2023-05-24T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684962E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T22:00:00",
                                                "endPoint": "2023-05-24T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849656E12
                                            },
                                            {
                                                "startPoint": "2023-05-24T23:00:00",
                                                "endPoint": "2023-05-25T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849692E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T00:00:00",
                                                "endPoint": "2023-05-25T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849728E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T01:00:00",
                                                "endPoint": "2023-05-25T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849764E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T02:00:00",
                                                "endPoint": "2023-05-25T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68498E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T03:00:00",
                                                "endPoint": "2023-05-25T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849836E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T04:00:00",
                                                "endPoint": "2023-05-25T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849872E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T05:00:00",
                                                "endPoint": "2023-05-25T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849908E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T06:00:00",
                                                "endPoint": "2023-05-25T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6849944E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T07:00:00",
                                                "endPoint": "2023-05-25T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.684998E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T08:00:00",
                                                "endPoint": "2023-05-25T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850016E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T09:00:00",
                                                "endPoint": "2023-05-25T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850052E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T10:00:00",
                                                "endPoint": "2023-05-25T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850088E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T11:00:00",
                                                "endPoint": "2023-05-25T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850124E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T12:00:00",
                                                "endPoint": "2023-05-25T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685016E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T13:00:00",
                                                "endPoint": "2023-05-25T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850196E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T14:00:00",
                                                "endPoint": "2023-05-25T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850232E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T15:00:00",
                                                "endPoint": "2023-05-25T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850268E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T16:00:00",
                                                "endPoint": "2023-05-25T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850304E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T17:00:00",
                                                "endPoint": "2023-05-25T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685034E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T18:00:00",
                                                "endPoint": "2023-05-25T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850376E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T19:00:00",
                                                "endPoint": "2023-05-25T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850412E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T20:00:00",
                                                "endPoint": "2023-05-25T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850448E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T21:00:00",
                                                "endPoint": "2023-05-25T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850484E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T22:00:00",
                                                "endPoint": "2023-05-25T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685052E12
                                            },
                                            {
                                                "startPoint": "2023-05-25T23:00:00",
                                                "endPoint": "2023-05-26T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850556E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T00:00:00",
                                                "endPoint": "2023-05-26T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850592E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T01:00:00",
                                                "endPoint": "2023-05-26T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850628E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T02:00:00",
                                                "endPoint": "2023-05-26T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850664E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T03:00:00",
                                                "endPoint": "2023-05-26T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68507E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T04:00:00",
                                                "endPoint": "2023-05-26T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850736E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T05:00:00",
                                                "endPoint": "2023-05-26T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850772E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T06:00:00",
                                                "endPoint": "2023-05-26T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850808E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T07:00:00",
                                                "endPoint": "2023-05-26T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850844E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T08:00:00",
                                                "endPoint": "2023-05-26T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685088E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T09:00:00",
                                                "endPoint": "2023-05-26T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850916E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T10:00:00",
                                                "endPoint": "2023-05-26T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850952E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T11:00:00",
                                                "endPoint": "2023-05-26T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6850988E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T12:00:00",
                                                "endPoint": "2023-05-26T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851024E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T13:00:00",
                                                "endPoint": "2023-05-26T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685106E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T14:00:00",
                                                "endPoint": "2023-05-26T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851096E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T15:00:00",
                                                "endPoint": "2023-05-26T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851132E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T16:00:00",
                                                "endPoint": "2023-05-26T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851168E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T17:00:00",
                                                "endPoint": "2023-05-26T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851204E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T18:00:00",
                                                "endPoint": "2023-05-26T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685124E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T19:00:00",
                                                "endPoint": "2023-05-26T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851276E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T20:00:00",
                                                "endPoint": "2023-05-26T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851312E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T21:00:00",
                                                "endPoint": "2023-05-26T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851348E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T22:00:00",
                                                "endPoint": "2023-05-26T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851384E12
                                            },
                                            {
                                                "startPoint": "2023-05-26T23:00:00",
                                                "endPoint": "2023-05-27T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685142E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T00:00:00",
                                                "endPoint": "2023-05-27T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851456E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T01:00:00",
                                                "endPoint": "2023-05-27T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851492E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T02:00:00",
                                                "endPoint": "2023-05-27T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851528E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T03:00:00",
                                                "endPoint": "2023-05-27T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851564E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T04:00:00",
                                                "endPoint": "2023-05-27T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68516E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T05:00:00",
                                                "endPoint": "2023-05-27T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851636E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T06:00:00",
                                                "endPoint": "2023-05-27T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851672E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T07:00:00",
                                                "endPoint": "2023-05-27T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851708E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T08:00:00",
                                                "endPoint": "2023-05-27T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851744E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T09:00:00",
                                                "endPoint": "2023-05-27T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685178E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T10:00:00",
                                                "endPoint": "2023-05-27T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851816E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T11:00:00",
                                                "endPoint": "2023-05-27T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851852E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T12:00:00",
                                                "endPoint": "2023-05-27T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851888E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T13:00:00",
                                                "endPoint": "2023-05-27T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851924E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T14:00:00",
                                                "endPoint": "2023-05-27T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685196E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T15:00:00",
                                                "endPoint": "2023-05-27T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6851996E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T16:00:00",
                                                "endPoint": "2023-05-27T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852032E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T17:00:00",
                                                "endPoint": "2023-05-27T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852068E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T18:00:00",
                                                "endPoint": "2023-05-27T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852104E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T19:00:00",
                                                "endPoint": "2023-05-27T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685214E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T20:00:00",
                                                "endPoint": "2023-05-27T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852176E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T21:00:00",
                                                "endPoint": "2023-05-27T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852212E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T22:00:00",
                                                "endPoint": "2023-05-27T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852248E12
                                            },
                                            {
                                                "startPoint": "2023-05-27T23:00:00",
                                                "endPoint": "2023-05-28T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852284E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T00:00:00",
                                                "endPoint": "2023-05-28T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685232E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T01:00:00",
                                                "endPoint": "2023-05-28T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852356E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T02:00:00",
                                                "endPoint": "2023-05-28T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852392E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T03:00:00",
                                                "endPoint": "2023-05-28T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852428E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T04:00:00",
                                                "endPoint": "2023-05-28T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852464E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T05:00:00",
                                                "endPoint": "2023-05-28T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68525E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T06:00:00",
                                                "endPoint": "2023-05-28T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852536E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T07:00:00",
                                                "endPoint": "2023-05-28T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852572E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T08:00:00",
                                                "endPoint": "2023-05-28T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852608E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T09:00:00",
                                                "endPoint": "2023-05-28T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852644E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T10:00:00",
                                                "endPoint": "2023-05-28T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685268E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T11:00:00",
                                                "endPoint": "2023-05-28T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852716E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T12:00:00",
                                                "endPoint": "2023-05-28T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852752E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T13:00:00",
                                                "endPoint": "2023-05-28T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852788E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T14:00:00",
                                                "endPoint": "2023-05-28T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852824E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T15:00:00",
                                                "endPoint": "2023-05-28T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685286E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T16:00:00",
                                                "endPoint": "2023-05-28T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852896E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T17:00:00",
                                                "endPoint": "2023-05-28T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852932E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T18:00:00",
                                                "endPoint": "2023-05-28T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6852968E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T19:00:00",
                                                "endPoint": "2023-05-28T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853004E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T20:00:00",
                                                "endPoint": "2023-05-28T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685304E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T21:00:00",
                                                "endPoint": "2023-05-28T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853076E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T22:00:00",
                                                "endPoint": "2023-05-28T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853112E12
                                            },
                                            {
                                                "startPoint": "2023-05-28T23:00:00",
                                                "endPoint": "2023-05-29T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853148E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T00:00:00",
                                                "endPoint": "2023-05-29T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853184E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T01:00:00",
                                                "endPoint": "2023-05-29T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685322E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T02:00:00",
                                                "endPoint": "2023-05-29T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853256E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T03:00:00",
                                                "endPoint": "2023-05-29T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853292E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T04:00:00",
                                                "endPoint": "2023-05-29T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853328E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T05:00:00",
                                                "endPoint": "2023-05-29T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853364E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T06:00:00",
                                                "endPoint": "2023-05-29T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68534E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T07:00:00",
                                                "endPoint": "2023-05-29T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853436E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T08:00:00",
                                                "endPoint": "2023-05-29T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853472E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T09:00:00",
                                                "endPoint": "2023-05-29T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853508E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T10:00:00",
                                                "endPoint": "2023-05-29T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853544E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T11:00:00",
                                                "endPoint": "2023-05-29T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685358E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T12:00:00",
                                                "endPoint": "2023-05-29T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853616E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T13:00:00",
                                                "endPoint": "2023-05-29T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853652E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T14:00:00",
                                                "endPoint": "2023-05-29T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853688E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T15:00:00",
                                                "endPoint": "2023-05-29T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853724E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T16:00:00",
                                                "endPoint": "2023-05-29T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685376E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T17:00:00",
                                                "endPoint": "2023-05-29T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853796E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T18:00:00",
                                                "endPoint": "2023-05-29T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853832E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T19:00:00",
                                                "endPoint": "2023-05-29T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853868E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T20:00:00",
                                                "endPoint": "2023-05-29T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853904E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T21:00:00",
                                                "endPoint": "2023-05-29T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685394E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T22:00:00",
                                                "endPoint": "2023-05-29T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6853976E12
                                            },
                                            {
                                                "startPoint": "2023-05-29T23:00:00",
                                                "endPoint": "2023-05-30T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854012E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T00:00:00",
                                                "endPoint": "2023-05-30T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854048E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T01:00:00",
                                                "endPoint": "2023-05-30T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854084E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T02:00:00",
                                                "endPoint": "2023-05-30T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685412E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T03:00:00",
                                                "endPoint": "2023-05-30T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854156E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T04:00:00",
                                                "endPoint": "2023-05-30T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854192E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T05:00:00",
                                                "endPoint": "2023-05-30T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854228E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T06:00:00",
                                                "endPoint": "2023-05-30T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854264E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T07:00:00",
                                                "endPoint": "2023-05-30T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68543E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T08:00:00",
                                                "endPoint": "2023-05-30T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854336E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T09:00:00",
                                                "endPoint": "2023-05-30T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854372E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T10:00:00",
                                                "endPoint": "2023-05-30T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854408E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T11:00:00",
                                                "endPoint": "2023-05-30T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854444E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T12:00:00",
                                                "endPoint": "2023-05-30T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685448E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T13:00:00",
                                                "endPoint": "2023-05-30T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854516E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T14:00:00",
                                                "endPoint": "2023-05-30T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854552E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T15:00:00",
                                                "endPoint": "2023-05-30T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854588E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T16:00:00",
                                                "endPoint": "2023-05-30T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854624E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T17:00:00",
                                                "endPoint": "2023-05-30T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685466E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T18:00:00",
                                                "endPoint": "2023-05-30T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854696E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T19:00:00",
                                                "endPoint": "2023-05-30T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854732E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T20:00:00",
                                                "endPoint": "2023-05-30T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854768E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T21:00:00",
                                                "endPoint": "2023-05-30T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854804E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T22:00:00",
                                                "endPoint": "2023-05-30T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685484E12
                                            },
                                            {
                                                "startPoint": "2023-05-30T23:00:00",
                                                "endPoint": "2023-05-31T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854876E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T00:00:00",
                                                "endPoint": "2023-05-31T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854912E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T01:00:00",
                                                "endPoint": "2023-05-31T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854948E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T02:00:00",
                                                "endPoint": "2023-05-31T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6854984E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T03:00:00",
                                                "endPoint": "2023-05-31T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685502E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T04:00:00",
                                                "endPoint": "2023-05-31T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855056E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T05:00:00",
                                                "endPoint": "2023-05-31T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855092E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T06:00:00",
                                                "endPoint": "2023-05-31T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855128E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T07:00:00",
                                                "endPoint": "2023-05-31T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855164E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T08:00:00",
                                                "endPoint": "2023-05-31T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68552E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T09:00:00",
                                                "endPoint": "2023-05-31T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855236E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T10:00:00",
                                                "endPoint": "2023-05-31T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855272E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T11:00:00",
                                                "endPoint": "2023-05-31T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855308E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T12:00:00",
                                                "endPoint": "2023-05-31T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855344E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T13:00:00",
                                                "endPoint": "2023-05-31T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685538E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T14:00:00",
                                                "endPoint": "2023-05-31T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855416E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T15:00:00",
                                                "endPoint": "2023-05-31T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855452E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T16:00:00",
                                                "endPoint": "2023-05-31T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855488E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T17:00:00",
                                                "endPoint": "2023-05-31T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855524E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T18:00:00",
                                                "endPoint": "2023-05-31T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685556E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T19:00:00",
                                                "endPoint": "2023-05-31T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855596E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T20:00:00",
                                                "endPoint": "2023-05-31T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855632E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T21:00:00",
                                                "endPoint": "2023-05-31T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855668E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T22:00:00",
                                                "endPoint": "2023-05-31T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855704E12
                                            },
                                            {
                                                "startPoint": "2023-05-31T23:00:00",
                                                "endPoint": "2023-06-01T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685574E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T00:00:00",
                                                "endPoint": "2023-06-01T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855776E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T01:00:00",
                                                "endPoint": "2023-06-01T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855812E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T02:00:00",
                                                "endPoint": "2023-06-01T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855848E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T03:00:00",
                                                "endPoint": "2023-06-01T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855884E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T04:00:00",
                                                "endPoint": "2023-06-01T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685592E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T05:00:00",
                                                "endPoint": "2023-06-01T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855956E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T06:00:00",
                                                "endPoint": "2023-06-01T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6855992E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T07:00:00",
                                                "endPoint": "2023-06-01T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856028E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T08:00:00",
                                                "endPoint": "2023-06-01T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856064E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T09:00:00",
                                                "endPoint": "2023-06-01T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68561E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T10:00:00",
                                                "endPoint": "2023-06-01T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856136E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T11:00:00",
                                                "endPoint": "2023-06-01T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856172E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T12:00:00",
                                                "endPoint": "2023-06-01T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856208E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T13:00:00",
                                                "endPoint": "2023-06-01T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856244E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T14:00:00",
                                                "endPoint": "2023-06-01T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685628E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T15:00:00",
                                                "endPoint": "2023-06-01T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856316E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T16:00:00",
                                                "endPoint": "2023-06-01T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856352E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T17:00:00",
                                                "endPoint": "2023-06-01T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856388E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T18:00:00",
                                                "endPoint": "2023-06-01T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856424E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T19:00:00",
                                                "endPoint": "2023-06-01T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685646E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T20:00:00",
                                                "endPoint": "2023-06-01T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856496E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T21:00:00",
                                                "endPoint": "2023-06-01T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856532E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T22:00:00",
                                                "endPoint": "2023-06-01T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856568E12
                                            },
                                            {
                                                "startPoint": "2023-06-01T23:00:00",
                                                "endPoint": "2023-06-02T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856604E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T00:00:00",
                                                "endPoint": "2023-06-02T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685664E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T01:00:00",
                                                "endPoint": "2023-06-02T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856676E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T02:00:00",
                                                "endPoint": "2023-06-02T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856712E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T03:00:00",
                                                "endPoint": "2023-06-02T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856748E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T04:00:00",
                                                "endPoint": "2023-06-02T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856784E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T05:00:00",
                                                "endPoint": "2023-06-02T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685682E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T06:00:00",
                                                "endPoint": "2023-06-02T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856856E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T07:00:00",
                                                "endPoint": "2023-06-02T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856892E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T08:00:00",
                                                "endPoint": "2023-06-02T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856928E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T09:00:00",
                                                "endPoint": "2023-06-02T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6856964E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T10:00:00",
                                                "endPoint": "2023-06-02T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T11:00:00",
                                                "endPoint": "2023-06-02T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857036E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T12:00:00",
                                                "endPoint": "2023-06-02T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857072E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T13:00:00",
                                                "endPoint": "2023-06-02T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857108E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T14:00:00",
                                                "endPoint": "2023-06-02T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857144E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T15:00:00",
                                                "endPoint": "2023-06-02T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685718E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T16:00:00",
                                                "endPoint": "2023-06-02T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857216E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T17:00:00",
                                                "endPoint": "2023-06-02T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857252E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T18:00:00",
                                                "endPoint": "2023-06-02T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857288E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T19:00:00",
                                                "endPoint": "2023-06-02T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857324E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T20:00:00",
                                                "endPoint": "2023-06-02T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685736E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T21:00:00",
                                                "endPoint": "2023-06-02T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857396E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T22:00:00",
                                                "endPoint": "2023-06-02T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857432E12
                                            },
                                            {
                                                "startPoint": "2023-06-02T23:00:00",
                                                "endPoint": "2023-06-03T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857468E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T00:00:00",
                                                "endPoint": "2023-06-03T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857504E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T01:00:00",
                                                "endPoint": "2023-06-03T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685754E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T02:00:00",
                                                "endPoint": "2023-06-03T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857576E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T03:00:00",
                                                "endPoint": "2023-06-03T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857612E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T04:00:00",
                                                "endPoint": "2023-06-03T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857648E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T05:00:00",
                                                "endPoint": "2023-06-03T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857684E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T06:00:00",
                                                "endPoint": "2023-06-03T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685772E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T07:00:00",
                                                "endPoint": "2023-06-03T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857756E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T08:00:00",
                                                "endPoint": "2023-06-03T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857792E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T09:00:00",
                                                "endPoint": "2023-06-03T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857828E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T10:00:00",
                                                "endPoint": "2023-06-03T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857864E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T11:00:00",
                                                "endPoint": "2023-06-03T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68579E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T12:00:00",
                                                "endPoint": "2023-06-03T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857936E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T13:00:00",
                                                "endPoint": "2023-06-03T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6857972E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T14:00:00",
                                                "endPoint": "2023-06-03T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858008E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T15:00:00",
                                                "endPoint": "2023-06-03T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858044E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T16:00:00",
                                                "endPoint": "2023-06-03T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685808E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T17:00:00",
                                                "endPoint": "2023-06-03T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858116E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T18:00:00",
                                                "endPoint": "2023-06-03T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858152E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T19:00:00",
                                                "endPoint": "2023-06-03T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858188E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T20:00:00",
                                                "endPoint": "2023-06-03T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858224E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T21:00:00",
                                                "endPoint": "2023-06-03T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685826E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T22:00:00",
                                                "endPoint": "2023-06-03T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858296E12
                                            },
                                            {
                                                "startPoint": "2023-06-03T23:00:00",
                                                "endPoint": "2023-06-04T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858332E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T00:00:00",
                                                "endPoint": "2023-06-04T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858368E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T01:00:00",
                                                "endPoint": "2023-06-04T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858404E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T02:00:00",
                                                "endPoint": "2023-06-04T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685844E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T03:00:00",
                                                "endPoint": "2023-06-04T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858476E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T04:00:00",
                                                "endPoint": "2023-06-04T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858512E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T05:00:00",
                                                "endPoint": "2023-06-04T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858548E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T06:00:00",
                                                "endPoint": "2023-06-04T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858584E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T07:00:00",
                                                "endPoint": "2023-06-04T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685862E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T08:00:00",
                                                "endPoint": "2023-06-04T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858656E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T09:00:00",
                                                "endPoint": "2023-06-04T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858692E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T10:00:00",
                                                "endPoint": "2023-06-04T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858728E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T11:00:00",
                                                "endPoint": "2023-06-04T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858764E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T12:00:00",
                                                "endPoint": "2023-06-04T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68588E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T13:00:00",
                                                "endPoint": "2023-06-04T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858836E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T14:00:00",
                                                "endPoint": "2023-06-04T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858872E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T15:00:00",
                                                "endPoint": "2023-06-04T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858908E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T16:00:00",
                                                "endPoint": "2023-06-04T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6858944E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T17:00:00",
                                                "endPoint": "2023-06-04T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685898E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T18:00:00",
                                                "endPoint": "2023-06-04T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859016E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T19:00:00",
                                                "endPoint": "2023-06-04T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859052E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T20:00:00",
                                                "endPoint": "2023-06-04T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859088E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T21:00:00",
                                                "endPoint": "2023-06-04T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859124E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T22:00:00",
                                                "endPoint": "2023-06-04T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685916E12
                                            },
                                            {
                                                "startPoint": "2023-06-04T23:00:00",
                                                "endPoint": "2023-06-05T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859196E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T00:00:00",
                                                "endPoint": "2023-06-05T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859232E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T01:00:00",
                                                "endPoint": "2023-06-05T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859268E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T02:00:00",
                                                "endPoint": "2023-06-05T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859304E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T03:00:00",
                                                "endPoint": "2023-06-05T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685934E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T04:00:00",
                                                "endPoint": "2023-06-05T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859376E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T05:00:00",
                                                "endPoint": "2023-06-05T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859412E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T06:00:00",
                                                "endPoint": "2023-06-05T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859448E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T07:00:00",
                                                "endPoint": "2023-06-05T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859484E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T08:00:00",
                                                "endPoint": "2023-06-05T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.685952E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T09:00:00",
                                                "endPoint": "2023-06-05T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859556E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T10:00:00",
                                                "endPoint": "2023-06-05T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859592E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T11:00:00",
                                                "endPoint": "2023-06-05T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6859628E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T12:00:00",
                                                "endPoint": "2023-06-05T13:00:00",
                                                "aswi": 64.68461,
                                                "dqi": 79.17284,
                                                "frequency": "1.00037",
                                                "dataCount": "2701",
                                                "score_frequency": "10",
                                                "score_stale": "0.0037",
                                                "score_dataGap": "6.66667",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "900",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6859664E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T13:00:00",
                                                "endPoint": "2023-06-05T14:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.68597E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T14:00:00",
                                                "endPoint": "2023-06-05T15:00:00",
                                                "aswi": 68.75626,
                                                "dqi": 83.34259,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.00558",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3598",
                                                "timestamp": 1.6859736E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T15:00:00",
                                                "endPoint": "2023-06-05T16:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6859772E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T16:00:00",
                                                "endPoint": "2023-06-05T17:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6859808E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T17:00:00",
                                                "endPoint": "2023-06-05T18:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6859844E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T18:00:00",
                                                "endPoint": "2023-06-05T19:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.685988E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T19:00:00",
                                                "endPoint": "2023-06-05T20:00:00",
                                                "aswi": 89.00492,
                                                "dqi": 84.93056,
                                                "frequency": "1",
                                                "dataCount": "3600",
                                                "score_frequency": "10",
                                                "score_stale": "0.975",
                                                "score_dataGap": "9.99444",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99444",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "2",
                                                "tt_dataGap": "2",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "2",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3249",
                                                "timestamp": 1.6859916E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T20:00:00",
                                                "endPoint": "2023-06-05T21:00:00",
                                                "aswi": 95.67261,
                                                "dqi": 90.16477,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.14886",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95001",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "18",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2106",
                                                "timestamp": 1.6859952E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T21:00:00",
                                                "endPoint": "2023-06-05T22:00:00",
                                                "aswi": 98.15083,
                                                "dqi": 94.8745,
                                                "frequency": "1.00028",
                                                "dataCount": "3552",
                                                "score_frequency": "10",
                                                "score_stale": "7.12274",
                                                "score_dataGap": "9.86201",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93806",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "49",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "22",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1036",
                                                "timestamp": 1.6859988E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T22:00:00",
                                                "endPoint": "2023-06-05T23:00:00",
                                                "aswi": 68.66791,
                                                "dqi": 67.45749,
                                                "frequency": "0.99387",
                                                "dataCount": "165",
                                                "score_frequency": "9.9387",
                                                "score_stale": "0.57074",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "13",
                                                "tt_dataGap": "3438",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3578",
                                                "timestamp": 1.6860024E12
                                            },
                                            {
                                                "startPoint": "2023-06-05T23:00:00",
                                                "endPoint": "2023-06-06T00:00:00",
                                                "aswi": 94.27404,
                                                "dqi": 87.23629,
                                                "frequency": "0.99929",
                                                "dataCount": "2817",
                                                "score_frequency": "9.9929",
                                                "score_stale": "5.636",
                                                "score_dataGap": "7.42726",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94675",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "246",
                                                "tt_dataGap": "787",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "19",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1705",
                                                "timestamp": 1.686006E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T00:00:00",
                                                "endPoint": "2023-06-06T01:00:00",
                                                "aswi": 97.77741,
                                                "dqi": 93.93224,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.41489",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94446",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "20",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1291",
                                                "timestamp": 1.6860096E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T01:00:00",
                                                "endPoint": "2023-06-06T02:00:00",
                                                "aswi": 98.26763,
                                                "dqi": 95.05693,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.0897",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94446",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "20",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1048",
                                                "timestamp": 1.6860132E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T02:00:00",
                                                "endPoint": "2023-06-06T03:00:00",
                                                "aswi": 98.42819,
                                                "dqi": 95.45034,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.32297",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94724",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "19",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "964",
                                                "timestamp": 1.6860168E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T03:00:00",
                                                "endPoint": "2023-06-06T04:00:00",
                                                "aswi": 96.54793,
                                                "dqi": 91.56253,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.96807",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.96945",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "11",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1811",
                                                "timestamp": 1.6860204E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T04:00:00",
                                                "endPoint": "2023-06-06T05:00:00",
                                                "aswi": 98.74034,
                                                "dqi": 96.23253,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.83672",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.9028",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "35",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "779",
                                                "timestamp": 1.686024E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T05:00:00",
                                                "endPoint": "2023-06-06T06:00:00",
                                                "aswi": 97.31759,
                                                "dqi": 92.97417,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.8345",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95001",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "18",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1500",
                                                "timestamp": 1.6860276E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T06:00:00",
                                                "endPoint": "2023-06-06T07:00:00",
                                                "aswi": 99.1314,
                                                "dqi": 97.3063,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.48376",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.90003",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "36",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "546",
                                                "timestamp": 1.6860312E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T07:00:00",
                                                "endPoint": "2023-06-06T08:00:00",
                                                "aswi": 98.04143,
                                                "dqi": 94.52467,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.77035",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94446",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "20",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1163",
                                                "timestamp": 1.6860348E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T08:00:00",
                                                "endPoint": "2023-06-06T09:00:00",
                                                "aswi": 96.58952,
                                                "dqi": 91.61807,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.02084",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95001",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "18",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1793",
                                                "timestamp": 1.6860384E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T09:00:00",
                                                "endPoint": "2023-06-06T10:00:00",
                                                "aswi": 98.30865,
                                                "dqi": 95.1495,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.15913",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93057",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "25",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1023",
                                                "timestamp": 1.686042E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T10:00:00",
                                                "endPoint": "2023-06-06T11:00:00",
                                                "aswi": 98.14636,
                                                "dqi": 94.75609,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.93419",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.91947",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "29",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1104",
                                                "timestamp": 1.6860456E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T11:00:00",
                                                "endPoint": "2023-06-06T12:00:00",
                                                "aswi": 98.86904,
                                                "dqi": 96.58428,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "8.02555",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92502",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "27",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "711",
                                                "timestamp": 1.6860492E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T12:00:00",
                                                "endPoint": "2023-06-06T13:00:00",
                                                "aswi": 95.43865,
                                                "dqi": 89.83153,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.95169",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94724",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "19",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2177",
                                                "timestamp": 1.6860528E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T13:00:00",
                                                "endPoint": "2023-06-06T14:00:00",
                                                "aswi": 96.66633,
                                                "dqi": 91.74766,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.10415",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94446",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "20",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1763",
                                                "timestamp": 1.6860564E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T14:00:00",
                                                "endPoint": "2023-06-06T15:00:00",
                                                "aswi": 97.02345,
                                                "dqi": 92.38637,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.50404",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.9278",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "26",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1619",
                                                "timestamp": 1.68606E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T15:00:00",
                                                "endPoint": "2023-06-06T16:00:00",
                                                "aswi": 96.436,
                                                "dqi": 91.3774,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.85144",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.97501",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "9",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1853",
                                                "timestamp": 1.6860636E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T16:00:00",
                                                "endPoint": "2023-06-06T17:00:00",
                                                "aswi": 96.38826,
                                                "dqi": 91.24737,
                                                "frequency": "1",
                                                "dataCount": "3597",
                                                "score_frequency": "10",
                                                "score_stale": "4.82778",
                                                "score_dataGap": "9.98611",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95274",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "5",
                                                "tt_dataGap": "5",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "17",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1864",
                                                "timestamp": 1.6860672E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T17:00:00",
                                                "endPoint": "2023-06-06T18:00:00",
                                                "aswi": 98.28518,
                                                "dqi": 95.09396,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.12303",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93335",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "24",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1036",
                                                "timestamp": 1.6860708E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T18:00:00",
                                                "endPoint": "2023-06-06T19:00:00",
                                                "aswi": 96.70898,
                                                "dqi": 91.79857,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.16524",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.91391",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "31",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1741",
                                                "timestamp": 1.6860744E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T19:00:00",
                                                "endPoint": "2023-06-06T20:00:00",
                                                "aswi": 95.91621,
                                                "dqi": 90.48412,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.38491",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.90558",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "34",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2021",
                                                "timestamp": 1.686078E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T20:00:00",
                                                "endPoint": "2023-06-06T21:00:00",
                                                "aswi": 98.70356,
                                                "dqi": 96.14459,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.75896",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.9278",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "26",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "807",
                                                "timestamp": 1.6860816E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T21:00:00",
                                                "endPoint": "2023-06-06T22:00:00",
                                                "aswi": 96.39385,
                                                "dqi": 91.26169,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.83478",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.92224",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "28",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1859",
                                                "timestamp": 1.6860852E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T22:00:00",
                                                "endPoint": "2023-06-06T23:00:00",
                                                "aswi": 98.5576,
                                                "dqi": 95.76969,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.52847",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93335",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "24",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "890",
                                                "timestamp": 1.6860888E12
                                            },
                                            {
                                                "startPoint": "2023-06-06T23:00:00",
                                                "endPoint": "2023-06-07T00:00:00",
                                                "aswi": 98.37986,
                                                "dqi": 95.31612,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "7.27576",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.91391",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "31",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "981",
                                                "timestamp": 1.6860924E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T00:00:00",
                                                "endPoint": "2023-06-07T01:00:00",
                                                "aswi": 95.42592,
                                                "dqi": 89.80839,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "3.94336",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94168",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "21",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2180",
                                                "timestamp": 1.686096E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T01:00:00",
                                                "endPoint": "2023-06-07T02:00:00",
                                                "aswi": 98.13325,
                                                "dqi": 94.7422,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "6.89254",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95279",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "17",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1119",
                                                "timestamp": 1.6860996E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T02:00:00",
                                                "endPoint": "2023-06-07T03:00:00",
                                                "aswi": 96.63602,
                                                "dqi": 91.69675,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.07083",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94724",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "19",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1775",
                                                "timestamp": 1.6861032E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T03:00:00",
                                                "endPoint": "2023-06-07T04:00:00",
                                                "aswi": 84.57643,
                                                "dqi": 83.82857,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.3527",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94446",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "20",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3473",
                                                "timestamp": 1.6861068E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T04:00:00",
                                                "endPoint": "2023-06-07T05:00:00",
                                                "aswi": 93.38432,
                                                "dqi": 87.45256,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "2.56875",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.9028",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "35",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2675",
                                                "timestamp": 1.6861104E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T05:00:00",
                                                "endPoint": "2023-06-07T06:00:00",
                                                "aswi": 97.0514,
                                                "dqi": 92.4558,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.52347",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95001",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "18",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1612",
                                                "timestamp": 1.686114E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T06:00:00",
                                                "endPoint": "2023-06-07T07:00:00",
                                                "aswi": 81.41359,
                                                "dqi": 82.76397,
                                                "frequency": "1",
                                                "dataCount": "3540",
                                                "score_frequency": "10",
                                                "score_stale": "0.16944",
                                                "score_dataGap": "9.82778",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "62",
                                                "tt_dataGap": "62",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861176E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T07:00:00",
                                                "endPoint": "2023-06-07T08:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861212E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T08:00:00",
                                                "endPoint": "2023-06-07T09:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861248E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T09:00:00",
                                                "endPoint": "2023-06-07T10:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861284E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T10:00:00",
                                                "endPoint": "2023-06-07T11:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.686132E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T11:00:00",
                                                "endPoint": "2023-06-07T12:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861356E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T12:00:00",
                                                "endPoint": "2023-06-07T13:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861392E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T13:00:00",
                                                "endPoint": "2023-06-07T14:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861428E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T14:00:00",
                                                "endPoint": "2023-06-07T15:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861464E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T15:00:00",
                                                "endPoint": "2023-06-07T16:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.68615E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T16:00:00",
                                                "endPoint": "2023-06-07T17:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861536E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T17:00:00",
                                                "endPoint": "2023-06-07T18:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861572E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T18:00:00",
                                                "endPoint": "2023-06-07T19:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861608E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T19:00:00",
                                                "endPoint": "2023-06-07T20:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861644E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T20:00:00",
                                                "endPoint": "2023-06-07T21:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.686168E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T21:00:00",
                                                "endPoint": "2023-06-07T22:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861716E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T22:00:00",
                                                "endPoint": "2023-06-07T23:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861752E12
                                            },
                                            {
                                                "startPoint": "2023-06-07T23:00:00",
                                                "endPoint": "2023-06-08T00:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861788E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T00:00:00",
                                                "endPoint": "2023-06-08T01:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861824E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T01:00:00",
                                                "endPoint": "2023-06-08T02:00:00",
                                                "aswi": 76.46974,
                                                "dqi": 83.17132,
                                                "frequency": "1",
                                                "dataCount": "3584",
                                                "score_frequency": "10",
                                                "score_stale": "0.04722",
                                                "score_dataGap": "9.95",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "18",
                                                "tt_dataGap": "18",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.686186E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T02:00:00",
                                                "endPoint": "2023-06-08T03:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861896E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T03:00:00",
                                                "endPoint": "2023-06-08T04:00:00",
                                                "aswi": 90.44058,
                                                "dqi": 75.67267,
                                                "frequency": "0.99892",
                                                "dataCount": "2777",
                                                "score_frequency": "9.9892",
                                                "score_stale": "2.28055",
                                                "score_dataGap": "7.7",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "828",
                                                "tt_dataGap": "828",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861932E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T04:00:00",
                                                "endPoint": "2023-06-08T05:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6861968E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T05:00:00",
                                                "endPoint": "2023-06-08T06:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6862004E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T06:00:00",
                                                "endPoint": "2023-06-08T07:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.686204E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T07:00:00",
                                                "endPoint": "2023-06-08T08:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6862076E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T08:00:00",
                                                "endPoint": "2023-06-08T09:00:00",
                                                "aswi": 65.56721,
                                                "dqi": 80.65829,
                                                "frequency": "1.00033",
                                                "dataCount": "3022",
                                                "score_frequency": "10",
                                                "score_stale": "0.0033",
                                                "score_dataGap": "8.08342",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "579",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6862112E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T09:00:00",
                                                "endPoint": "2023-06-08T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862148E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T10:00:00",
                                                "endPoint": "2023-06-08T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862184E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T11:00:00",
                                                "endPoint": "2023-06-08T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686222E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T12:00:00",
                                                "endPoint": "2023-06-08T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862256E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T13:00:00",
                                                "endPoint": "2023-06-08T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862292E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T14:00:00",
                                                "endPoint": "2023-06-08T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862328E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T15:00:00",
                                                "endPoint": "2023-06-08T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862364E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T16:00:00",
                                                "endPoint": "2023-06-08T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68624E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T17:00:00",
                                                "endPoint": "2023-06-08T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862436E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T18:00:00",
                                                "endPoint": "2023-06-08T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862472E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T19:00:00",
                                                "endPoint": "2023-06-08T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862508E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T20:00:00",
                                                "endPoint": "2023-06-08T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862544E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T21:00:00",
                                                "endPoint": "2023-06-08T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686258E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T22:00:00",
                                                "endPoint": "2023-06-08T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862616E12
                                            },
                                            {
                                                "startPoint": "2023-06-08T23:00:00",
                                                "endPoint": "2023-06-09T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862652E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T00:00:00",
                                                "endPoint": "2023-06-09T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862688E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T01:00:00",
                                                "endPoint": "2023-06-09T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862724E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T02:00:00",
                                                "endPoint": "2023-06-09T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686276E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T03:00:00",
                                                "endPoint": "2023-06-09T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862796E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T04:00:00",
                                                "endPoint": "2023-06-09T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862832E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T05:00:00",
                                                "endPoint": "2023-06-09T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862868E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T06:00:00",
                                                "endPoint": "2023-06-09T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862904E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T07:00:00",
                                                "endPoint": "2023-06-09T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686294E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T08:00:00",
                                                "endPoint": "2023-06-09T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6862976E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T09:00:00",
                                                "endPoint": "2023-06-09T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863012E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T10:00:00",
                                                "endPoint": "2023-06-09T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863048E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T11:00:00",
                                                "endPoint": "2023-06-09T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863084E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T12:00:00",
                                                "endPoint": "2023-06-09T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686312E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T13:00:00",
                                                "endPoint": "2023-06-09T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863156E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T14:00:00",
                                                "endPoint": "2023-06-09T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863192E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T15:00:00",
                                                "endPoint": "2023-06-09T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863228E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T16:00:00",
                                                "endPoint": "2023-06-09T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863264E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T17:00:00",
                                                "endPoint": "2023-06-09T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68633E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T18:00:00",
                                                "endPoint": "2023-06-09T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863336E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T19:00:00",
                                                "endPoint": "2023-06-09T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863372E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T20:00:00",
                                                "endPoint": "2023-06-09T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863408E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T21:00:00",
                                                "endPoint": "2023-06-09T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863444E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T22:00:00",
                                                "endPoint": "2023-06-09T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686348E12
                                            },
                                            {
                                                "startPoint": "2023-06-09T23:00:00",
                                                "endPoint": "2023-06-10T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863516E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T00:00:00",
                                                "endPoint": "2023-06-10T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863552E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T01:00:00",
                                                "endPoint": "2023-06-10T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863588E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T02:00:00",
                                                "endPoint": "2023-06-10T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863624E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T03:00:00",
                                                "endPoint": "2023-06-10T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686366E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T04:00:00",
                                                "endPoint": "2023-06-10T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863696E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T05:00:00",
                                                "endPoint": "2023-06-10T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863732E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T06:00:00",
                                                "endPoint": "2023-06-10T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863768E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T07:00:00",
                                                "endPoint": "2023-06-10T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863804E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T08:00:00",
                                                "endPoint": "2023-06-10T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686384E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T09:00:00",
                                                "endPoint": "2023-06-10T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863876E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T10:00:00",
                                                "endPoint": "2023-06-10T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863912E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T11:00:00",
                                                "endPoint": "2023-06-10T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863948E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T12:00:00",
                                                "endPoint": "2023-06-10T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6863984E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T13:00:00",
                                                "endPoint": "2023-06-10T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686402E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T14:00:00",
                                                "endPoint": "2023-06-10T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864056E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T15:00:00",
                                                "endPoint": "2023-06-10T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864092E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T16:00:00",
                                                "endPoint": "2023-06-10T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864128E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T17:00:00",
                                                "endPoint": "2023-06-10T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864164E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T18:00:00",
                                                "endPoint": "2023-06-10T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68642E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T19:00:00",
                                                "endPoint": "2023-06-10T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864236E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T20:00:00",
                                                "endPoint": "2023-06-10T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864272E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T21:00:00",
                                                "endPoint": "2023-06-10T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864308E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T22:00:00",
                                                "endPoint": "2023-06-10T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864344E12
                                            },
                                            {
                                                "startPoint": "2023-06-10T23:00:00",
                                                "endPoint": "2023-06-11T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686438E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T00:00:00",
                                                "endPoint": "2023-06-11T01:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864416E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T01:00:00",
                                                "endPoint": "2023-06-11T02:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864452E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T02:00:00",
                                                "endPoint": "2023-06-11T03:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864488E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T03:00:00",
                                                "endPoint": "2023-06-11T04:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864524E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T04:00:00",
                                                "endPoint": "2023-06-11T05:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686456E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T05:00:00",
                                                "endPoint": "2023-06-11T06:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864596E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T06:00:00",
                                                "endPoint": "2023-06-11T07:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864632E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T07:00:00",
                                                "endPoint": "2023-06-11T08:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864668E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T08:00:00",
                                                "endPoint": "2023-06-11T09:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864704E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T09:00:00",
                                                "endPoint": "2023-06-11T10:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686474E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T10:00:00",
                                                "endPoint": "2023-06-11T11:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864776E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T11:00:00",
                                                "endPoint": "2023-06-11T12:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864812E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T12:00:00",
                                                "endPoint": "2023-06-11T13:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864848E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T13:00:00",
                                                "endPoint": "2023-06-11T14:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864884E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T14:00:00",
                                                "endPoint": "2023-06-11T15:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.686492E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T15:00:00",
                                                "endPoint": "2023-06-11T16:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864956E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T16:00:00",
                                                "endPoint": "2023-06-11T17:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6864992E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T17:00:00",
                                                "endPoint": "2023-06-11T18:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865028E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T18:00:00",
                                                "endPoint": "2023-06-11T19:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865064E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T19:00:00",
                                                "endPoint": "2023-06-11T20:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.68651E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T20:00:00",
                                                "endPoint": "2023-06-11T21:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865136E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T21:00:00",
                                                "endPoint": "2023-06-11T22:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865172E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T22:00:00",
                                                "endPoint": "2023-06-11T23:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865208E12
                                            },
                                            {
                                                "startPoint": "2023-06-11T23:00:00",
                                                "endPoint": "2023-06-12T00:00:00",
                                                "aswi": 1.0,
                                                "dqi": 0.0,
                                                "frequency": "0",
                                                "dataCount": "0",
                                                "score_frequency": "1",
                                                "score_stale": "1",
                                                "score_dataGap": "1",
                                                "score_maxValue": "1",
                                                "score_minValue": "1",
                                                "score_precision": "1",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "3600",
                                                "tt_dataGap": "3600",
                                                "tt_maxValue": "3600",
                                                "tt_minValue": "3600",
                                                "tt_precision": "3600",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3600",
                                                "timestamp": 1.6865244E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T00:00:00",
                                                "endPoint": "2023-06-12T01:00:00",
                                                "aswi": 56.54103,
                                                "dqi": 75.01851,
                                                "frequency": "1.00056",
                                                "dataCount": "1801",
                                                "score_frequency": "10",
                                                "score_stale": "0.01115",
                                                "score_dataGap": "1",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "1800",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3596",
                                                "timestamp": 1.686528E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T01:00:00",
                                                "endPoint": "2023-06-12T02:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865316E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T02:00:00",
                                                "endPoint": "2023-06-12T03:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865352E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T03:00:00",
                                                "endPoint": "2023-06-12T04:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865388E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T04:00:00",
                                                "endPoint": "2023-06-12T05:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865424E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T05:00:00",
                                                "endPoint": "2023-06-12T06:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.686546E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T06:00:00",
                                                "endPoint": "2023-06-12T07:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865496E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T07:00:00",
                                                "endPoint": "2023-06-12T08:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865532E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T08:00:00",
                                                "endPoint": "2023-06-12T09:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865568E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T09:00:00",
                                                "endPoint": "2023-06-12T10:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865604E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T10:00:00",
                                                "endPoint": "2023-06-12T11:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.686564E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T11:00:00",
                                                "endPoint": "2023-06-12T12:00:00",
                                                "aswi": 66.42903,
                                                "dqi": 83.33796,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.0028",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "10",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "0",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3599",
                                                "timestamp": 1.6865676E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T12:00:00",
                                                "endPoint": "2023-06-12T13:00:00",
                                                "aswi": 86.62737,
                                                "dqi": 84.27289,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "0.56653",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.99722",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "1",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "3396",
                                                "timestamp": 1.6865712E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T13:00:00",
                                                "endPoint": "2023-06-12T14:00:00",
                                                "aswi": 96.75114,
                                                "dqi": 91.9004,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.19301",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94724",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "19",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1731",
                                                "timestamp": 1.6865748E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T14:00:00",
                                                "endPoint": "2023-06-12T15:00:00",
                                                "aswi": 93.73999,
                                                "dqi": 87.82746,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "2.76314",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93335",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "24",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "2605",
                                                "timestamp": 1.6865784E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T15:00:00",
                                                "endPoint": "2023-06-12T16:00:00",
                                                "aswi": 97.09318,
                                                "dqi": 92.52522,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "5.57902",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.93613",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "23",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1592",
                                                "timestamp": 1.686582E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T16:00:00",
                                                "endPoint": "2023-06-12T17:00:00",
                                                "aswi": 96.10046,
                                                "dqi": 90.81274,
                                                "frequency": "1.00028",
                                                "dataCount": "3601",
                                                "score_frequency": "10",
                                                "score_stale": "4.53486",
                                                "score_dataGap": "10",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.95279",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "0",
                                                "tt_dataGap": "0",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "17",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1967",
                                                "timestamp": 1.6865856E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T17:00:00",
                                                "endPoint": "2023-06-12T18:00:00",
                                                "aswi": 97.11825,
                                                "dqi": 91.99868,
                                                "frequency": "1",
                                                "dataCount": "3553",
                                                "score_frequency": "10",
                                                "score_stale": "6.03611",
                                                "score_dataGap": "9.86389",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.48776",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "49",
                                                "tt_dataGap": "49",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "184",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1446",
                                                "timestamp": 1.6865892E12
                                            },
                                            {
                                                "startPoint": "2023-06-12T18:00:00",
                                                "endPoint": "2023-06-12T19:00:00",
                                                "aswi": 97.37408,
                                                "dqi": 92.01728,
                                                "frequency": "0.9997",
                                                "dataCount": "3375",
                                                "score_frequency": "9.997",
                                                "score_stale": "6.74625",
                                                "score_dataGap": "9.36667",
                                                "score_maxValue": "10",
                                                "score_minValue": "10",
                                                "score_precision": "9.94667",
                                                "score_latency": "NOT CALCULATING",
                                                "tt_frequency": "228",
                                                "tt_dataGap": "228",
                                                "tt_maxValue": "0",
                                                "tt_minValue": "0",
                                                "tt_precision": "19",
                                                "tt_latency": "NOT CALCULATING",
                                                "tt_stale": "1249",
                                                "timestamp": 1.6865928E12
                                            }
                                        ]
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    }

export const dataQualityLoading = true

export const rigWellData = {
    "Akshay_test1": [
        "Akshay_well1"
    ],
    "Patterson_814": [
        "CMC_BUTTERCUP_25-37_E_0335LS"
    ],
    "DEMO_RIG": [
        "DEMO_CSV",
        "DEMO_WELL"
    ],
    "AG_RIG1": [
        "DEMO_W_2",
        "NEW_WB"
    ],
    "DQ": [
        "DQ2",
        "DQDQ"
    ],
    "DQAdvance": [
        "DQAdvance"
    ],
    "Test_Rig_K": [
        "Test_Well_K"
    ]
} 
export const activeDevices = {
    "Test_Rig_K": [
        {
            "name": "TEST_K",
            "rig_name": "Test_Rig_K",
            "well_id": "Test_Well_K",
            "log_id": "Test_WellBore_K",
            "feed_id": 26,
            "feed_type": "CSV",
            "device_type": "TIMESERIES",
            "monitoring_threshold": 60,
            "dead_channel_threshold": 900,
            "monitoring_state": true
        }
    ]
}

export const thresholdColorsDqi = {
    "thresholdColors": [
        {
          "maxthresholdValue": "20",
          "backgroundColor": "#ffc7ce",
          "color": "#9c0006",
        },
        {
          "maxthresholdValue": "50",
          "backgroundColor": "#fff2ce",
          "color": "black",
        },
        {
          "maxthresholdValue": "70",
          "backgroundColor": "#ffeb9c",
          "color": "#9c5700",
        },
        {
          "maxthresholdValue": "90",
          "backgroundColor": "#c6efce",
          "color": "#006100",
        }
      ]  
}

export const configData = {
    "log": "Ashish_Depth_Log",
    "rig": "Ashish",
    "well": "Ashish",
    "bunit": "GOMBU",
    "rules": [
      {
        "uom": "%%",
        "name": "GAMMA RAY DEPTH",
        "bunit": "GOMBU",
        "status": "enable",
        "aspects": [
          {
            "name": "frequency",
            "status": "enable",
            "isEnable": true,
            "aspectType": "Number",
            "expectedValue": 1,
            "deltaValue": 10,
            "weightage": 10,
            "ttThreshold": 20000
          },
          {
            "name": "precision",
            "status": "enable",
            "isEnable": true,
            "aspectType": "Number",
            "expectedValue": 2,
            "weightage": 10,
            "ttThreshold": 100000
          },
          {
            "name": "dataGap",
            "status": "enable",
            "isEnable": true,
            "aspectType": "Number",
            "expectedValue": 10000,
            "weightage": 10
          },
          {
            "name": "dataCount",
            "status": "enable",
            "isEnable": true,
            "aspectType": "Number",
            "expectedValue": 36000,
            "deltaValue": 60,
            "weightage": 30,
            "ttThreshold": 30000
          },
          {
            "name": "latency",
            "status": "enable",
            "isEnable": true,
            "aspectType": "Number",
            "expectedValue": 3000,
            "deltaValue": 60,
            "weightage": 10,
            "ttThreshold": 30000
          },
          {
            "name": "minValue",
            "status": "enable",
            "isEnable": true,
            "aspectType": "Number",
            "expectedValue": 10,
            "deltaValue": 2,
            "weightage": 10,
            "ttThreshold": 30000
          },
          {
            "name": "maxValue",
            "status": "enable",
            "isEnable": true,
            "aspectType": "Number",
            "expectedValue": 30000,
            "weightage": 10,
            "ttThreshold": 30000
          },
          {
            "name": "staleValue",
            "status": "enable",
            "isEnable": true,
            "aspectType": "Number",
            "weightage": 10,
            "ttThreshold": 30000
          }
        ],
        "version": "v1",
        "datatype": "F",
        "dataProvider": "Data Provider1",
        "notifications": {
          "isDQINotificationEnable": false,
          "DQINotificationThresholdLimit": 0,
          "DQINotificationsPriority": "Medium"
        }
      }
    ],
    "UidLog": "Ashish_Depth_Log",
    "UidWell": "undefined",
    "logType": "DEPTHSERIES",
    "slideBy": 0,
    "version": "v3",
    "nameWell": "Ashish",
    "wellbore": "Ashish",
    "isRunning": false,
    "UidWellbore": "undefined",
    "dataProvider": "Data Provider1",
    "nameWellbore": "Ashish",
    "syncEndPoint": {
      "isSecure": "false",
      "port": 8095,
      "host": "192.168.2.208",
      "clientId": "RigAdmin",
      "apiKey": "8476509c72164674802e5471f3591435",
      "type": "YH"
    },
    "templateName": "Ashish_Depth_Log_T1",
    "windowLength": 2000,
    "sourceEndPoint": {
      "isSecure": "false",
      "port": 8095,
      "host": "192.168.2.208",
      "clientId": "RigAdmin",
      "apiKey": "8476509c72164674802e5471f3591435",
      "type": "YH"
    }
  }

export const auditValue = {
    "Message": [
        {
            "timestamp": 1709734609554,
            "entityType": "templateManager",
            "entityName": "TemplateManagerDAO -updateTemplateSync",
            "username": "",
            "action": "update",
            "description": "Correct data not stored.",
            "id": 107,
            "entityID": 107,
            "actionType": "system"
        },
        {
            "timestamp": 1709734609554,
            "entityType": "templateManager",
            "entityName": "TemplateManagerDAO -updateTemplateSync",
            "username": "",
            "action": "update",
            "description": "Correct data not stored.",
            "id": 108,
            "entityID": 107,
            "actionType": "system"
        }
    ]
}

export const dqi_params =
{
   
            "Result": "OK",
            "data": {
                "businessUnit": [
                    {
                        "name": "RBU",
                        "rigs": [
                            {
                                "name": "HP-517",
                                "wells": [
                                    {
                                        "name": "ARISTOCRAT_H14-756",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "ARISTOCRAT_H14-765",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "ARISTOCRAT_H14-775",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "ARISTOCRAT_H14-785",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-782",
                                        "logs": [],
                                        "wellDQIPercentage": "0.00"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-773",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-763",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-754",
                                        "logs": [
                                            {
                                                "name": "Baker - MWD",
                                                "indexType": "DEPTHSERIES",
                                                "startIndex": "8866.499",
                                                "endIndex": "17466.499",
                                                "windowLength": "200",
                                                "dataProvider": "Baker Hughes",
                                                "logDQIPercentage": "56.9"
                                            }
                                        ],
                                        "start_index": "1714004501295",
                                        "end_index": "1714118910424",
                                        "wellDQIPercentage": "56.9"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-744",
                                        "logs": [
                                            {
                                                "name": "Baker - MWD",
                                                "indexType": "DEPTHSERIES",
                                                "startIndex": "2184.501",
                                                "endIndex": "17384.501",
                                                "windowLength": "200",
                                                "dataProvider": "Baker Hughes",
                                                "logDQIPercentage": "57.18"
                                            }
                                        ],
                                        "start_index": "1714266171141",
                                        "end_index": "1714411841248",
                                        "wellDQIPercentage": "57.18"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-734",
                                        "logs": [
                                            {
                                                "name": "Baker - MWD",
                                                "indexType": "DEPTHSERIES",
                                                "startIndex": "-999.25",
                                                "endIndex": "9400.75",
                                                "windowLength": "200",
                                                "dataProvider": "Baker Hughes",
                                                "logDQIPercentage": "26.58"
                                            }
                                        ],
                                        "start_index": "1714524753244",
                                        "end_index": "1714607387823",
                                        "wellDQIPercentage": "26.58"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "name": "MCBU",
                        "rigs": [
                            {
                                "name": "HP-517",
                                "wells": [
                                    {
                                        "name": "MILL_IRON_STATE_CC18-765",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "MILL_IRON_STATE_CC18-754",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "MILL_IRON_STATE_CC18-743",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "MILL_IRON_STATE_CC18-733",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "ARISTOCRAT_H14-775",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "ARISTOCRAT_H14-765",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "ARISTOCRAT_H14-756",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "ARISTOCRAT_H14-785",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-715",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-725",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-734",
                                        "logs": [
                                            {
                                                "name": "Pason_Time based_MCBU",
                                                "indexType": "TIMESERIES",
                                                "startIndex": "1714003200000",
                                                "endIndex": "1714608000000",
                                                "windowLength": "3600000",
                                                "dataProvider": "Pason",
                                                "logDQIPercentage": "7.86"
                                            }
                                        ],
                                        "start_index": "1714003200000",
                                        "end_index": "1714608000000",
                                        "wellDQIPercentage": "7.86"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-744",
                                        "logs": [
                                            {
                                                "name": "Pason_Time based_MCBU",
                                                "indexType": "TIMESERIES",
                                                "startIndex": "1714006260000",
                                                "endIndex": "1714507200000",
                                                "windowLength": "3600000",
                                                "dataProvider": "Pason",
                                                "logDQIPercentage": "13.29"
                                            }
                                        ],
                                        "start_index": "1714006260000",
                                        "end_index": "1714507200000",
                                        "wellDQIPercentage": "13.29"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-754",
                                        "logs": [
                                            {
                                                "name": "Pason_Time based_MCBU",
                                                "indexType": "TIMESERIES",
                                                "startIndex": "1714005903000",
                                                "endIndex": "1714225503000",
                                                "windowLength": "3600000",
                                                "dataProvider": "Pason",
                                                "logDQIPercentage": "27.32"
                                            }
                                        ],
                                        "start_index": "1714005903000",
                                        "end_index": "1714225503000",
                                        "wellDQIPercentage": "27.32"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-763",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-773",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "GUTTERSEN_Y12-782",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    },
                                    {
                                        "name": "MILL_IRON_STATE_CC18-775",
                                        "logs": [],
                                        "wellDQIPercentage": "0"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
     
   
    "customJs": [],
    "customCss": [],
    "hasfileContent": false
}

export const getSyncData = {
    "Result": "OK",
    "data": [
        {
            "apiKey": "123",
            "clientId": "789",
            "dataProvider": "SigmaStream (Pason)",
            "endPointType": "YellowHammer",
            "host": "123",
            "isSecure": "True",
            "port": "5632",
            "rig": "Patterson 814",
            "well": "CMC_Camden-Fenway_F_0355LS",
            "progressBar": "20%",
            "totalRecords": "15",
            "id":'1'
        },
        {
            "apiKey": "12453",
            "clientId": "78679",
            "dataProvider": "NOV",
            "endPointType": "YellowHammer",
            "host": "123.123",
            "isSecure": "False",
            "port": "565532",
            "rig": "AV_CLUSTER",
            "well": "av_cluster",
            "progressBar": "40%",
            "totalRecords": "25",
            "id":'2'
        },
        {
            "dataProvider": "SigmaStream",
            "dateFormat": "YYYY-MM-DDTHH:mm:ss",
            "endPointType": "WITSML",
            "password": "test",
            "rig": "Test_Rig_5_7",
            "url": "http://192.168.3.35",
            "userName": "test",
            "version": "1.3.1.1",
            "well": "Test_Well_5_7",
            "progressBar": "90%",
            "totalRecords": "75",
            "id":'3'
        }
    ],
    "totalRecord": 3
};


//   const dqi_params =
// {
   
//             "Result": "OK",
//             "data": {
//                 "businessUnit": [
//                     {
//                         "name": "RBU",
//                         "rigs": [
//                             {
//                                 "name": "HP-517",
//                                 "wells": [
//                                     {
//                                         "name": "ARISTOCRAT_H14-756",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "ARISTOCRAT_H14-765",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "ARISTOCRAT_H14-775",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "ARISTOCRAT_H14-785",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-782",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0.00"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-773",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-763",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-754",
//                                         "logs": [
//                                             {
//                                                 "name": "Baker - MWD",
//                                                 "indexType": "DEPTHSERIES",
//                                                 "startIndex": "8866.499",
//                                                 "endIndex": "17466.499",
//                                                 "windowLength": "200",
//                                                 "dataProvider": "Baker Hughes",
//                                                 "logDQIPercentage": "56.9"
//                                             }
//                                         ],
//                                         "start_index": "1714004501295",
//                                         "end_index": "1714118910424",
//                                         "wellDQIPercentage": "56.9"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-744",
//                                         "logs": [
//                                             {
//                                                 "name": "Baker - MWD",
//                                                 "indexType": "DEPTHSERIES",
//                                                 "startIndex": "2184.501",
//                                                 "endIndex": "17384.501",
//                                                 "windowLength": "200",
//                                                 "dataProvider": "Baker Hughes",
//                                                 "logDQIPercentage": "57.18"
//                                             }
//                                         ],
//                                         "start_index": "1714266171141",
//                                         "end_index": "1714411841248",
//                                         "wellDQIPercentage": "57.18"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-734",
//                                         "logs": [
//                                             {
//                                                 "name": "Baker - MWD",
//                                                 "indexType": "DEPTHSERIES",
//                                                 "startIndex": "-999.25",
//                                                 "endIndex": "9400.75",
//                                                 "windowLength": "200",
//                                                 "dataProvider": "Baker Hughes",
//                                                 "logDQIPercentage": "26.58"
//                                             }
//                                         ],
//                                         "start_index": "1714524753244",
//                                         "end_index": "1714607387823",
//                                         "wellDQIPercentage": "26.58"
//                                     }
//                                 ]
//                             }
//                         ]
//                     },
//                     {
//                         "name": "MCBU",
//                         "rigs": [
//                             {
//                                 "name": "HP-517",
//                                 "wells": [
//                                     {
//                                         "name": "MILL_IRON_STATE_CC18-765",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "MILL_IRON_STATE_CC18-754",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "MILL_IRON_STATE_CC18-743",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "MILL_IRON_STATE_CC18-733",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "ARISTOCRAT_H14-775",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "ARISTOCRAT_H14-765",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "ARISTOCRAT_H14-756",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "ARISTOCRAT_H14-785",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-715",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-725",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-734",
//                                         "logs": [
//                                             {
//                                                 "name": "Pason_Time based_MCBU",
//                                                 "indexType": "TIMESERIES",
//                                                 "startIndex": "1714003200000",
//                                                 "endIndex": "1714608000000",
//                                                 "windowLength": "3600000",
//                                                 "dataProvider": "Pason",
//                                                 "logDQIPercentage": "7.86"
//                                             }
//                                         ],
//                                         "start_index": "1714003200000",
//                                         "end_index": "1714608000000",
//                                         "wellDQIPercentage": "7.86"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-744",
//                                         "logs": [
//                                             {
//                                                 "name": "Pason_Time based_MCBU",
//                                                 "indexType": "TIMESERIES",
//                                                 "startIndex": "1714006260000",
//                                                 "endIndex": "1714507200000",
//                                                 "windowLength": "3600000",
//                                                 "dataProvider": "Pason",
//                                                 "logDQIPercentage": "13.29"
//                                             }
//                                         ],
//                                         "start_index": "1714006260000",
//                                         "end_index": "1714507200000",
//                                         "wellDQIPercentage": "13.29"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-754",
//                                         "logs": [
//                                             {
//                                                 "name": "Pason_Time based_MCBU",
//                                                 "indexType": "TIMESERIES",
//                                                 "startIndex": "1714005903000",
//                                                 "endIndex": "1714225503000",
//                                                 "windowLength": "3600000",
//                                                 "dataProvider": "Pason",
//                                                 "logDQIPercentage": "27.32"
//                                             }
//                                         ],
//                                         "start_index": "1714005903000",
//                                         "end_index": "1714225503000",
//                                         "wellDQIPercentage": "27.32"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-763",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-773",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "GUTTERSEN_Y12-782",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     },
//                                     {
//                                         "name": "MILL_IRON_STATE_CC18-775",
//                                         "logs": [],
//                                         "wellDQIPercentage": "0"
//                                     }
//                                 ]
//                             }
//                         ]
//                     }
//                 ]
//             },
     
   
//     "customJs": [],
//     "customCss": [],
//     "hasfileContent": false
// }

